(function () {
  "use strict";

  var isUpdatingPrice = false;
  var isUpdatingDiscount = false;
  var cartRefreshTimeout = null;
  var isCartPage = false;
  var isProductPage = false;

  function hasUserRemovedDiscountGlobal() {
    try {
      return localStorage.getItem("userRemovedDiscountGlobal") === "true";
    } catch (e) {
      return false;
    }
  }

  function setUserRemovedDiscountGlobal() {
    try {
      localStorage.setItem("userRemovedDiscountGlobal", "true");
    } catch (e) {
      console.error("[DISCOUNT] Error setting userRemovedDiscountGlobal:", e);
    }
  }

  function clearUserRemovedDiscountGlobal() {
    try {
      localStorage.removeItem("userRemovedDiscountGlobal");
    } catch (e) {
      console.error("[DISCOUNT] Error clearing userRemovedDiscountGlobal:", e);
    }
  }

  function initPageFlags() {
    isCartPage = window.isThisCartPage();
    isProductPage = window.isProductPage === true;
  }

  function updatePriceDataAttributes(variant) {
    if (!isProductPage) {
      return;
    }
    console.log("product-discount-price.js: updatePriceDataAttributes");
    var priceContainer = window.getPriceContainer();
    if (!priceContainer) {
      console.error("[updatePriceDataAttributes] No price container found");
      return;
    }
    try {
      if (variant && variant.price) {
        priceContainer.setAttribute("data-variant-price", variant.price);
        priceContainer.setAttribute(
          "data-compare-at-price",
          variant.compare_at_price || variant.price
        );
        return;
      }

      var variantFromOptions = window.getVariantFromSelectedOptions();
      if (variantFromOptions && variantFromOptions.price) {
        priceContainer.setAttribute(
          "data-variant-price",
          variantFromOptions.price
        );
        priceContainer.setAttribute(
          "data-compare-at-price",
          variantFromOptions.compare_at_price || variantFromOptions.price
        );
        return;
      }

      var variantSelects = document.querySelector(".product-form__variants");
      if (variantSelects) {
        var productForm =
          variantSelects.closest("form") ||
          variantSelects.closest("[data-product-json]")?.parentElement;
        if (
          productForm &&
          productForm.productVariants &&
          productForm.productVariants.currentVariant
        ) {
          var currentVariant = productForm.productVariants.currentVariant;
          if (currentVariant) {
            priceContainer.setAttribute(
              "data-variant-price",
              currentVariant.price
            );
            priceContainer.setAttribute(
              "data-compare-at-price",
              currentVariant.compare_at_price || currentVariant.price
            );
            return;
          }
        } else {
          console.error(
            "[updatePriceDataAttributes] Could not access ProductVariants instance"
          );
        }
      } else {
        console.error(
          "[updatePriceDataAttributes] .product-form__variants element not found"
        );
      }
      var productJson = document.querySelector(
        '[type="application/json"][data-product-json]'
      )?.textContent;
      if (productJson) {
        var productData = JSON.parse(productJson);

        var variants = productData.product?.variants || productData.variants;
        if (!variants || !Array.isArray(variants)) {
          console.error(
            "[updatePriceDataAttributes] No variants found in product data",
            productData
          );
        }
        var variantIdInput = document.querySelector('[name="id"]');
        var variantId = variantIdInput ? variantIdInput.value : null;
        var selectedVariant = null;
        if (variantId && variants) {
          selectedVariant = variants.find(function (v) {
            return String(v.id) === String(variantId);
          });
        }
        if (!selectedVariant && variants) {
          console.error(
            "[updatePriceDataAttributes] Variant not found by ID, trying fallback"
          );
          selectedVariant =
            variants.find(function (v) {
              return v.available;
            }) || variants[0];
        }
        if (selectedVariant) {
          priceContainer.setAttribute(
            "data-variant-price",
            selectedVariant.price
          );
          priceContainer.setAttribute(
            "data-compare-at-price",
            selectedVariant.compare_at_price || selectedVariant.price
          );
        } else {
          console.error(
            "[updatePriceDataAttributes] No variant found in product data"
          );
        }
      } else {
        console.error("[updatePriceDataAttributes] Product JSON not found");
      }
    } catch (e) {
      console.error(
        "[updatePriceDataAttributes] Error updating price data attributes:",
        e
      );
    }
  }

  function updatePrice(discount, originalPrice) {
    console.log("product-discount-price.js: updatePrice");
    if (isUpdatingPrice) {
      console.warn("[updatePrice] Already updating price. Exiting early.");
      return null;
    }
    isUpdatingPrice = true;
    var priceContainer = window.getPriceContainer();
    if (!priceContainer) {
      console.error("[updatePrice] No priceContainer found!");
      isUpdatingPrice = false;
      return null;
    }

    var variantPrice = parseInt(
      priceContainer.getAttribute("data-variant-price") || originalPrice
    );

    if (!discount || !variantPrice) {
      console.warn("[updatePrice] No discount or invalid variantPrice.", {
        discount,
        variantPrice,
      });
      var currencyCodeEnabled =
        window.currencyCodeEnabled !== undefined
          ? window.currencyCodeEnabled
          : true;
      var formattedPrice = window.formatMoney(
        variantPrice,
        currencyCodeEnabled
      );
      var amountElements = priceContainer.querySelectorAll(".price .amount");
      var priceEl =
        amountElements.length > 0
          ? amountElements[amountElements.length - 1]
          : null;

      if (priceEl) {
        priceEl.textContent = formattedPrice;
      } else {
        var fallbackPriceEl = priceContainer.querySelector(
          ".price .amount:not(.price--compare .amount)"
        );
        if (fallbackPriceEl && !fallbackPriceEl.closest(".price--compare")) {
          fallbackPriceEl.textContent = formattedPrice;
        }
      }
      var comparePriceEl = priceContainer.querySelector(".price--compare");
      if (comparePriceEl) {
        comparePriceEl.style.display = "none";
        comparePriceEl.remove();
      }

      var parentContainer = priceContainer.parentElement;
      var savingsEl = parentContainer
        ? parentContainer.querySelector(".product-form-saving-price")
        : document.querySelector(".product-form-saving-price");
      if (savingsEl) {
        savingsEl.style.display = "none";
      }
      isUpdatingPrice = false;
      return null;
    }

    var finalPrice = variantPrice;
    var savings = 0;
    var discountAmount = 0;
    if (discount.percentage && discount.percentage > 0) {
      discountAmount = Math.round(variantPrice * (discount.percentage / 100));
      finalPrice = variantPrice - discountAmount;
      savings = discountAmount;
    } else {
      finalPrice = variantPrice;
      savings = 0;
    }

    var currencyCodeEnabled =
      window.currencyCodeEnabled !== undefined
        ? window.currencyCodeEnabled
        : true;

    var formattedPrice = window.formatMoney(finalPrice, currencyCodeEnabled);
    var formattedSavings = window.formatMoney(savings, currencyCodeEnabled);
    var formattedDiscountAmount = window.formatMoney(
      discountAmount,
      currencyCodeEnabled
    );

    var priceInsEl = priceContainer.querySelector(".price-list .price");
    if (priceInsEl) {
      priceInsEl.textContent = formattedPrice;
    } else {
      var priceEl = priceContainer.querySelector(".price");
      if (priceEl && !priceEl.closest(".price--compare")) {
        priceEl.textContent = formattedPrice;
      }
    }
    var comparePriceEl = priceContainer.querySelector(".price--compare");
    if (comparePriceEl) {
      comparePriceEl.style.display = "none";
      comparePriceEl.remove();
    }

    var parentContainer = priceContainer.parentElement;
    var savingsEl = parentContainer
      ? parentContainer.querySelector(".product-form-saving-price")
      : document.querySelector(".product-form-saving-price");

    if (savingsEl) {
      let formattedSavingsText =
        'Spare: <span class="product-savings-amount">' +
        formattedSavings +
        "</span>";

      savingsEl.innerHTML = formattedSavingsText;
      savingsEl.style.display = savings > 0 ? "block" : "none";
    } else {
      console.error("updatePrice: No savingsEl found.");
    }
    isUpdatingPrice = false;
    return {
      discountedPrice: finalPrice,
      savings: savings,
      discountAmount: discountAmount,
      formattedPrice: formattedPrice,
      formattedSavings: formattedSavings,
      formattedDiscountAmount: formattedDiscountAmount,
    };
  }

  function updateAppliedDiscount(discount, priceUpdate, retries) {
    console.log("product-discount-price.js: updateAppliedDiscount");
    retries = retries || 0;
    if (isUpdatingDiscount && retries === 0) return;
    isUpdatingDiscount = true;
    var appliedDiscountEl = document.getElementById("applied-discount");
    if (!appliedDiscountEl) {
      if (retries < 2) {
        isUpdatingDiscount = false;
        setTimeout(function () {
          updateAppliedDiscount(discount, priceUpdate, retries + 1);
        }, 100);
        return;
      }
      isUpdatingDiscount = false;
      return;
    }
    var appliedDiscountTextEl = document.getElementById(
      "applied-discount-text"
    );
    if (!appliedDiscountTextEl) {
      if (retries < 2) {
        isUpdatingDiscount = false;
        setTimeout(function () {
          updateAppliedDiscount(discount, priceUpdate, retries + 1);
        }, 100);
        return;
      }
      isUpdatingDiscount = false;
      return;
    }
    if (
      !discount ||
      !priceUpdate ||
      !priceUpdate.discountAmount ||
      priceUpdate.discountAmount <= 0
    ) {
      appliedDiscountEl.style.display = "none";
      isUpdatingDiscount = false;
      return;
    }
    var discountTitle = (discount.title || "").trim();
    var codeLabel = window.discountCodeLabel || "Code:";
    var activeText = window.discountActiveText || "Active";
    var newContent = codeLabel + " " + discountTitle + " - " + activeText;

    appliedDiscountTextEl.textContent = newContent;
    appliedDiscountEl.style.display = "flex";

    if (appliedDiscountTextEl.textContent !== newContent && retries < 2) {
      isUpdatingDiscount = false;
      setTimeout(function () {
        updateAppliedDiscount(discount, priceUpdate, retries + 1);
      }, 100);
      return;
    }
    isUpdatingDiscount = false;
  }

  function handleDiscountButtonClick(discountTitle, buttonElement, event) {
    console.log("product-discount-price.js: handleDiscountButtonClick");
    try {
      if (!buttonElement) {
        return false;
      }

      if (event) {
        event.preventDefault();
        event.stopPropagation();
      }

      document.querySelectorAll(".discount-button").forEach(function (btn) {
        btn.classList.remove("active");
      });
      buttonElement.classList.add("active");

      var discountsWrapper = document.querySelector(
        "[data-product-discounts-wrapper]"
      );
      if (!discountsWrapper) {
        return false;
      }
      var discountsScript = discountsWrapper.querySelector(
        'script[type="application/json"]'
      );
      if (!discountsScript) {
        return false;
      }
      var discountsData = discountsScript.textContent.trim();
      if (!discountsData) {
        return false;
      }

      var buttonNumber = null;
      if (buttonElement.id === "discount-button-1") {
        buttonNumber = 1;
      } else if (buttonElement.id === "discount-button-2") {
        buttonNumber = 2;
      }

      window.saveDiscountPreference(discountTitle);
      if (buttonNumber) {
        try {
          localStorage.setItem("assemblyPreference", String(buttonNumber));
        } catch (e) {
          console.error(
            "[handleDiscountButtonClick] Error saving assembly preference:",
            e
          );
        }
      }

      applyDiscount(discountTitle, discountsData);

      return false;
    } catch (err) {
      console.error(
        "[handleDiscountButtonClick] Error in handleDiscountButtonClick:",
        err
      );
      return false;
    }
  }

  window.handleDiscountButtonClick = handleDiscountButtonClick;

  function removeDiscount(variantId) {
    console.log("product-discount-price.js: removeDiscount");
    try {
      var event = window.event || {};
      if (event) {
        if (event.stopPropagation) event.stopPropagation();
        if (event.preventDefault) event.preventDefault();
        event.cancelBubble = true;
      }

      if (!variantId) {
        var target = event.target || event.currentTarget;
        if (target) {
          var removeBtn = target.closest(".discount-pill-remove");
          if (removeBtn) {
            var cartDrawerItem = removeBtn.closest(".mini-cart__line-item");
            if (cartDrawerItem) {
              variantId = cartDrawerItem.getAttribute("data-variant-id");
              if (!variantId) {
                var removeButton =
                  cartDrawerItem.querySelector(".remove[data-id]");
                if (removeButton) {
                  variantId = removeButton.getAttribute("data-id");
                }
              }
            } else {
              var cartPageRow = removeBtn.closest('tr[id^="CartItem-"]');
              if (cartPageRow) {
                var productId = cartPageRow.getAttribute("data-product-id");
                if (productId) {
                  var keyMatch = productId.match(/^(\d+)/);
                  if (keyMatch) {
                    variantId = keyMatch[1];
                  } else {
                    variantId = productId;
                  }
                }
              }
            }
          }
        }
      }
      if (!variantId) {
        console.warn(
          "[REMOVE-DISCOUNT] No variantId found, cannot remove discount"
        );
        return;
      }

      try {
        var stored = localStorage.getItem("variantDiscounts");
        if (stored) {
          var variantDiscounts = JSON.parse(stored);
          if (variantDiscounts[variantId]) {
            delete variantDiscounts[variantId];
            localStorage.setItem(
              "variantDiscounts",
              JSON.stringify(variantDiscounts)
            );
          }
        }

        setUserRemovedDiscountGlobal();
      } catch (e) {
        console.error("[REMOVE-DISCOUNT] Error removing variant discount:", e);
      }
      if (variantId) {
        var cartDrawerItem = document.querySelector(
          '.mini-cart__line-item[data-variant-id="' +
            variantId +
            '"], #CartDrawerItem-' +
            variantId
        );
        if (cartDrawerItem) {
          var drawerPill = cartDrawerItem.querySelector(
            "#applied-discount-cart-drawer"
          );
          if (drawerPill) {
            drawerPill.remove();
          }
          var shopifyPills = cartDrawerItem.querySelectorAll(
            ".custom-discount-pill"
          );
          if (shopifyPills.length > 0) {
            shopifyPills.forEach(function (pill) {
              pill.remove();
            });
          }
          var priceSpan = cartDrawerItem.querySelector(".price");
          if (priceSpan) {
            var originalCents = 0;

            var quantity = 1;
            var qtyText = cartDrawerItem.querySelector(
              ".quantity-selector__value"
            );
            if (qtyText) {
              var qtyMatch = qtyText.textContent.match(/\d+/);
              if (qtyMatch) {
                quantity = parseInt(qtyMatch[0]);
              }
            }

            var dataOriginalPrice = cartDrawerItem.getAttribute(
              "data-original-price"
            );
            if (dataOriginalPrice) {
              originalCents = parseInt(dataOriginalPrice);
            }

            if (originalCents === 0 || isNaN(originalCents)) {
              var amountElements = priceSpan.querySelectorAll(".amount");
              if (amountElements.length > 0) {
                var originalPriceText = amountElements[0].textContent.trim();
                originalCents = window.parseMoneyTextToCents(originalPriceText);
              }
            }

            if ((originalCents === 0 || isNaN(originalCents)) && quantity > 0) {
              var dataOriginalLinePrice = cartDrawerItem.getAttribute(
                "data-original-line-price"
              );
              if (dataOriginalLinePrice) {
                var linePriceCents = parseInt(dataOriginalLinePrice);
                if (linePriceCents > 0 && quantity > 0) {
                  originalCents = Math.round(linePriceCents / quantity);
                }
              }
            }

            if (originalCents === 0 || isNaN(originalCents)) {
              var amountElements = priceSpan.querySelectorAll(".amount");
              if (amountElements.length > 0) {
                var currentPriceText = amountElements[0].textContent.trim();
                originalCents = window.parseMoneyTextToCents(currentPriceText);
              }
            }

            if (originalCents > 0 && !isNaN(originalCents)) {
              var currencyCodeEnabled =
                window.currencyCodeEnabled !== undefined
                  ? window.currencyCodeEnabled
                  : true;
              var formattedPrice = window.formatMoney(
                originalCents,
                currencyCodeEnabled
              );
              priceSpan.innerHTML =
                '<span class="mini-quantity">' +
                quantity +
                "×</span> " +
                '<span class="amount">' +
                formattedPrice +
                "</span>";

              var originalLinePrice = originalCents * quantity;
              cartDrawerItem.setAttribute(
                "data-original-line-price",
                originalLinePrice
              );
              cartDrawerItem.setAttribute(
                "data-final-line-price",
                originalLinePrice
              );
              cartDrawerItem.removeAttribute("data-discounted-subtotal");
            } else {
              console.warn(
                "[REMOVE-DISCOUNT] Could not determine original price for cart drawer item:",
                {
                  variantId: variantId,
                  dataOriginalPrice: dataOriginalPrice,
                  hasMultipleAmounts:
                    priceSpan.querySelectorAll(".amount").length > 1,
                  hasCurrentAmount: !!priceSpan.querySelector(".amount"),
                }
              );
            }
          }
        }
        var cartPageRow = document.querySelector(
          'tr[id^="CartItem-"][data-product-id*="' + variantId + '"]'
        );
        if (cartPageRow) {
          var cartPagePill = cartPageRow.querySelector(
            "#applied-discount-cart-page"
          );
          if (cartPagePill) {
            cartPagePill.remove();
          }
          var shopifyPills = cartPageRow.querySelectorAll(
            ".discounts__discount"
          );
          if (shopifyPills.length > 0) {
            shopifyPills.forEach(function (pill) {
              pill.remove();
            });
          }
          var unitPriceList = cartPageRow.querySelector(
            ".line-item__price-list"
          );
          var unitPriceSpan = unitPriceList
            ? unitPriceList.querySelector(".line-item__price")
            : null;
          if (unitPriceSpan) {
            var originalCents = 0;
            var originalText = unitPriceSpan.textContent.trim();
            originalCents = window.parseMoneyTextToCents(originalText);
            if (originalCents > 0) {
              var currencyCodeEnabled =
                window.currencyCodeEnabled !== undefined
                  ? window.currencyCodeEnabled
                  : true;
              var formattedPrice = window.formatMoney(
                originalCents,
                currencyCodeEnabled
              );
              var quantity = 1;
              var qtyInput =
                cartPageRow.querySelector('input[name="updates[]"]') ||
                cartPageRow.querySelector(".quantity-selector__value");
              if (qtyInput) {
                quantity =
                  parseInt(
                    qtyInput.value ||
                      qtyInput.getAttribute("data-current-value") ||
                      "1",
                    10
                  ) || 1;
              }
              var lineTotalCents = originalCents * quantity;
              var formattedLineTotal = window.formatMoney(
                lineTotalCents,
                currencyCodeEnabled
              );
              var amountElements = unitPriceSpan.querySelectorAll(".amount");
              if (amountElements.length > 1) {
                for (var i = 1; i < amountElements.length; i++) {
                  amountElements[i].remove();
                }
              }
              unitPriceSpan.innerHTML =
                '<span class="amount">' + formattedPrice + "</span>";
              var subtotalCell = cartPageRow.querySelector(
                ".line-item__line-price"
              );
              if (subtotalCell) {
                var subtotalPriceSpan = subtotalCell.querySelector("span");
                if (subtotalPriceSpan) {
                  var originalLinePrice = window.parseMoneyTextToCents(
                    subtotalPriceSpan.textContent.trim()
                  );
                  if (originalLinePrice > 0) {
                    var formattedOriginalLineTotal = window.formatMoney(
                      originalLinePrice,
                      currencyCodeEnabled
                    );
                    subtotalPriceSpan.innerHTML =
                      '<span class="amount">' +
                      formattedOriginalLineTotal +
                      "</span>";
                  } else {
                    subtotalPriceSpan.innerHTML =
                      '<span class="amount">' + formattedLineTotal + "</span>";
                  }
                }
              }
            }
          }
        }
      } else {
        var drawerPill = document.getElementById(
          "applied-discount-cart-drawer"
        );
        if (drawerPill) {
          drawerPill.remove();
        }
        var cartPagePill = document.getElementById(
          "applied-discount-cart-page"
        );
        if (cartPagePill) {
          cartPagePill.remove();
        }
      }
      try {
        var stored = localStorage.getItem("variantDiscounts");
        var hasAnyDiscounts = false;
        if (stored) {
          var variantDiscounts = JSON.parse(stored);
          hasAnyDiscounts = Object.keys(variantDiscounts).length > 0;
        }

        if (!hasAnyDiscounts) {
          localStorage.removeItem("cartLockedDiscountPreference");
        }
      } catch (e) {
        console.error(
          "[REMOVE-DISCOUNT] Error checking if all discounts removed:",
          e
        );
      }

      setTimeout(function () {
        recomputeDrawerSubtotalFromDOM(
          "product-discount-price.js: removeDiscount line 679"
        );
        recomputeCartPageSubtotalFromDOM(
          "product-discount-price.js: removeDiscount line 689"
        );
        try {
          setupCheckoutDiscountRedirects(
            "product-discount-price.js: removeDiscount line 696"
          );
        } catch (e) {
          console.error("[REMOVE-DISCOUNT] Error updating checkout URLs:", e);
        }
      }, 100);
    } catch (e) {
      console.error("[DISCOUNT] Error removing discount:", e);
    }
  }

  window.removeDiscount = removeDiscount;

  function applyDiscount(discountTitle, discountsData) {
    console.log("product-discount-price.js: applyDiscount");
    if (!discountTitle || discountTitle.trim() === "") {
      window.resetToOriginalPrice();
      return;
    }
    var discounts = null;
    try {
      discounts =
        typeof discountsData === "string"
          ? JSON.parse(discountsData.trim())
          : discountsData;
    } catch (e) {
      console.error("[applyDiscount] Error parsing discounts:", e);
      return;
    }
    var discount = null;
    if (discounts && Array.isArray(discounts)) {
      discount = discounts.find(function (d) {
        return d.title === discountTitle.trim();
      });
    }
    if (!discount) {
      window.resetToOriginalPrice();
      return;
    }

    if (typeof window.getCurrentVariantPrice === "function") {
      var variantPrice = window.getCurrentVariantPrice();
    } else {
      console.error("[applyDiscount] getCurrentVariantPrice not available");
      return;
    }

    if (!variantPrice) {
      console.error("[applyDiscount] Could not get variant price");
      return;
    }
    if (!discount.percentage || discount.percentage <= 0) {
      window.resetToOriginalPrice();
      return;
    }

    var priceUpdate = updatePrice(discount, variantPrice);

    updateAppliedDiscount(discount, priceUpdate);

    return discount;
  }

  function applyActiveDiscount() {
    if (!isProductPage) {
      return;
    }
    console.log("product-discount-price.js: applyActiveDiscount");
    if (isUpdatingPrice) {
      console.error("[applyActiveDiscount] Skipping - isUpdatingPrice is true");
      return;
    }
    updatePriceDataAttributes();
    var discountButtonsContainer = document.querySelector(
      "[data-product-discounts-wrapper] .discount-buttons"
    );
    var activeButton = discountButtonsContainer?.querySelector(
      ".discount-button.active"
    );
    var discountsScript = document.querySelector(
      '[data-product-discounts-wrapper] script[type="application/json"]'
    );
    if (activeButton && discountsScript) {
      var discountTitle = activeButton.getAttribute("data-discount-title");
      if (discountTitle) {
        var discountsData = discountsScript.textContent.trim();
        applyDiscount(discountTitle, discountsData);
      }
    } else {
      if (typeof window.getCurrentVariantPrice === "function") {
        var variantPrice = window.getCurrentVariantPrice();
        if (variantPrice) {
          updatePrice(null, variantPrice);
          updateAppliedDiscount(null, null);
        }
      } else {
        console.error(
          "[applyActiveDiscount] getCurrentVariantPrice not available"
        );
      }
    }
  }

  function handleVariantChange(event) {
    if (!isProductPage) {
      return;
    }
    if (isUpdatingPrice) {
      return;
    }
    console.log("product-discount-price.js: handleVariantChange");

    var variant =
      event && event.detail && event.detail.variant
        ? event.detail.variant
        : null;

    if (
      variant &&
      variant.id &&
      window.history &&
      window.history.replaceState
    ) {
      try {
        var url = new URL(window.location.href);
        var currentVariantId = url.searchParams.get("variant");

        if (currentVariantId !== String(variant.id)) {
          url.searchParams.set("variant", variant.id);
          var newUrl = url.toString();
          window.history.replaceState(
            {
              path: newUrl,
            },
            "",
            newUrl
          );
        }
      } catch (e) {
        var currentUrl = window.location.href;
        var variantParam = "variant=" + variant.id;
        if (currentUrl.indexOf(variantParam) === -1) {
          var separator = currentUrl.indexOf("?") === -1 ? "?" : "&";
          var newUrl = currentUrl.split("?")[0] + separator + variantParam;
          window.history.replaceState(
            {
              path: newUrl,
            },
            "",
            newUrl
          );
        }
      }
    }
    var activeDiscount = document.querySelector(".discount-button.active");
    var discountTitle = activeDiscount
      ? activeDiscount.getAttribute("data-discount-title")
      : null;
    if (!activeDiscount || !discountTitle || discountTitle.trim() === "") {
      console.error(
        "[handleVariantChange] No active discount - updating price without discount"
      );

      setTimeout(function () {
        if (!isUpdatingPrice) {
          updatePriceDataAttributes(variant);
          var variantPrice = window.getCurrentVariantPrice();
          if (variantPrice) {
            updatePrice(null, variantPrice);
            updateAppliedDiscount(null, null);
          }
        }
      }, 100);
      return;
    }
    setTimeout(function () {
      if (!isUpdatingPrice) {
        updatePriceDataAttributes(variant);
        applyActiveDiscount();
      }
    }, 300);
  }

  function applyPreferenceOnProductPage() {
    console.log("product-discount-price.js: applyPreferenceOnProductPage");
    if (!isProductPage) {
      return;
    }
    try {
      var wrapper = document.querySelector("[data-product-discounts-wrapper]");
      if (!wrapper) {
        return;
      }

      var pref = null;
      var buttonNumber = null;
      var useLockedPreference = false;

      try {
        var lockedPreference = localStorage.getItem(
          "cartLockedDiscountPreference"
        );
        if (lockedPreference) {
          buttonNumber = parseInt(lockedPreference, 10);
          useLockedPreference = true;
        }
      } catch (e) {
        console.error(
          "[applyPreferenceOnProductPage] Error checking cartLockedDiscountPreference:",
          e
        );
      }

      if (!buttonNumber) {
        try {
          var assemblyPref = localStorage.getItem("assemblyPreference");
          if (assemblyPref) {
            buttonNumber = parseInt(assemblyPref, 10);
            useLockedPreference = false;
          }
        } catch (e) {
          console.error(
            "[applyPreferenceOnProductPage] Error checking assemblyPreference:",
            e
          );
        }
      }

      if (!buttonNumber) {
        pref = window.getDiscountPreference();
      }

      var buttons = wrapper.querySelectorAll(".discount-button");
      if (!buttons || !buttons.length) {
        return;
      }
      var targetBtn = null;
      var hasNoDiscount = false;
      if (typeof window.hasNoDiscountPreference === "function") {
        hasNoDiscount = window.hasNoDiscountPreference();
      } else {
        try {
          hasNoDiscount =
            localStorage.getItem("activeDiscountTitle") === "__no_discount__";
        } catch (e) {
          hasNoDiscount = false;
        }
      }
      if (hasNoDiscount && !buttonNumber) {
        buttons.forEach(function (btn, index) {
          var title = btn.getAttribute("data-discount-title") || "";
          if (!targetBtn) {
            if (btn.id === "discount-button-2") {
              targetBtn = btn;
            }
          }
        });
        if (!targetBtn && buttons.length >= 2) {
          if (buttons[1] && buttons[1].id === "discount-button-2") {
            targetBtn = buttons[1];
          }
        }
        if (targetBtn) {
          document.querySelectorAll(".discount-button").forEach(function (btn) {
            btn.classList.remove("active");
          });
          targetBtn.classList.add("active");
          window.resetToOriginalPrice();
          var productPill = document.getElementById("applied-discount");
          if (productPill) {
            productPill.style.display = "none";
          }
        }
        return;
      }

      if (buttonNumber && (buttonNumber === 1 || buttonNumber === 2)) {
        var targetButtonId =
          buttonNumber === 1 ? "discount-button-1" : "discount-button-2";
        targetBtn = wrapper.querySelector("#" + targetButtonId);
        if (targetBtn) {
          var buttonTitle = targetBtn.getAttribute("data-discount-title");
          if (buttonTitle) {
            pref = buttonTitle;
          }
        } else {
          console.error(
            "[BUTTON] Target button not found:",
            targetButtonId,
            "buttonNumber:",
            buttonNumber,
            "useLockedPreference:",
            useLockedPreference
          );
        }
      } else if (pref) {
        buttons.forEach(function (btn) {
          try {
            var title = btn.getAttribute("data-discount-title") || "";
            if (!targetBtn && title && title.trim() !== "") {
              var prefLower = pref.toLowerCase();
              var titleLower = title.trim().toLowerCase();
              if (prefLower === titleLower) {
                targetBtn = btn;
              }
            }
          } catch (e) {
            console.error(
              "[DEBUG] Error processing button in applyPreferenceOnProductPage:",
              e
            );
          }
        });
      }

      if (!targetBtn && !useLockedPreference) {
        var discountButtonsContainer =
          wrapper.querySelector(".discount-buttons");
        if (discountButtonsContainer) {
          var initialDiscount = discountButtonsContainer.getAttribute(
            "data-initial-discount"
          );
          if (initialDiscount && initialDiscount.trim() !== "") {
            buttons.forEach(function (btn) {
              var title = btn.getAttribute("data-discount-title") || "";
              if (
                !targetBtn &&
                title &&
                title.trim() === initialDiscount.trim()
              ) {
                targetBtn = btn;
              }
            });
          }
        }

        if (!targetBtn) {
          var existingActive = wrapper.querySelector(".discount-button.active");
          var hasSavedPreference =
            window.getDiscountPreference() ||
            localStorage.getItem("assemblyPreference");

          if (existingActive && !hasSavedPreference) {
            targetBtn = existingActive;
          }
        }
      }
      if (!targetBtn) {
        return;
      }
      var discountsScript = wrapper.querySelector(
        'script[type="application/json"]'
      );
      if (!discountsScript) {
        console.error("[DEBUG] Discounts script not found");
        return;
      }
      try {
        var discountsData = discountsScript.textContent.trim();
        var buttonMappingFromDOM = null;
        var button1 = wrapper.querySelector("#discount-button-1");
        var button2 = wrapper.querySelector("#discount-button-2");
        if (button1 && button2) {
          var button1Title = button1.getAttribute("data-discount-title");
          var button2Title = button2.getAttribute("data-discount-title");
          if (button1Title && button2Title) {
            buttonMappingFromDOM = {
              button1: button1Title,
              button2: button2Title,
            };
            try {
              localStorage.setItem(
                "buttonDiscountMapping",
                JSON.stringify(buttonMappingFromDOM)
              );
            } catch (e) {
              console.error(
                "[BUTTON] Error storing button mapping from DOM:",
                e
              );
            }
          }
        }

        document.querySelectorAll(".discount-button").forEach(function (btn) {
          try {
            btn.classList.remove("active");
          } catch (e) {
            console.error("[DEBUG] Error removing active class:", e);
          }
        });
        targetBtn.classList.add("active");

        var buttonDiscountTitle =
          targetBtn.getAttribute("data-discount-title") || pref;
        applyDiscount(buttonDiscountTitle, discountsData);
      } catch (e) {
        console.error(
          "[DEBUG] Error applying discount in applyPreferenceOnProductPage:",
          e
        );
      }
    } catch (e) {
      console.error("[DEBUG] Error in applyPreferenceOnProductPage:", e);
    }
  }

  function initializeAddToCartListener() {
    console.log("product-discount-price.js: initializeAddToCartListener");
    if (!isProductPage) {
      return;
    }
    var addToCartButton = document.querySelector("#AddToCart");

    if (addToCartButton) {
      var form = addToCartButton.closest("form");

      if (form && !form.dataset.discountListenerAdded) {
        form.dataset.discountListenerAdded = "true";
        var discountListenerSubmitted = false;

        function handleAddToCartWithMontage(e) {
          if (discountListenerSubmitted) {
            if (e) {
              e.preventDefault();
              e.stopPropagation();
              e.stopImmediatePropagation();
            }
            return;
          }

          var discountsWrapper = document.querySelector(
            "[data-product-discounts-wrapper]"
          );
          if (!discountsWrapper) {
            return;
          }

          var discountsScript = discountsWrapper.querySelector(
            'script[type="application/json"]'
          );
          var hasDiscounts = false;
          if (discountsScript) {
            try {
              var discounts = JSON.parse(discountsScript.textContent.trim());
              hasDiscounts = Array.isArray(discounts) && discounts.length > 0;
            } catch (e) {
              console.error("[ADD-TO-CART] Error parsing discounts:", e);
            }
          }

          if (!hasDiscounts) {
            return;
          }

          discountListenerSubmitted = true;
          if (e) {
            e.preventDefault();
            e.stopPropagation();
            e.stopImmediatePropagation();
          }

          try {
            setTimeout(function () {
              try {
                var variantId = null;

                if (
                  form &&
                  form.productVariants &&
                  form.productVariants.currentVariant
                ) {
                  variantId = String(form.productVariants.currentVariant.id);
                }

                if (!variantId) {
                  var variantSelects = form.querySelector(
                    ".product-form__variants"
                  );
                  if (variantSelects && variantSelects.currentVariant) {
                    variantId = String(variantSelects.currentVariant.id);
                  }
                }

                if (!variantId) {
                  var productFormElement = form.closest("product-form");
                  if (
                    productFormElement &&
                    productFormElement.productVariants &&
                    productFormElement.productVariants.currentVariant
                  ) {
                    variantId = String(
                      productFormElement.productVariants.currentVariant.id
                    );
                  }
                }

                if (!variantId) {
                  var variantIdInput =
                    form.querySelector('input[name="id"]') ||
                    form.querySelector('select[name="id"]');

                  if (variantIdInput) {
                    variantId = variantIdInput.value;
                  }
                }

                if (!variantId) {
                  console.error("[ADD-TO-CART] Could not determine variant ID");
                  discountListenerSubmitted = false;
                  return;
                }

                var quantityInput = form.querySelector(
                  'input[name="quantity"]'
                );
                var quantity = quantityInput
                  ? parseInt(quantityInput.value || "1", 10)
                  : 1;

                var discountTitleToUse = "";
                var lockedPreference = null;
                try {
                  lockedPreference = localStorage.getItem(
                    "cartLockedDiscountPreference"
                  );
                } catch (e) {
                  console.error("[DEBUG] Error getting locked preference:", e);
                }

                if (lockedPreference) {
                  var buttonMapping = window.getButtonDiscountMapping();
                  if (buttonMapping) {
                    if (lockedPreference === "1") {
                      discountTitleToUse = buttonMapping.button1 || "";
                    } else if (lockedPreference === "2") {
                      discountTitleToUse = buttonMapping.button2 || "";
                    }
                  }
                }

                var discountsWrapper = document.querySelector(
                  "[data-product-discounts-wrapper]"
                );

                if (!discountsWrapper) {
                  return;
                }

                if (!discountTitleToUse) {
                  discountTitleToUse =
                    window.getDiscountPreferenceWithPriority();
                }

                var discountPercentage = 0;
                var discountsScript = discountsWrapper.querySelector(
                  'script[type="application/json"]'
                );
                if (discountsScript && discountTitleToUse) {
                  try {
                    var discounts = JSON.parse(
                      discountsScript.textContent.trim()
                    );
                    var discount = window.findDiscountByTitle(
                      discounts,
                      discountTitleToUse
                    );
                    if (discount && discount.percentage) {
                      discountPercentage = discount.percentage;
                    }
                  } catch (e) {
                    console.error(
                      "[DEBUG] Error parsing discounts in form submit:",
                      e
                    );
                  }
                }

                var activeButton = discountsWrapper.querySelector(
                  ".discount-button.active"
                );
                var isButton2Active = false;
                if (activeButton) {
                  isButton2Active = activeButton.id === "discount-button-2";
                }

                var shouldAddMontageProducts = false;
                if (lockedPreference === "2") {
                  shouldAddMontageProducts = true;
                } else if (lockedPreference === "1") {
                  shouldAddMontageProducts = false;
                } else {
                  shouldAddMontageProducts = isButton2Active;
                }

                var linkedVariantsScript = document.querySelector(
                  '[id^="linked-variants-data-"]'
                );

                var itemsToAdd = [{ id: variantId, quantity: quantity }];
                var linkedVariantIds = [];

                if (shouldAddMontageProducts && linkedVariantsScript) {
                  try {
                    var linkedVariantsData = JSON.parse(
                      linkedVariantsScript.textContent.trim()
                    );
                    var linkedVariants = linkedVariantsData[variantId];
                    if (
                      linkedVariants &&
                      Array.isArray(linkedVariants) &&
                      linkedVariants.length > 0
                    ) {
                      var productTitle = "";
                      var variantTitle = "";

                      var productJson = document.querySelector(
                        '[type="application/json"][data-product-json]'
                      );
                      if (productJson) {
                        try {
                          var productData = JSON.parse(productJson.textContent);
                          if (productData.productTitle) {
                            productTitle = productData.productTitle;
                          } else {
                            console.error(
                              "[ADD-TO-CART] Error getting product title:",
                              productData
                            );
                            productTitle = "";
                          }

                          var selectedVariant =
                            productData.productVariants?.find(function (v) {
                              return String(v.id) === String(variantId);
                            });
                          if (selectedVariant && selectedVariant.title) {
                            variantTitle = "- " + selectedVariant.title;
                          } else {
                            console.error(
                              "[ADD-TO-CART] Error getting variant title:",
                              selectedVariant
                            );
                            variantTitle = "";
                          }
                        } catch (e) {
                          console.error(
                            "[ADD-TO-CART] Error parsing product JSON:",
                            e
                          );
                        }
                      }

                      var propertyLabel = {
                        en: "For",
                        de: "Für",
                        fr: "Pour",
                        it: "Per",
                      };

                      var currentLocale = document.documentElement.lang || "en";
                      var langCode = currentLocale.split("-")[0].toLowerCase();
                      if (!propertyLabel[langCode]) {
                        langCode = "en";
                      }

                      var propertyKey = propertyLabel[langCode];

                      var combinedTitle = productTitle || "";
                      if (variantTitle && variantTitle !== "Default Title") {
                        if (combinedTitle) {
                          combinedTitle = combinedTitle + " " + variantTitle;
                        } else {
                          combinedTitle = variantTitle;
                        }
                      }

                      linkedVariants.forEach(function (linkedVariant) {
                        if (
                          linkedVariant &&
                          linkedVariant.id &&
                          String(linkedVariant.id) !== String(variantId)
                        ) {
                          linkedVariantIds.push(String(linkedVariant.id));
                          var properties = {};
                          if (combinedTitle) {
                            properties[propertyKey] = combinedTitle;
                          }

                          itemsToAdd.push({
                            id: String(linkedVariant.id),
                            quantity: quantity,
                            properties: properties,
                          });
                        }
                      });

                      if (linkedVariantIds.length > 0) {
                        try {
                          var variantRelationships = JSON.parse(
                            localStorage.getItem("variantRelationships") || "{}"
                          );
                          variantRelationships[String(variantId)] =
                            linkedVariantIds;
                          localStorage.setItem(
                            "variantRelationships",
                            JSON.stringify(variantRelationships)
                          );
                        } catch (e) {
                          console.error(
                            "[ADD-TO-CART] Error storing variant relationship:",
                            e
                          );
                        }
                      }
                    }
                  } catch (e) {
                    console.error(
                      "[ADD-TO-CART] Error parsing linked variants:",
                      e
                    );
                  }
                }

                var cartAddBody =
                  itemsToAdd.length === 1
                    ? { id: variantId, quantity: quantity }
                    : { items: itemsToAdd };

                cartAddBody.sections = ["mini-cart"];
                cartAddBody.sections_url = window.location.pathname;

                fetch("/cart/add.js", {
                  method: "POST",
                  headers: {
                    "Content-Type": "application/json",
                    "X-Requested-With": "XMLHttpRequest",
                    Accept: "application/json",
                  },
                  body: JSON.stringify(cartAddBody),
                })
                  .then(function (response) {
                    if (response.ok) {
                      return response.json();
                    }
                    throw new Error("Failed to add to cart");
                  })
                  .then(async function (cartData) {
                    try {
                      var currentLockedPreference = localStorage.getItem(
                        "cartLockedDiscountPreference"
                      );
                      if (!currentLockedPreference) {
                        var activeButton = discountsWrapper.querySelector(
                          ".discount-button.active"
                        );
                        var buttonNumber = null;
                        if (activeButton) {
                          if (activeButton.id === "discount-button-1") {
                            buttonNumber = 1;
                          } else if (activeButton.id === "discount-button-2") {
                            buttonNumber = 2;
                          }
                        }

                        if (!buttonNumber) {
                          var assemblyPref =
                            localStorage.getItem("assemblyPreference");
                          if (assemblyPref) {
                            buttonNumber = parseInt(assemblyPref, 10);
                          }
                        }

                        if (
                          !buttonNumber ||
                          (buttonNumber !== 1 && buttonNumber !== 2)
                        ) {
                          buttonNumber = 1;
                        }

                        localStorage.setItem(
                          "cartLockedDiscountPreference",
                          String(buttonNumber)
                        );
                      }
                    } catch (e) {
                      console.error(
                        "[ADD-TO-CART] Error setting cartLockedDiscountPreference:",
                        e
                      );
                    }

                    try {
                      window.saveVariantDiscount(
                        variantId,
                        discountTitleToUse,
                        discountPercentage
                      );
                    } catch (e) {
                      console.error(
                        "[DEBUG] Error saving variant discount:",
                        e
                      );
                    }

                    if (cartData && cartData.sections) {
                      if (
                        typeof window.updateMiniCartFromSections === "function"
                      ) {
                        window.updateMiniCartFromSections(cartData, {
                          openDrawer: true,
                          updateBubbleCount: true,
                          cartData: cartData,
                        });
                      }
                    }

                    if (
                      cartData &&
                      cartData.items &&
                      cartData.items.length > 0
                    ) {
                      var productItem =
                        cartData.items[cartData.items.length - 1];
                      document.dispatchEvent(
                        new CustomEvent("cart:item-added", {
                          detail: { product: productItem },
                        })
                      );
                    }

                    discountListenerSubmitted = false;
                  })
                  .catch(function (error) {
                    console.error("[ADD-TO-CART] Error adding to cart:", error);
                    discountListenerSubmitted = false;
                  });
              } catch (e) {
                console.error("[DEBUG] Error in form submit listener:", e);
                discountListenerSubmitted = false;
              }
            }, 300);
          } catch (e) {
            console.error("[DEBUG] Error setting up form submit:", e);
            discountListenerSubmitted = false;
          }
        }

        addToCartButton.addEventListener(
          "click",
          function (e) {
            var discountsWrapper = document.querySelector(
              "[data-product-discounts-wrapper]"
            );
            var hasDiscounts = false;
            if (discountsWrapper) {
              var discountsScript = discountsWrapper.querySelector(
                'script[type="application/json"]'
              );
              if (discountsScript) {
                try {
                  var discounts = JSON.parse(
                    discountsScript.textContent.trim()
                  );
                  hasDiscounts =
                    Array.isArray(discounts) && discounts.length > 0;
                } catch (e) {
                  console.error("[CLICK] Error parsing discounts:", e);
                }
              }
            }

            if (hasDiscounts) {
              handleAddToCartWithMontage(e);
            }
          },
          true
        );

        form.addEventListener(
          "submit",
          function (e) {
            handleAddToCartWithMontage(e);
          },
          true
        );
      }
      return true;
    }
    return false;
  }

  function initOnReady() {
    initPageFlags();

    console.log("product-discount-price.js: initOnReady");

    applyDiscountsOnPageLoad();
    setupEssentialUpsellListener();

    if (typeof window.initializeInterception === "function") {
      window.initializeInterception();
    }

    if (isProductPage) {
      if (!initializeAddToCartListener()) {
        setTimeout(initializeAddToCartListener, 500);
      }

      setTimeout(() => {
        applyPreferenceOnProductPage();
        setTimeout(applyPreferenceOnProductPage, 100);
      }, 200);
    }
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initOnReady);
  } else {
    initOnReady();
  }

  document.addEventListener("variant:changed", handleVariantChange);
  document.addEventListener("product:variant-change", handleVariantChange);

  function setupVariantSelectorListeners() {
    console.log("product-discount-price.js: setupVariantSelectorListeners");
    var variantSelects = document.querySelector(".product-form__variants");
    if (variantSelects) {
      variantSelects.addEventListener("variant:changed", handleVariantChange);
    } else {
      if (typeof setupVariantSelectorListeners.tries === "undefined") {
        setupVariantSelectorListeners.tries = 0;
      }
      setupVariantSelectorListeners.tries++;
      if (setupVariantSelectorListeners.tries <= 5) {
        setTimeout(setupVariantSelectorListeners, 500);
      } else {
        console.warn(
          "[VARIANT-CHANGE] Max retries reached for variant selector listener setup"
        );
      }
    }
  }
  if (isProductPage) {
    setupVariantSelectorListeners();
  }

  var variantChangedEventFired = false;

  document.addEventListener("change", function (event) {
    console.log("product-discount-price.js: change event");
    if (
      event.target &&
      event.target.classList &&
      event.target.classList.contains("product-form__single-selector")
    ) {
      variantChangedEventFired = false;

      setTimeout(function () {
        if (!variantChangedEventFired) {
          var variant = window.getVariantFromSelectedOptions();
          if (variant) {
            if (variant.id && window.history && window.history.replaceState) {
              var url = new URL(window.location.href);
              url.searchParams.set("variant", variant.id);
              var newUrl = url.toString();
              window.history.replaceState(
                {
                  path: newUrl,
                },
                "",
                newUrl
              );
            }

            var syntheticEvent = {
              type: "change",
              target: event.target,
              detail: {
                variant: variant,
              },
            };
            handleVariantChange(syntheticEvent);
          } else {
            setTimeout(function () {
              handleVariantChange(event);
            }, 100);
          }
        }
      }, 200);
    }
  });

  document.addEventListener(
    "variant:changed",
    function (event) {
      console.log("product-discount-price.js: variant:changed event");
      variantChangedEventFired = true;
    },
    true
  );

  function handleCartItemAdded(productData) {
    console.log("product-discount-price.js: handleCartItemAdded");
    try {
      var discountsWrapper = document.querySelector(
        "[data-product-discounts-wrapper]"
      );
      if (!discountsWrapper) {
        if (productData && productData.variant_id) {
          try {
            var noDiscountVariants = JSON.parse(
              localStorage.getItem("noDiscountVariants") || "[]"
            );
            if (
              noDiscountVariants.indexOf(String(productData.variant_id)) === -1
            ) {
              noDiscountVariants.push(String(productData.variant_id));
              localStorage.setItem(
                "noDiscountVariants",
                JSON.stringify(noDiscountVariants)
              );
            }
          } catch (e) {
            console.error("[CART-ADD] Error saving no-discount variant:", e);
          }
        }
        return;
      }

      var button1 = document.querySelector("#discount-button-1");
      var button2 = document.querySelector("#discount-button-2");
      var activeButton = document.querySelector(".discount-button.active");

      var buttonNumber = null;

      if (button1 && button2 && activeButton) {
        var button1Title = button1.getAttribute("data-discount-title");
        var button2Title = button2.getAttribute("data-discount-title");
        if (button1Title && button2Title) {
          var mapping = {
            button1: button1Title,
            button2: button2Title,
          };
          try {
            localStorage.setItem(
              "buttonDiscountMapping",
              JSON.stringify(mapping)
            );
          } catch (e) {
            console.error("[CART-ADD] Error storing button mapping:", e);
          }
        }

        if (activeButton.id === "discount-button-2") {
          buttonNumber = 2;
        } else if (activeButton.id === "discount-button-1") {
          buttonNumber = 1;
        }
      }

      if (buttonNumber === null) {
        try {
          var assemblyPref = localStorage.getItem("assemblyPreference");
          if (assemblyPref) {
            buttonNumber = parseInt(assemblyPref, 10);
          }
        } catch (e) {
          console.error("[CART-ADD] Error getting assemblyPreference:", e);
        }
      }

      if (buttonNumber === null || (buttonNumber !== 1 && buttonNumber !== 2)) {
        buttonNumber = 1;
      }

      try {
        var lockedPreference = localStorage.getItem(
          "cartLockedDiscountPreference"
        );

        if (!lockedPreference) {
          try {
            localStorage.setItem(
              "cartLockedDiscountPreference",
              String(buttonNumber)
            );
            var verify = localStorage.getItem("cartLockedDiscountPreference");
            if (verify === String(buttonNumber)) {
            } else {
              console.error(
                "[CART-ADD]  VERIFICATION FAILED: Expected",
                buttonNumber,
                "but got",
                verify
              );
            }
          } catch (e) {
            console.error(
              "[CART-ADD]  ERROR setting cartLockedDiscountPreference:",
              e
            );
          }
        } else {
          var lockedButtonNumber = parseInt(lockedPreference, 10);
          buttonNumber = lockedButtonNumber;
        }
      } catch (e) {
        console.error("[CART-ADD] Error handling locked preference:", e);
      }

      setTimeout(function () {
        if (typeof window.applyCartDrawerDiscounts === "function") {
          window.applyCartDrawerDiscounts(
            "product-discount-price.js: handleCartItemAdded line 1847"
          );
        }
        applyCartPageDiscounts(
          "product-discount-price.js: handleCartItemAdded line 1849"
        );
      }, 400);
    } catch (e) {
      console.error("[CART-ADD]  CRITICAL ERROR in handleCartItemAdded:", e);
    }
  }

  document.addEventListener("cart:item-added", function (event) {
    var product =
      event.detail?.product || event.detail || event.detail?.items?.[0];
    handleCartItemAdded(product);
  });

  document.addEventListener("cart-drawer:open", function () {
    try {
      if (typeof window.applyCartDrawerDiscounts === "function") {
        window.applyCartDrawerDiscounts(
          "product-discount-price.js: cart-drawer:open line 1867"
        );
      }
    } catch (e) {
      console.error("[CART-ADD] Error applying cart drawer discounts:", e);
    }
  });

  var formInterceptionInitialized = false;

  function initializeFormInterception() {
    console.log("product-discount-price.js: initializeFormInterception");
    if (formInterceptionInitialized) {
      return;
    }

    var addToCartButton = document.querySelector("#AddToCart");
    if (!addToCartButton) {
      return;
    }

    var form = addToCartButton.closest("form");
    if (!form) {
      return;
    }

    if (form.dataset.formInterceptionInitialized) {
      return;
    }

    form.dataset.formInterceptionInitialized = "true";
    formInterceptionInitialized = true;

    var productFormElement = form.closest("product-form");
    if (form) {
      var formSubmitted = false;
      var handleFormSubmit = function (e) {
        if (formSubmitted) {
          e.preventDefault();
          e.stopPropagation();
          e.stopImmediatePropagation();
          return false;
        }

        var discountsWrapper = document.querySelector(
          "[data-product-discounts-wrapper]"
        );
        if (!discountsWrapper) {
          formSubmitted = false;
          return;
        }

        var lockedPreference = null;
        try {
          lockedPreference = localStorage.getItem(
            "cartLockedDiscountPreference"
          );
        } catch (e) {
          console.error("[CART] Error checking locked preference:", e);
        }

        var activeButton = discountsWrapper.querySelector(
          ".discount-button.active"
        );
        var isButton2Active = false;
        if (activeButton) {
          isButton2Active = activeButton.id === "discount-button-2";
        }

        var shouldAddMontageProducts = false;
        if (lockedPreference === "2") {
          shouldAddMontageProducts = true;
        } else if (lockedPreference === "1") {
          shouldAddMontageProducts = false;
        } else {
          shouldAddMontageProducts = isButton2Active;
        }

        if (!shouldAddMontageProducts) {
          e.preventDefault();
          e.stopPropagation();
          e.stopImmediatePropagation();
          formSubmitted = true;

          var variantIdInput =
            form.querySelector('input[name="id"]') ||
            form.querySelector('select[name="id"]');
          var quantityInput = form.querySelector('input[name="quantity"]');
          var variantId = variantIdInput ? variantIdInput.value : null;
          var quantity = quantityInput
            ? parseInt(quantityInput.value || "1")
            : 1;

          if (!variantId) {
            console.error("[FORM-SUBMIT] No variant ID found");
            formSubmitted = false;
            return false;
          }

          fetch("/cart/add.js", {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              "X-Requested-With": "XMLHttpRequest",
              Accept: "application/json",
            },
            body: JSON.stringify({
              id: variantId,
              quantity: quantity,
            }),
          })
            .then(function (response) {
              if (response.ok) {
                return response.json();
              }
              throw new Error("Failed to add to cart");
            })
            .then(function (cartData) {
              var sectionsToRender = [
                {
                  id: "mini-cart",
                  section: "mini-cart",
                  selector: ".mini-cart__inner",
                },
              ];

              var sectionsParam = sectionsToRender
                .map(function (s) {
                  return s.section;
                })
                .join(",");

              return fetch(
                `/cart.js?sections=${sectionsParam}&sections_url=${encodeURIComponent(
                  window.location.pathname
                )}`
              )
                .then(function (res) {
                  return res.json();
                })
                .then(function (sectionsData) {
                  var usedUpdateMiniCart = false;
                  if (
                    sectionsData.sections &&
                    sectionsData.sections["mini-cart"] &&
                    typeof window.updateMiniCartFromSections === "function"
                  ) {
                    window.updateMiniCartFromSections(sectionsData, {
                      openDrawer: true,
                      updateBubbleCount: true,
                      cartData: cartData,
                    });

                    setTimeout(function () {
                      window.disableCartInteractions(
                        "product-discount-price.js:2017"
                      );
                    }, 100);
                    usedUpdateMiniCart = true;

                    if (cartData) {
                      cartData._usedUpdateMiniCart = true;
                    }

                    if (cartData) {
                      cartData._usedUpdateMiniCart = true;
                    }
                  } else {
                    sectionsToRender.forEach(function (section) {
                      var element = document.getElementById(section.id);
                      if (
                        element &&
                        sectionsData.sections &&
                        sectionsData.sections[section.section]
                      ) {
                        var selector = section.selector || element;
                        var elementToReplace =
                          typeof selector === "string"
                            ? element.querySelector(selector) || element
                            : selector;
                        if (elementToReplace) {
                          elementToReplace.innerHTML =
                            sectionsData.sections[section.section];
                        }

                        if (
                          section.id === "mini-cart" &&
                          typeof CartDrawer !== "undefined"
                        ) {
                          new CartDrawer();
                        }
                      }
                    });

                    document.dispatchEvent(new CustomEvent("cart:refresh"));
                    setTimeout(function () {
                      document.dispatchEvent(
                        new CustomEvent("cart-drawer:refresh")
                      );
                      if (
                        typeof window.applyCartDrawerDiscounts === "function"
                      ) {
                        window.applyCartDrawerDiscounts(
                          "product-discount-price.js: handleCartItemAdded line 2070"
                        );
                      }
                    }, 100);
                  }
                  return cartData;
                });
            })
            .then(function (cartData) {
              var discountsWrapper = document.querySelector(
                "[data-product-discounts-wrapper]"
              );
              if (!discountsWrapper) {
                formSubmitted = false;
                document.dispatchEvent(new CustomEvent("cart:refresh"));
                return;
              }

              var discountTitleToUse = "";
              var lockedPreference = null;
              try {
                lockedPreference = localStorage.getItem(
                  "cartLockedDiscountPreference"
                );
              } catch (e) {
                console.error("[CART] Error checking locked preference:", e);
              }

              if (lockedPreference && variantId) {
                var lockedButtonNumber = parseInt(lockedPreference, 10);
                var button1 =
                  discountsWrapper.querySelector("#discount-button-1");
                var button2 =
                  discountsWrapper.querySelector("#discount-button-2");
                var buttonToUse = null;
                if (lockedButtonNumber === 1 && button1) {
                  buttonToUse = button1;
                } else if (lockedButtonNumber === 2 && button2) {
                  buttonToUse = button2;
                }
                if (buttonToUse) {
                  discountTitleToUse =
                    buttonToUse.getAttribute("data-discount-title") || "";
                }
              }

              if (!discountTitleToUse && variantId) {
                var buttonMapping = window.getButtonDiscountMapping();
                if (buttonMapping && lockedPreference) {
                  if (lockedPreference === "1") {
                    discountTitleToUse = buttonMapping.button1 || "";
                  } else if (lockedPreference === "2") {
                    discountTitleToUse = buttonMapping.button2 || "";
                  }
                }
                if (!discountTitleToUse) {
                  var activeDiscountButton = discountsWrapper.querySelector(
                    ".discount-button.active"
                  );
                  if (activeDiscountButton) {
                    discountTitleToUse =
                      activeDiscountButton.getAttribute(
                        "data-discount-title"
                      ) || "";
                  }
                }
              }

              if (
                discountTitleToUse &&
                discountTitleToUse.trim() !== "" &&
                variantId
              ) {
                var discountsScript = discountsWrapper.querySelector(
                  'script[type="application/json"]'
                );
                if (discountsScript) {
                  try {
                    var discountsData = JSON.parse(
                      discountsScript.textContent.trim()
                    );
                    if (discountsData && Array.isArray(discountsData)) {
                      var exactDiscount = discountsData.find(function (d) {
                        return d.title === discountTitleToUse.trim();
                      });
                      if (
                        exactDiscount &&
                        exactDiscount.percentage !== undefined
                      ) {
                        window.saveVariantDiscount(
                          variantId,
                          discountTitleToUse.trim(),
                          exactDiscount.percentage
                        );
                      } else {
                        window.saveVariantDiscount(
                          variantId,
                          discountTitleToUse.trim(),
                          0
                        );
                      }
                    } else {
                      window.saveVariantDiscount(
                        variantId,
                        discountTitleToUse.trim(),
                        0
                      );
                    }
                  } catch (e) {
                    console.error(
                      "[CART] Error parsing discounts or saving variant discount:",
                      e
                    );
                    window.saveVariantDiscount(
                      variantId,
                      discountTitleToUse.trim(),
                      0
                    );
                  }
                } else {
                  window.saveVariantDiscount(
                    variantId,
                    discountTitleToUse.trim(),
                    0
                  );
                }
              }

              formSubmitted = false;

              document.dispatchEvent(new CustomEvent("cart:refresh"));

              if (!cartData || !cartData._usedUpdateMiniCart) {
                if (typeof window.openMiniCart === "function") {
                  window.openMiniCart();
                }
              }

              if (cartData && cartData.items) {
                var productItem = cartData.items[cartData.items.length - 1];
                document.dispatchEvent(
                  new CustomEvent("cart:item-added", {
                    detail: { product: productItem },
                  })
                );

                handleCartItemAdded(productItem);
              } else {
                console.warn(
                  "[FORM-SUBMIT] cartData.items not found (linked variants path), cartData:",
                  cartData
                );

                if (cartData) {
                  handleCartItemAdded(cartData);
                }
              }

              setTimeout(function () {
                if (typeof window.applyCartDrawerDiscounts === "function") {
                  window.applyCartDrawerDiscounts(
                    "product-discount-price.js: handleCartItemAdded line 2228"
                  );
                }
                applyCartPageDiscounts(
                  "product-discount-price.js: handleCartItemAdded line 2230"
                );
              }, 600);

              setTimeout(function () {
                document.dispatchEvent(new CustomEvent("cart-drawer:refresh"));
                if (typeof window.applyCartDrawerDiscounts === "function") {
                  window.applyCartDrawerDiscounts(
                    "product-discount-price.js: handleCartItemAdded line 2232"
                  );
                }
                applyCartPageDiscounts(
                  "product-discount-price.js: handleCartItemAdded line 2234"
                );
              }, 800);
            })
            .catch(function (error) {
              formSubmitted = false;
              console.error("[FORM-SUBMIT] Error adding to cart:", error);
            });

          return false;
        }

        var variantIdInput =
          form.querySelector('input[name="id"]') ||
          form.querySelector('select[name="id"]');
        if (variantIdInput) {
          var variantId = variantIdInput.value;
          if (variantId) {
            var linkedVariantsScript = document.querySelector(
              '[id^="linked-variants-data-"]'
            );
            if (linkedVariantsScript) {
              try {
                var linkedVariantsData = JSON.parse(
                  linkedVariantsScript.textContent.trim()
                );
                var linkedVariants = linkedVariantsData[variantId];
                if (
                  linkedVariants &&
                  Array.isArray(linkedVariants) &&
                  linkedVariants.length > 0
                ) {
                  e.preventDefault();
                  e.stopPropagation();
                  e.stopImmediatePropagation();
                  formSubmitted = true;

                  var quantityInput = form.querySelector(
                    'input[name="quantity"]'
                  );
                  var quantity = quantityInput
                    ? parseInt(quantityInput.value || "1")
                    : 1;

                  var productTitle = "";
                  var variantTitle = "";

                  var productTitleEl = document.querySelector(
                    ".product_title, h1.product_title"
                  );
                  if (productTitleEl) {
                    productTitle = productTitleEl.textContent.trim();
                  }

                  var variantSelects = document.querySelector(
                    "product-form__variants"
                  );
                  if (variantSelects && variantSelects.currentVariant) {
                    variantTitle = variantSelects.currentVariant.title || "";
                  } else {
                    var productJson = document.querySelector(
                      '[type="application/json"][data-product-json]'
                    );
                    if (productJson) {
                      try {
                        var productData = JSON.parse(productJson.textContent);
                        var selectedVariant = productData.variants?.find(
                          function (v) {
                            return String(v.id) === String(variantId);
                          }
                        );
                        if (selectedVariant) {
                          variantTitle = selectedVariant.title || "";
                        }
                      } catch (e) {
                        console.error("[CART] Error parsing product JSON:", e);
                      }
                    }
                  }

                  var propertyLabel = {
                    en: "For",
                    de: "Für",
                    fr: "Pour",
                    it: "Per",
                  };

                  var currentLocale = document.documentElement.lang || "en";
                  var langCode = currentLocale.split("-")[0].toLowerCase();
                  if (!propertyLabel[langCode]) {
                    langCode = "en";
                  }

                  var propertyKey = propertyLabel[langCode];

                  var combinedTitle = productTitle || "";
                  if (variantTitle && variantTitle !== "Default Title") {
                    if (combinedTitle) {
                      combinedTitle = combinedTitle + " " + variantTitle;
                    } else {
                      combinedTitle = variantTitle;
                    }
                  }

                  var itemsToAdd = [{ id: variantId, quantity: quantity }];
                  var linkedVariantIds = [];
                  linkedVariants.forEach(function (linkedVariant) {
                    if (
                      linkedVariant &&
                      linkedVariant.id &&
                      String(linkedVariant.id) !== String(variantId)
                    ) {
                      linkedVariantIds.push(String(linkedVariant.id));
                      var properties = {};
                      if (combinedTitle) {
                        properties[propertyKey] = combinedTitle;
                      }

                      itemsToAdd.push({
                        id: String(linkedVariant.id),
                        quantity: quantity,
                        properties: properties,
                      });
                    }
                  });

                  if (linkedVariantIds.length > 0) {
                    try {
                      var variantRelationships = JSON.parse(
                        localStorage.getItem("variantRelationships") || "{}"
                      );
                      variantRelationships[String(variantId)] =
                        linkedVariantIds;
                      localStorage.setItem(
                        "variantRelationships",
                        JSON.stringify(variantRelationships)
                      );
                    } catch (e) {
                      console.error(
                        "[CART] Error storing variant relationship:",
                        e
                      );
                    }
                  }

                  var discountTitleToUse = "";
                  var lockedPreference = null;
                  try {
                    lockedPreference = localStorage.getItem(
                      "cartLockedDiscountPreference"
                    );
                  } catch (e) {
                    console.error(
                      "[CART] Error checking locked preference:",
                      e
                    );
                  }

                  if (lockedPreference) {
                    var lockedButtonNumber = parseInt(lockedPreference, 10);
                    var button1 = document.querySelector("#discount-button-1");
                    var button2 = document.querySelector("#discount-button-2");
                    var buttonToUse = null;
                    if (lockedButtonNumber === 1 && button1) {
                      buttonToUse = button1;
                    } else if (lockedButtonNumber === 2 && button2) {
                      buttonToUse = button2;
                    }
                    if (buttonToUse) {
                      discountTitleToUse =
                        buttonToUse.getAttribute("data-discount-title") || "";
                    }
                  }

                  if (!discountTitleToUse) {
                    var activeDiscountButton = document.querySelector(
                      ".discount-button.active"
                    );
                    if (activeDiscountButton) {
                      discountTitleToUse =
                        activeDiscountButton.getAttribute(
                          "data-discount-title"
                        ) || "";
                    }
                  }

                  if (discountTitleToUse && discountTitleToUse.trim() !== "") {
                    var discountsScript = document.querySelector(
                      '[data-product-discounts-wrapper] script[type="application/json"]'
                    );
                    if (discountsScript) {
                      try {
                        var discountsData = JSON.parse(
                          discountsScript.textContent.trim()
                        );
                        if (discountsData && Array.isArray(discountsData)) {
                          var exactDiscount = discountsData.find(function (d) {
                            return d.title === discountTitleToUse.trim();
                          });
                          if (
                            exactDiscount &&
                            exactDiscount.percentage !== undefined
                          ) {
                            window.saveVariantDiscount(
                              variantId,
                              discountTitleToUse.trim(),
                              exactDiscount.percentage
                            );
                          } else {
                            window.saveVariantDiscount(
                              variantId,
                              discountTitleToUse.trim(),
                              0
                            );
                          }
                        } else {
                          window.saveVariantDiscount(
                            variantId,
                            discountTitleToUse.trim(),
                            0
                          );
                        }
                      } catch (e) {
                        console.error(
                          "[CART] Error parsing discounts or saving variant discount:",
                          e
                        );
                        window.saveVariantDiscount(
                          variantId,
                          discountTitleToUse.trim(),
                          0
                        );
                      }
                    } else {
                      window.saveVariantDiscount(
                        variantId,
                        discountTitleToUse.trim(),
                        0
                      );
                    }
                  }

                  var config = {
                    method: "POST",
                    headers: {
                      "Content-Type": "application/json",
                      "X-Requested-With": "XMLHttpRequest",
                      Accept: "application/json",
                    },
                    body: JSON.stringify({ items: itemsToAdd }),
                  };
                  fetch("/cart/add.js", config)
                    .then(function (response) {
                      if (response.ok) {
                        return response.json();
                      }
                      throw new Error("Network response was not ok");
                    })
                    .then(function (cartData) {
                      var sectionsToRender = [
                        {
                          id: "mini-cart",
                          section: "mini-cart",
                          selector: ".mini-cart__inner",
                        },
                      ];

                      var sectionsParam = sectionsToRender
                        .map(function (s) {
                          return s.section;
                        })
                        .join(",");

                      return fetch(
                        `/cart.js?sections=${sectionsParam}&sections_url=${encodeURIComponent(
                          window.location.pathname
                        )}`
                      )
                        .then(function (res) {
                          return res.json();
                        })
                        .then(function (sectionsData) {
                          sectionsToRender.forEach(function (section) {
                            var element = document.getElementById(section.id);
                            if (
                              element &&
                              sectionsData.sections &&
                              sectionsData.sections[section.section]
                            ) {
                              var selector = section.selector || element;
                              var elementToReplace =
                                typeof selector === "string"
                                  ? element.querySelector(selector) || element
                                  : selector;
                              if (elementToReplace) {
                                elementToReplace.innerHTML =
                                  sectionsData.sections[section.section];
                              }

                              if (
                                section.id === "mini-cart" &&
                                typeof CartDrawer !== "undefined"
                              ) {
                                new CartDrawer();
                              }
                            }
                          });
                          return cartData;
                        });
                    })
                    .then(function (cartData) {
                      formSubmitted = false;

                      document.dispatchEvent(new CustomEvent("cart:refresh"));

                      if (typeof window.openMiniCart === "function") {
                        window.openMiniCart();
                      }

                      if (cartData && cartData.items) {
                        var productItem =
                          cartData.items[cartData.items.length - 1];
                        document.dispatchEvent(
                          new CustomEvent("cart:item-added", {
                            detail: { product: productItem },
                          })
                        );
                      }
                    })
                    .catch(function (error) {
                      formSubmitted = false;
                      console.error(
                        "[CART] Error adding linked variants:",
                        error
                      );
                    });

                  return false;
                } else {
                  e.preventDefault();
                  e.stopPropagation();
                  e.stopImmediatePropagation();
                  formSubmitted = true;

                  var quantityInput = form.querySelector(
                    'input[name="quantity"]'
                  );
                  var quantity = quantityInput
                    ? parseInt(quantityInput.value || "1")
                    : 1;

                  fetch("/cart/add.js", {
                    method: "POST",
                    headers: {
                      "Content-Type": "application/json",
                      "X-Requested-With": "XMLHttpRequest",
                      Accept: "application/json",
                    },
                    body: JSON.stringify({
                      id: variantId,
                      quantity: quantity,
                    }),
                  })
                    .then(function (response) {
                      if (response.ok) {
                        return response.json();
                      }
                      throw new Error("Failed to add to cart");
                    })
                    .then(function (cartData) {
                      var sectionsToRender = [
                        {
                          id: "mini-cart",
                          section: "mini-cart",
                          selector: ".mini-cart__inner",
                        },
                      ];

                      var sectionsParam = sectionsToRender
                        .map(function (s) {
                          return s.section;
                        })
                        .join(",");

                      return fetch(
                        `/cart.js?sections=${sectionsParam}&sections_url=${encodeURIComponent(
                          window.location.pathname
                        )}`
                      )
                        .then(function (res) {
                          return res.json();
                        })
                        .then(function (sectionsData) {
                          sectionsToRender.forEach(function (section) {
                            var element = document.getElementById(section.id);
                            if (
                              element &&
                              sectionsData.sections &&
                              sectionsData.sections[section.section]
                            ) {
                              var selector = section.selector || element;
                              var elementToReplace =
                                typeof selector === "string"
                                  ? element.querySelector(selector) || element
                                  : selector;
                              if (elementToReplace) {
                                elementToReplace.innerHTML =
                                  sectionsData.sections[section.section];
                              }

                              if (
                                section.id === "mini-cart" &&
                                typeof CartDrawer !== "undefined"
                              ) {
                                new CartDrawer();
                              }
                            }
                          });
                          return cartData;
                        });
                    })
                    .then(function (cartData) {
                      var discountTitleToUse = "";
                      var lockedPreference = null;
                      try {
                        lockedPreference = localStorage.getItem(
                          "cartLockedDiscountPreference"
                        );
                      } catch (e) {
                        console.error(
                          "[CART] Error checking locked preference:",
                          e
                        );
                      }

                      if (lockedPreference == null) {
                        var activeDiscountButton = document.querySelector(
                          ".discount-button.active"
                        );
                        if (activeDiscountButton) {
                          var buttonId = activeDiscountButton.id;
                          var buttonNumber = null;
                          if (buttonId === "discount-button-1") {
                            buttonNumber = 1;
                          } else if (buttonId === "discount-button-2") {
                            buttonNumber = 2;
                          }
                          if (buttonNumber) {
                            try {
                              localStorage.setItem(
                                "cartLockedDiscountPreference",
                                String(buttonNumber)
                              );
                              lockedPreference = String(buttonNumber);
                            } catch (e) {
                              console.error(
                                "[CART] Error setting locked preference:",
                                e
                              );
                            }
                          }
                        }
                      }

                      if (lockedPreference && variantId) {
                        var lockedButtonNumber = parseInt(lockedPreference, 10);
                        var button1 =
                          document.querySelector("#discount-button-1");
                        var button2 =
                          document.querySelector("#discount-button-2");
                        var buttonToUse = null;
                        if (lockedButtonNumber === 1 && button1) {
                          buttonToUse = button1;
                        } else if (lockedButtonNumber === 2 && button2) {
                          buttonToUse = button2;
                        }
                        if (buttonToUse) {
                          discountTitleToUse =
                            buttonToUse.getAttribute("data-discount-title") ||
                            "";
                        }
                      }

                      if (!discountTitleToUse && variantId) {
                        var activeDiscountButton = document.querySelector(
                          ".discount-button.active"
                        );
                        if (activeDiscountButton) {
                          discountTitleToUse =
                            activeDiscountButton.getAttribute(
                              "data-discount-title"
                            ) || "";
                        }
                      }

                      if (
                        discountTitleToUse &&
                        discountTitleToUse.trim() !== "" &&
                        variantId
                      ) {
                        var discountsScript = document.querySelector(
                          '[data-product-discounts-wrapper] script[type="application/json"]'
                        );
                        if (discountsScript) {
                          try {
                            var discountsData = JSON.parse(
                              discountsScript.textContent.trim()
                            );
                            if (discountsData && Array.isArray(discountsData)) {
                              var exactDiscount = discountsData.find(function (
                                d
                              ) {
                                return d.title === discountTitleToUse.trim();
                              });
                              var discountPercentage = 0;
                              if (
                                exactDiscount &&
                                exactDiscount.percentage !== undefined
                              ) {
                                discountPercentage = exactDiscount.percentage;
                              }
                              window.saveVariantDiscount(
                                variantId,
                                discountTitleToUse.trim(),
                                discountPercentage
                              );
                            } else {
                              window.saveVariantDiscount(
                                variantId,
                                discountTitleToUse.trim(),
                                0
                              );
                            }
                          } catch (e) {
                            console.error(
                              "[CART] Error parsing discounts or saving variant discount:",
                              e
                            );
                            window.saveVariantDiscount(
                              variantId,
                              discountTitleToUse.trim(),
                              0
                            );
                          }
                        } else {
                          window.saveVariantDiscount(
                            variantId,
                            discountTitleToUse.trim(),
                            0
                          );
                        }
                      }

                      formSubmitted = false;

                      document.dispatchEvent(new CustomEvent("cart:refresh"));

                      if (typeof window.openMiniCart === "function") {
                        window.openMiniCart();
                      }

                      if (cartData && cartData.items) {
                        var productItem =
                          cartData.items[cartData.items.length - 1];
                        document.dispatchEvent(
                          new CustomEvent("cart:item-added", {
                            detail: { product: productItem },
                          })
                        );
                      }

                      setTimeout(function () {
                        applyCartDrawerDiscounts(
                          "product-discount-price.js: handleCartItemAdded line 2825"
                        );
                        applyCartPageDiscounts(
                          "product-discount-price.js: handleCartItemAdded line 2827"
                        );
                      }, 400);

                      setTimeout(function () {
                        applyCartDrawerDiscounts(
                          "product-discount-price.js: handleCartItemAdded line 2838"
                        );
                      }, 800);
                    })
                    .catch(function (error) {
                      formSubmitted = false;
                      console.error(
                        "[FORM-SUBMIT] Error adding to cart:",
                        error
                      );
                    });

                  return false;
                }
              } catch (err) {
                console.error("[CART] Error parsing linked variants:", err);
                e.preventDefault();
                e.stopPropagation();
                e.stopImmediatePropagation();
                formSubmitted = true;

                var quantityInput = form.querySelector(
                  'input[name="quantity"]'
                );
                var quantity = quantityInput
                  ? parseInt(quantityInput.value || "1")
                  : 1;

                fetch("/cart/add.js", {
                  method: "POST",
                  headers: {
                    "Content-Type": "application/json",
                    "X-Requested-With": "XMLHttpRequest",
                    Accept: "application/json",
                  },
                  body: JSON.stringify({
                    id: variantId,
                    quantity: quantity,
                  }),
                })
                  .then(function (response) {
                    if (response.ok) {
                      return response.json();
                    }
                    throw new Error("Failed to add to cart");
                  })
                  .then(function (cartData) {
                    var sectionsToRender = [
                      {
                        id: "mini-cart",
                        section: "mini-cart",
                        selector: ".mini-cart__inner",
                      },
                    ];

                    var sectionsParam = sectionsToRender
                      .map(function (s) {
                        return s.section;
                      })
                      .join(",");

                    return fetch(
                      `/cart.js?sections=${sectionsParam}&sections_url=${encodeURIComponent(
                        window.location.pathname
                      )}`
                    )
                      .then(function (res) {
                        return res.json();
                      })
                      .then(function (sectionsData) {
                        sectionsToRender.forEach(function (section) {
                          var element = document.getElementById(section.id);
                          if (
                            element &&
                            sectionsData.sections &&
                            sectionsData.sections[section.section]
                          ) {
                            var selector = section.selector || element;
                            var elementToReplace =
                              typeof selector === "string"
                                ? element.querySelector(selector) || element
                                : selector;
                            if (elementToReplace) {
                              elementToReplace.innerHTML =
                                sectionsData.sections[section.section];
                            }

                            if (
                              section.id === "mini-cart" &&
                              typeof CartDrawer !== "undefined"
                            ) {
                              new CartDrawer();
                            }
                          }
                        });
                        return cartData;
                      });
                  })
                  .then(function (cartData) {
                    var discountTitleToUse = "";
                    var lockedPreference = null;
                    try {
                      lockedPreference = localStorage.getItem(
                        "cartLockedDiscountPreference"
                      );
                    } catch (e) {
                      console.error(
                        "[CART] Error checking locked preference:",
                        e
                      );
                    }

                    if (lockedPreference && variantId) {
                      var lockedButtonNumber = parseInt(lockedPreference, 10);
                      var button1 =
                        document.querySelector("#discount-button-1");
                      var button2 =
                        document.querySelector("#discount-button-2");
                      var buttonToUse = null;
                      if (lockedButtonNumber === 1 && button1) {
                        buttonToUse = button1;
                      } else if (lockedButtonNumber === 2 && button2) {
                        buttonToUse = button2;
                      }
                      if (buttonToUse) {
                        discountTitleToUse =
                          buttonToUse.getAttribute("data-discount-title") || "";
                      }
                    }

                    if (!discountTitleToUse && variantId) {
                      var activeDiscountButton = document.querySelector(
                        ".discount-button.active"
                      );
                      if (activeDiscountButton) {
                        discountTitleToUse =
                          activeDiscountButton.getAttribute(
                            "data-discount-title"
                          ) || "";
                      }
                    }

                    if (
                      discountTitleToUse &&
                      discountTitleToUse.trim() !== "" &&
                      variantId
                    ) {
                      var discountsScript = document.querySelector(
                        '[data-product-discounts-wrapper] script[type="application/json"]'
                      );
                      if (discountsScript) {
                        try {
                          var discountsData = JSON.parse(
                            discountsScript.textContent.trim()
                          );
                          if (discountsData && Array.isArray(discountsData)) {
                            var exactDiscount = discountsData.find(function (
                              d
                            ) {
                              return d.title === discountTitleToUse.trim();
                            });
                            if (
                              exactDiscount &&
                              exactDiscount.percentage !== undefined
                            ) {
                              window.saveVariantDiscount(
                                variantId,
                                discountTitleToUse.trim(),
                                exactDiscount.percentage
                              );
                            } else {
                              window.saveVariantDiscount(
                                variantId,
                                discountTitleToUse.trim(),
                                0
                              );
                            }
                          } else {
                            window.saveVariantDiscount(
                              variantId,
                              discountTitleToUse.trim(),
                              0
                            );
                          }
                        } catch (e) {
                          console.error(
                            "[CART] Error parsing discounts or saving variant discount:",
                            e
                          );
                          window.saveVariantDiscount(
                            variantId,
                            discountTitleToUse.trim(),
                            0
                          );
                        }
                      } else {
                        window.saveVariantDiscount(
                          variantId,
                          discountTitleToUse.trim(),
                          0
                        );
                      }
                    }

                    formSubmitted = false;

                    document.dispatchEvent(new CustomEvent("cart:refresh"));

                    if (typeof window.openMiniCart === "function") {
                      window.openMiniCart();
                    }

                    if (cartData && cartData.items) {
                      var productItem =
                        cartData.items[cartData.items.length - 1];
                      document.dispatchEvent(
                        new CustomEvent("cart:item-added", {
                          detail: { product: productItem },
                        })
                      );

                      handleCartItemAdded(productItem);
                    } else {
                      console.warn(
                        "[FORM-SUBMIT] cartData.items not found (main path), cartData:",
                        cartData
                      );

                      if (cartData) {
                        handleCartItemAdded(cartData);
                      }
                    }

                    setTimeout(function () {
                      applyCartDrawerDiscounts(
                        "product-discount-price.js: handleCartItemAdded line 2839"
                      );
                      applyCartPageDiscounts(
                        "product-discount-price.js: handleCartItemAdded line 2841"
                      );
                    }, 400);
                  })
                  .catch(function (error) {
                    formSubmitted = false;
                    console.error("[FORM-SUBMIT] Error adding to cart:", error);
                  });

                return false;
              }
            } else {
              e.preventDefault();
              e.stopPropagation();
              e.stopImmediatePropagation();
              formSubmitted = true;

              var quantityInput = form.querySelector('input[name="quantity"]');
              var quantity = quantityInput
                ? parseInt(quantityInput.value || "1")
                : 1;

              fetch("/cart/add.js", {
                method: "POST",
                headers: {
                  "Content-Type": "application/json",
                  "X-Requested-With": "XMLHttpRequest",
                  Accept: "application/json",
                },
                body: JSON.stringify({
                  id: variantId,
                  quantity: quantity,
                }),
              })
                .then(function (response) {
                  if (response.ok) {
                    return response.json();
                  }
                  throw new Error("Failed to add to cart");
                })
                .then(function (cartData) {
                  var sectionsToRender = [
                    {
                      id: "mini-cart",
                      section: "mini-cart",
                      selector: ".mini-cart__inner",
                    },
                  ];

                  var sectionsParam = sectionsToRender
                    .map(function (s) {
                      return s.section;
                    })
                    .join(",");

                  return fetch(
                    `/cart.js?sections=${sectionsParam}&sections_url=${encodeURIComponent(
                      window.location.pathname
                    )}`
                  )
                    .then(function (res) {
                      return res.json();
                    })
                    .then(function (sectionsData) {
                      sectionsToRender.forEach(function (section) {
                        var element = document.getElementById(section.id);
                        if (
                          element &&
                          sectionsData.sections &&
                          sectionsData.sections[section.section]
                        ) {
                          var selector = section.selector || element;
                          var elementToReplace =
                            typeof selector === "string"
                              ? element.querySelector(selector) || element
                              : selector;
                          if (elementToReplace) {
                            elementToReplace.innerHTML =
                              sectionsData.sections[section.section];
                          }

                          if (
                            section.id === "mini-cart" &&
                            typeof CartDrawer !== "undefined"
                          ) {
                            new CartDrawer();
                          }
                        }
                      });
                      return cartData;
                    });
                })
                .then(function (cartData) {
                  formSubmitted = false;

                  document.dispatchEvent(new CustomEvent("cart:refresh"));

                  if (typeof window.openMiniCart === "function") {
                    window.openMiniCart();
                  }

                  if (cartData && cartData.items) {
                    var productItem = cartData.items[cartData.items.length - 1];

                    document.dispatchEvent(
                      new CustomEvent("cart:item-added", {
                        detail: { product: productItem },
                      })
                    );

                    handleCartItemAdded(productItem);
                  } else {
                    console.warn(
                      "[FORM-SUBMIT] cartData.items not found, cartData:",
                      cartData
                    );

                    if (cartData) {
                      handleCartItemAdded(cartData);
                    }
                  }

                  setTimeout(function () {
                    applyCartDrawerDiscounts(
                      "product-discount-price.js: handleCartItemAdded line 3079"
                    );
                    applyCartPageDiscounts(
                      "product-discount-price.js: handleCartItemAdded line 3081"
                    );
                  }, 400);
                })
                .catch(function (error) {
                  formSubmitted = false;
                  console.error("[FORM-SUBMIT] Error adding to cart:", error);
                });

              return false;
            }
          }
        }
      };
    }

    var submitHandled = false;
    var handleFormSubmitOnce = function (e) {
      if (submitHandled) {
        e.preventDefault();
        e.stopPropagation();
        e.stopImmediatePropagation();
        return false;
      }
      submitHandled = true;
      var result = handleFormSubmit(e);

      var discountsWrapper = document.querySelector(
        "[data-product-discounts-wrapper]"
      );
      if (!discountsWrapper) {
        submitHandled = false;
        return;
      }

      setTimeout(function () {
        submitHandled = false;
      }, 1000);
      return result;
    };

    form.addEventListener("submit", handleFormSubmitOnce, true);

    if (productFormElement) {
      var originalOnSubmit = productFormElement.onSubmitHandler;

      if (originalOnSubmit) {
        productFormElement.onSubmitHandler = function (evt) {
          if (formSubmitted) {
            evt.preventDefault();
            evt.stopPropagation();
            evt.stopImmediatePropagation();
            return false;
          }
          return originalOnSubmit.call(this, evt);
        };
      }
      productFormElement.addEventListener("submit", handleFormSubmitOnce, true);
    }

    form.addEventListener("submit", function (e) {
      if (formSubmitted) {
        e.preventDefault();
        e.stopPropagation();
        e.stopImmediatePropagation();
        return false;
      }
      setTimeout(function () {
        try {
          var variantIdInput =
            form.querySelector('input[name="id"]') ||
            form.querySelector('select[name="id"]');
          if (variantIdInput) {
            var variantId = variantIdInput.value;
            if (variantId) {
              var variantIdStr = String(variantId).trim();
              var existingDiscount =
                window.getVariantDiscountData(variantIdStr);
              if (existingDiscount && existingDiscount.title) {
                return;
              }
              var activeDiscount = window.getDiscountPreferenceWithPriority();
              if (!activeDiscount || activeDiscount.trim() === "") {
                return;
              }
              var discountPercentage = 0;
              var selectedDiscountTitle = activeDiscount.trim();
              var discountsScript = document.querySelector(
                '[data-product-discounts-wrapper] script[type="application/json"]'
              );
              if (discountsScript && selectedDiscountTitle) {
                try {
                  var discounts = JSON.parse(
                    discountsScript.textContent.trim()
                  );
                  if (discounts && Array.isArray(discounts)) {
                    var exactDiscount = discounts.find(function (d) {
                      return d.title === selectedDiscountTitle;
                    });
                    if (
                      exactDiscount &&
                      exactDiscount.percentage !== undefined
                    ) {
                      discountPercentage = exactDiscount.percentage;
                      selectedDiscountTitle =
                        exactDiscount.title || selectedDiscountTitle;
                    }
                  }
                } catch (e) {
                  console.error(
                    "[DEBUG] Error parsing discounts in form submit:",
                    e
                  );
                }
              }

              setTimeout(function () {
                try {
                  window.saveVariantDiscount(
                    variantIdStr,
                    selectedDiscountTitle,
                    discountPercentage
                  );
                } catch (e) {
                  console.error(
                    "[DEBUG] Error saving variant discount in form submit:",
                    e
                  );
                }
              }, 500);
            }
          }
        } catch (e) {
          console.error("[DEBUG] Error in form submit listener:", e);
        }
      }, 300);
    });
  }

  if (isProductPage) {
    initializeFormInterception();
  }

  if (typeof window.applyCartDrawerDiscounts === "undefined") {
    window.applyCartDrawerDiscounts = function (debugMessage) {
      if (isCartPage) {
        return;
      }
      console.log(
        "product-discount-price.js: applyCartDrawerDiscounts:" + debugMessage
      );
      fetch("/cart.js")
        .then(function (response) {
          return response.json();
        })
        .then(function (cartData) {
          setTimeout(function () {
            applyCartDrawerDiscountsInternal(cartData);
          }, 100);
        })
        .catch(function (error) {
          console.error("[DRAWER] Error fetching cart data:", error);
          setTimeout(function () {
            applyCartDrawerDiscountsInternal(null);
          }, 100);
        });
    };

    function applyCartDrawerDiscountsInternal(cartData) {
      console.log(
        "product-discount-price.js: applyCartDrawerDiscountsInternal"
      );
      setTimeout(function () {
        if (hasUserRemovedDiscountGlobal()) {
          console.log(
            "[DRAWER] User removed discount - skipping discount application"
          );
          recomputeDrawerSubtotalFromDOM(
            "product-discount-price.js: applyCartDrawerDiscountsInternal - user removed discount"
          );
          return;
        }

        var userHasNoDiscountPreference = false;
        if (typeof window.hasNoDiscountPreference === "function") {
          userHasNoDiscountPreference = window.hasNoDiscountPreference();
        } else {
          try {
            userHasNoDiscountPreference =
              localStorage.getItem("activeDiscountTitle") === "__no_discount__";
          } catch (e) {
            userHasNoDiscountPreference = false;
          }
        }

        if (userHasNoDiscountPreference) {
          var allDrawerItems = document.querySelectorAll(
            ".mini-cart__line-item"
          );
          allDrawerItems.forEach(function (item) {
            try {
              var shopifyPill = item.querySelector(".custom-discount-pill");
              if (shopifyPill) shopifyPill.remove();
              var customPill = item.querySelector(
                '.selected-applied-discount[id="applied-discount-cart-drawer"]'
              );
              if (customPill) customPill.remove();
              var priceSpan = item.querySelector(
                ".mini-cart__price-list .price, .price"
              );
              if (priceSpan) {
                var amountElements = priceSpan.querySelectorAll(".amount");
                if (amountElements.length > 1) {
                  var originalCents = 0;
                  if (amountElements[0]) {
                    var originalText = amountElements[0].textContent.trim();
                    originalCents = window.parseMoneyTextToCents(originalText);
                  } else {
                    var amountEl = priceSpan.querySelector(".amount");
                    if (amountEl) {
                      var priceText = amountEl.textContent.trim();
                      originalCents = window.parseMoneyTextToCents(priceText);
                    }
                  }
                  if (originalCents > 0) {
                    var cce =
                      window.currencyCodeEnabled !== undefined
                        ? window.currencyCodeEnabled
                        : true;
                    var formattedPrice = window.formatMoney(originalCents, cce);
                    var qtyText = item.querySelector(
                      ".quantity-selector__value"
                    );
                    var quantity = 1;
                    if (qtyText) {
                      var qtyMatch = qtyText.textContent.match(/\d+/);
                      if (qtyMatch) quantity = parseInt(qtyMatch[0]);
                    }
                    for (var i = 1; i < amountElements.length; i++) {
                      amountElements[i].remove();
                    }
                    priceSpan.innerHTML =
                      '<span class="mini-quantity">' +
                      quantity +
                      "×</span> " +
                      '<span class="amount">' +
                      formattedPrice +
                      "</span>";
                  }
                }
              }
            } catch (e) {
              console.error("[DEBUG] Error resetting drawer item:", e);
            }
          });
          recomputeDrawerSubtotalFromDOM(
            "product-discount-price.js: applyCartDrawerDiscountsInternal line 3483"
          );
          return;
        }
        var cartItems = document.querySelectorAll(".mini-cart__line-item");
        var drawerTotals = { original: 0, discounted: 0 };

        cartItems.forEach(function (item, itemIndex) {
          try {
            var isMontageProduct = false;
            var productHandle = item.getAttribute("data-product-handle");
            if (productHandle) {
              isMontageProduct =
                productHandle === "montage" ||
                productHandle === "montage-zubehor";
            }

            if (isMontageProduct) {
              var existingDiscountPill = item.querySelector(
                '.selected-applied-discount[id="applied-discount-cart-drawer"]'
              );
              if (existingDiscountPill) {
                existingDiscountPill.remove();
              }
              var shopifyPill = item.querySelector(".custom-discount-pill");
              if (shopifyPill) {
                shopifyPill.remove();
              }
              return;
            }

            var variantIdMatch = item.id.match(/CartDrawerItem-(\d+)/);
            var button = item.querySelector(".remove[data-id]");
            var variantId = null;

            variantId = item.getAttribute("data-variant-id");

            if (!variantId && item.dataset && item.dataset.variantId) {
              variantId = item.dataset.variantId;
            }
            if (!variantId && button) {
              variantId = button.getAttribute("data-id");
            }
            if (!variantId && variantIdMatch && cartData && cartData.items) {
              var itemIndex = parseInt(variantIdMatch[1], 10);

              if (itemIndex > 0 && itemIndex <= cartData.items.length) {
                var cartItem = cartData.items[itemIndex - 1];

                if (cartItem && cartItem.variant_id) {
                  variantId = String(cartItem.variant_id);
                }
              }
            }
            if (!variantId && variantIdMatch) {
              variantId = variantIdMatch[1];
            }

            if (variantId) {
              variantId = String(variantId).trim();
            }

            if (!variantId) {
              console.error(
                "[DRAWER-DEBUG] CRITICAL: No variant ID found for item!",
                {
                  itemId: item.id,
                  itemHTML: item.outerHTML.substring(0, 300),
                }
              );
              return;
            }

            var discountData = window.getVariantDiscountData(variantId);

            var buttonMapping = window.getButtonDiscountMapping();
            var assemblyPreference = window.getAssemblyPreference();
            var buttonNumber = assemblyPreference || 1;
            var targetDiscountTitle = null;

            if (
              buttonMapping &&
              (buttonMapping.button1 || buttonMapping.button2)
            ) {
              if (buttonNumber === 1) {
                targetDiscountTitle = buttonMapping.button1;
              } else if (buttonNumber === 2) {
                targetDiscountTitle = buttonMapping.button2;
              }
            }

            var variantDiscountsAttr = item.getAttribute(
              "data-variant-discounts"
            );

            try {
              var noDiscountVariants = JSON.parse(
                localStorage.getItem("noDiscountVariants") || "[]"
              );
              if (noDiscountVariants.indexOf(variantId) !== -1) {
                return;
              }
            } catch (e) {
              console.error(
                "[DRAWER-DEBUG] Error checking no-discount variants:",
                e
              );
            }

            if (variantDiscountsAttr && targetDiscountTitle) {
              try {
                var variantDiscounts = JSON.parse(variantDiscountsAttr);
                if (
                  variantDiscounts &&
                  Array.isArray(variantDiscounts) &&
                  variantDiscounts.length > 0
                ) {
                  var needsUpdate = false;

                  if (
                    !discountData ||
                    !discountData.title ||
                    discountData.title !== targetDiscountTitle
                  ) {
                    needsUpdate = true;
                  }

                  if (needsUpdate || !discountData || !discountData.title) {
                    var foundDiscount = variantDiscounts.find(function (d) {
                      return d.title && d.title.trim() === targetDiscountTitle;
                    });

                    if (foundDiscount) {
                      var discountPercentage = 0;
                      var discountValue = foundDiscount.value;

                      if (discountValue) {
                        if (discountValue.value !== undefined) {
                          var value = parseFloat(discountValue.value);
                          if (discountValue.type === "percentage") {
                            discountPercentage =
                              value <= 1 ? value * 100 : value;
                          } else {
                            discountPercentage = value * 100;
                          }
                        } else if (typeof discountValue === "number") {
                          discountPercentage =
                            discountValue <= 1
                              ? discountValue * 100
                              : discountValue;
                        } else if (typeof discountValue === "string") {
                          var parsed = parseFloat(discountValue);
                          discountPercentage =
                            parsed <= 1 ? parsed * 100 : parsed;
                        }
                      }

                      discountData = {
                        title: targetDiscountTitle,
                        percentage: discountPercentage,
                      };

                      window.saveVariantDiscount(
                        variantId,
                        targetDiscountTitle,
                        discountPercentage
                      );
                    }
                  }
                }
              } catch (e) {
                console.error(
                  "[DRAWER] Error parsing variant discounts from DOM:",
                  e
                );
              }
            }

            var priceSpan = item.querySelector(".price");
            var existingDiscountPill = item.querySelector(
              '.selected-applied-discount[id="applied-discount-cart-drawer"]'
            );
            var shopifyDiscountPill = item.querySelector(
              ".custom-discount-pill"
            );
            var userRemovedDiscount = false;
            if (typeof window.hasNoDiscountPreference === "function") {
              userRemovedDiscount = window.hasNoDiscountPreference();
            } else {
              try {
                userRemovedDiscount =
                  localStorage.getItem("activeDiscountTitle") ===
                  "__no_discount__";
              } catch (e) {
                userRemovedDiscount = false;
              }
            }

            if (shopifyDiscountPill) {
              if (userRemovedDiscount) {
                shopifyDiscountPill.remove();
                if (existingDiscountPill) {
                  existingDiscountPill.remove();
                }
                var priceSpan2 = item.querySelector(
                  ".mini-cart__price-list .price, .price"
                );
                if (priceSpan2) {
                  var amountElements2 = priceSpan2.querySelectorAll(".amount");
                  var originalPriceText2 =
                    amountElements2.length > 0
                      ? amountElements2[0].textContent.trim()
                      : "";
                  if (originalPriceText2) {
                    var originalCents2 =
                      window.parseMoneyTextToCents(originalPriceText2);
                    if (originalCents2 > 0) {
                      var quantity2 = 1;
                      var qtyText2 = item.querySelector(
                        ".quantity-selector__value"
                      );
                      if (qtyText2) {
                        var qtyMatch2 = (
                          qtyText2.textContent ||
                          qtyText2.value ||
                          ""
                        ).match(/\d+/);
                        if (qtyMatch2) {
                          quantity2 = parseInt(qtyMatch2[0]);
                        }
                      }
                      var lineTotalCents2 = originalCents2 * quantity2;
                      var currencyCodeEnabled2 =
                        window.currencyCodeEnabled !== undefined
                          ? window.currencyCodeEnabled
                          : true;
                      var formattedPrice2 = window.formatMoney(
                        originalCents2,
                        currencyCodeEnabled2
                      );

                      var amountElements2 =
                        priceSpan2.querySelectorAll(".amount");
                      if (amountElements2.length > 1) {
                        for (var i = 1; i < amountElements2.length; i++) {
                          amountElements2[i].remove();
                        }
                      }
                      priceSpan2.innerHTML =
                        '<span class="mini-quantity">' +
                        quantity2 +
                        "×</span> " +
                        '<span class="amount">' +
                        formattedPrice2 +
                        "</span>";
                      drawerTotals.original += lineTotalCents2;
                      drawerTotals.discounted += lineTotalCents2;
                    }
                  }
                }
                return;
              }
            }
            if (shopifyDiscountPill && !userRemovedDiscount) {
              if (
                discountData &&
                discountData.title &&
                discountData.title.trim() !== ""
              ) {
                shopifyDiscountPill.remove();
                if (existingDiscountPill) {
                  existingDiscountPill.remove();
                }
              } else {
                if (existingDiscountPill) {
                  existingDiscountPill.remove();
                }
                try {
                  var amountElements = item.querySelectorAll(".price .amount");
                  if (amountElements.length >= 2) {
                    var oTxt = amountElements[0].textContent.trim();
                    var dTxt = amountElements[1].textContent.trim();
                    var oMatch = oTxt.match(/[\d'.,]+/);
                    var dMatch = dTxt.match(/[\d'.,]+/);
                    if (oMatch && dMatch) {
                      var oCents = Math.round(
                        parseFloat(
                          oMatch[0].replace(/[']/g, "").replace(/,/g, ".")
                        ) * 100
                      );
                      var dCents = Math.round(
                        parseFloat(
                          dMatch[0].replace(/[']/g, "").replace(/,/g, ".")
                        ) * 100
                      );
                      var qtyEl = item.querySelector(
                        ".quantity-selector__value"
                      );
                      var qTxt = (
                        qtyEl?.textContent ||
                        qtyEl?.value ||
                        "1"
                      ).replace(/[^0-9]/g, "");
                      var q = parseInt(qTxt || "1");
                      drawerTotals.original += oCents * (isNaN(q) ? 1 : q);
                      drawerTotals.discounted += dCents * (isNaN(q) ? 1 : q);
                    }
                  }
                } catch (e) {
                  console.error(
                    "[DEBUG] Error processing Shopify discount:",
                    e
                  );
                }
                return;
              }
            }
            if (
              discountData &&
              discountData.title &&
              discountData.title.trim() !== ""
            ) {
              var shouldSkipPriceUpdate = false;
              if (
                priceSpan &&
                priceSpan.dataset.discountApplied === "true" &&
                existingDiscountPill
              ) {
                shouldSkipPriceUpdate = false;

                try {
                  var amountElements = item.querySelectorAll(".price .amount");
                  if (amountElements.length >= 2) {
                    var oTxt = amountElements[0].textContent.trim();
                    var dTxt = amountElements[1].textContent.trim();
                    var oMatch = oTxt.match(/[\d'.,]+/);
                    var dMatch = dTxt.match(/[\d'.,]+/);
                    if (oMatch && dMatch) {
                      var oCents = Math.round(
                        parseFloat(
                          oMatch[0].replace(/[']/g, "").replace(/,/g, ".")
                        ) * 100
                      );
                      var dCents = Math.round(
                        parseFloat(
                          dMatch[0].replace(/[']/g, "").replace(/,/g, ".")
                        ) * 100
                      );
                      var qtyEl = item.querySelector(
                        ".quantity-selector__value"
                      );
                      var qTxt = (
                        qtyEl?.textContent ||
                        qtyEl?.value ||
                        "1"
                      ).replace(/[^0-9]/g, "");
                      var q = parseInt(qTxt || "1");
                      drawerTotals.original += oCents * (isNaN(q) ? 1 : q);
                      drawerTotals.discounted += dCents * (isNaN(q) ? 1 : q);
                    }
                  }
                } catch (e) {}
              }
              if (!priceSpan) {
                return;
              }
              var originalPrice = 0;

              if (priceSpan) {
                var originalPriceAttr = priceSpan.getAttribute(
                  "data-original-price"
                );
                if (originalPriceAttr) {
                  var originalPriceCents = parseInt(originalPriceAttr, 10);
                  if (originalPriceCents > 0) {
                    originalPrice = originalPriceCents;
                  }
                }

                if (!originalPrice) {
                  var originalPriceText = priceSpan.textContent.trim();
                  var parsedOriginal =
                    window.parseMoneyTextToCents(originalPriceText);
                  if (parsedOriginal > 0) {
                    originalPrice = parsedOriginal;
                  }
                }
              }

              if (!originalPrice) {
                var originalLinePriceAttr = item.getAttribute(
                  "data-original-line-price"
                );
                if (originalLinePriceAttr) {
                  var originalLinePrice = parseInt(originalLinePriceAttr) || 0;
                  if (originalLinePrice > 0) {
                    var qtyEl = item.querySelector(".quantity-selector__value");
                    var qtyText = (
                      qtyEl?.textContent ||
                      qtyEl?.value ||
                      "1"
                    ).replace(/[^0-9]/g, "");
                    var qty = parseInt(qtyText || "1");
                    if (qty > 0) {
                      originalPrice = Math.round(originalLinePrice / qty);
                    } else {
                      originalPrice = originalLinePrice;
                    }
                  }
                }
              }

              if (!originalPrice) {
                var amountElements = priceSpan.querySelectorAll(".amount");
                if (amountElements.length > 0) {
                  var originalPriceText = amountElements[0].textContent.trim();
                  originalPrice =
                    window.parseMoneyTextToCents(originalPriceText);
                }
              }

              if (!originalPrice) {
                var dataOriginalPrice = item.getAttribute(
                  "data-original-price"
                );
                if (dataOriginalPrice) {
                  var dataPrice = parseInt(dataOriginalPrice) || 0;
                  if (dataPrice > 0) {
                    originalPrice = dataPrice;
                  }
                }
              }

              if (!originalPrice) {
                var insAmountEl = priceSpan.querySelector("ins .amount");
                if (insAmountEl) {
                  var insPriceText = insAmountEl.textContent.trim();
                  var insPrice = window.parseMoneyTextToCents(insPriceText);
                  if (
                    discountData.percentage > 0 &&
                    discountData.percentage < 100
                  ) {
                    originalPrice = Math.round(
                      insPrice / (1 - discountData.percentage / 100)
                    );
                  } else {
                    originalPrice = insPrice;
                  }
                }
              }

              if (!originalPrice) {
                var amountElements = priceSpan.querySelectorAll(".amount");
                if (
                  discountData.percentage > 0 &&
                  discountData.percentage < 100
                ) {
                  if (amountElements.length > 1) {
                    var discountedPriceText =
                      amountElements[1].textContent.trim();
                    var discountedPrice =
                      window.parseMoneyTextToCents(discountedPriceText);
                    if (discountedPrice > 0) {
                      originalPrice = Math.round(
                        discountedPrice / (1 - discountData.percentage / 100)
                      );
                    }
                  }

                  if (!originalPrice && amountElements.length > 0) {
                    var originalPriceText =
                      amountElements[0].textContent.trim();
                    var originalPriceValue =
                      window.parseMoneyTextToCents(originalPriceText);

                    if (originalPriceValue > 0 && discountData.percentage > 0) {
                      var potentialOriginal = Math.round(
                        originalPriceValue / (1 - discountData.percentage / 100)
                      );

                      originalPrice = potentialOriginal;
                    }
                  }
                }
              }

              if (!originalPrice) {
                var amountElements = priceSpan.querySelectorAll(".amount");
                if (amountElements.length > 0) {
                  var originalPriceText = amountElements[0].textContent.trim();
                  originalPrice =
                    window.parseMoneyTextToCents(originalPriceText);
                }
              }

              if (!originalPrice) {
                var amountSpan = priceSpan.querySelector(".amount");
                if (amountSpan) {
                  var originalPriceText = amountSpan.textContent.trim();
                  originalPrice =
                    window.parseMoneyTextToCents(originalPriceText);
                }
              }

              if (!originalPrice) return;
              var discountPercentage = discountData.percentage || 0;
              var displayDiscountTitle = discountData.title;

              if (
                discountData.percentage === undefined ||
                discountData.percentage === 0
              ) {
                var discountsScript =
                  document.querySelector("#cart-drawer-discounts-data") ||
                  document.querySelector(
                    '[data-product-discounts-wrapper] script[type="application/json"]'
                  );
                if (discountsScript) {
                  try {
                    var discounts = JSON.parse(
                      discountsScript.textContent.trim()
                    );
                    if (discounts && Array.isArray(discounts)) {
                      var exactMatch = discounts.find(function (d) {
                        return d.title === discountData.title;
                      });
                      if (exactMatch) {
                        discountPercentage = exactMatch.percentage || 0;
                        displayDiscountTitle =
                          exactMatch.title || discountData.title;
                      }
                    }
                  } catch (e) {
                    console.error("[CART] Error resolving discount title:", e);
                  }
                }
              }
              if (!discountPercentage && existingDiscountPill) {
                try {
                  var pillText = existingDiscountPill.textContent || "";

                  var currencyCode = (window.shop_currency || "CHF").replace(
                    /[.*+?^${}()|[\]\\]/g,
                    "\\$&"
                  );
                  var mAmt = pillText.match(
                    new RegExp("-\\s*" + currencyCode + "\\s*([\\d'.,]+)", "i")
                  );
                  if (mAmt) {
                    var dCents = Math.round(
                      parseFloat(
                        mAmt[1].replace(/[']/g, "").replace(/,/g, ".")
                      ) * 100
                    );
                    if (originalPrice > 0 && dCents > 0) {
                      discountPercentage = Math.max(
                        0,
                        Math.min(100, (dCents / originalPrice) * 100)
                      );
                    }
                  }
                } catch (e) {}
              }
              if (discountPercentage > 0) {
                try {
                  var unitDiscountAmount = Math.round(
                    originalPrice * (discountPercentage / 100)
                  );
                  var finalPrice = originalPrice - unitDiscountAmount;
                  var qtyEl = item.querySelector(".quantity-selector__value");
                  var qtyText = (
                    qtyEl?.textContent ||
                    qtyEl?.value ||
                    "1"
                  ).replace(/[^0-9]/g, "");
                  var qty = parseInt(qtyText || "1");
                  var currencyCodeEnabled =
                    window.currencyCodeEnabled !== undefined
                      ? window.currencyCodeEnabled
                      : true;
                  var formattedOriginal = window.formatMoney(
                    originalPrice,
                    currencyCodeEnabled
                  );
                  var formattedFinal = window.formatMoney(
                    finalPrice,
                    currencyCodeEnabled
                  );
                  var quantityText = "";
                  var existingQuantity =
                    priceSpan.querySelector(".mini-quantity");
                  if (existingQuantity) {
                    quantityText = existingQuantity.textContent || "";
                  } else {
                    if (qtyEl) {
                      quantityText = qty + " ×";
                    }
                  }

                  priceSpan.innerHTML =
                    '<span class="mini-quantity">' +
                    quantityText +
                    "</span> " +
                    '<span class="amount price-original">' +
                    formattedOriginal +
                    "</span> " +
                    '<span class="amount price-discounted">' +
                    formattedFinal +
                    "</span>";

                  var originalLineTotal = originalPrice * qty;
                  var discountedLineTotal = finalPrice * qty;

                  try {
                    item.setAttribute(
                      "data-discounted-subtotal",
                      discountedLineTotal
                    );
                    item.setAttribute(
                      "data-original-line-price",
                      originalLineTotal
                    );

                    if (discountedLineTotal !== null) {
                      recomputeDrawerSubtotalFromDOM(
                        "product-discount-price.js: after setting discount attributes line 4070"
                      );
                    } else {
                      console.error(
                        "[DRAWER DEBUG] discountedLineTotal is null: " +
                          discountedLineTotal
                      );
                    }
                  } catch (attrError) {
                    console.error(
                      "[DRAWER DEBUG] Error setting discount attributes:",
                      attrError
                    );
                  }

                  var discountPill = item.querySelector(
                    '.selected-applied-discount[id="applied-discount-cart-drawer"]'
                  );
                  if (!discountPill) {
                    var discountPillHtml =
                      '<div class="selected-applied-discount" id="applied-discount-cart-drawer">' +
                      '<span><svg width="12" height="12" aria-hidden="true" focusable="false" role="presentation" class="icon icon-discount" viewBox="0 0 12 12"><path fill-rule="evenodd" clip-rule="evenodd" d="M7 0h3a2 2 0 012 2v3a1 1 0 01-.3.7l-6 6a1 1 0 01-1.4 0l-4-4a1 1 0 010-1.4l6-6A1 1 0 017 0zm2 2a1 1 0 102 0 1 1 0 00-2 0z" fill="currentColor"></path></svg></span>' +
                      "<span>" +
                      displayDiscountTitle +
                      "</span>" +
                      '<button type="button" class="discount-pill-remove" onclick="event.stopPropagation(); event.preventDefault(); window.removeDiscount && window.removeDiscount(\'' +
                      variantId +
                      '\'); return false;" aria-label="Remove discount" title="Remove discount">×</button>' +
                      "</div>";
                    var customPillContainer = item.querySelector(
                      ".mini-cart__product-info"
                    );

                    var insertionPoint = null;
                    var insertionMethod = "beforebegin";

                    if (customPillContainer) {
                      var priceSpanParent = priceSpan.parentElement;
                      if (
                        priceSpanParent &&
                        priceSpanParent === customPillContainer
                      ) {
                        var walker = document.createTreeWalker(
                          customPillContainer,
                          NodeFilter.SHOW_COMMENT | NodeFilter.SHOW_ELEMENT,
                          null,
                          false
                        );
                        var node;
                        while ((node = walker.nextNode())) {
                          if (node.nodeType === Node.COMMENT_NODE) {
                            var commentText = node.textContent.trim();
                            if (
                              commentText.includes("CUSTOM DISCOUNT PILL START")
                            ) {
                              foundStartComment = true;
                              insertionPoint = node;
                              insertionMethod = "afterend";
                              break;
                            }
                          }
                        }

                        if (!insertionPoint) {
                          var existingPills =
                            customPillContainer.querySelectorAll(
                              ".custom-discount-pill, .selected-applied-discount"
                            );
                          if (existingPills.length > 0) {
                            insertionPoint =
                              existingPills[existingPills.length - 1];
                            insertionMethod = "afterend";
                          } else {
                            insertionPoint = priceSpan;
                            insertionMethod = "beforebegin";
                          }
                        }
                      } else {
                        insertionPoint = priceSpan;
                        insertionMethod = "beforebegin";
                      }
                    } else {
                      var customPillEnd = item.querySelector(
                        ".custom-discount-pill:last-of-type, .selected-applied-discount:last-of-type"
                      );
                      if (customPillEnd) {
                        insertionPoint = customPillEnd;
                        insertionMethod = "afterend";
                      } else if (priceSpan) {
                        insertionPoint = priceSpan;
                        insertionMethod = "beforebegin";
                      }
                    }

                    if (insertionPoint) {
                      try {
                        if (insertionPoint.nodeType === Node.COMMENT_NODE) {
                          var tempDiv = document.createElement("div");
                          insertionPoint.parentNode.insertBefore(
                            tempDiv,
                            insertionPoint.nextSibling
                          );
                          tempDiv.innerHTML = discountPillHtml;
                          var pillElement = tempDiv.firstElementChild;
                          if (pillElement) {
                            tempDiv.parentNode.replaceChild(
                              pillElement,
                              tempDiv
                            );
                          } else {
                            tempDiv.remove();
                          }
                        } else {
                          insertionPoint.insertAdjacentHTML(
                            insertionMethod,
                            discountPillHtml
                          );
                        }
                      } catch (insertError) {
                        console.error(
                          "[DRAWER-DEBUG] Error inserting discount pill:",
                          insertError,
                          {
                            variantId: variantId,
                            insertionPoint: insertionPoint,
                            insertionMethod: insertionMethod,
                          }
                        );
                      }
                    } else {
                      console.error(
                        "[DRAWER-DEBUG] Could not find insertion point for discount pill, variant:",
                        variantId,
                        {
                          customPillContainer: !!customPillContainer,
                          priceSpan: !!priceSpan,
                        }
                      );
                    }
                  } else if (existingDiscountPill) {
                    var textSpan =
                      existingDiscountPill.querySelector("span:last-child");
                    if (textSpan) {
                      textSpan.textContent = displayDiscountTitle;
                    }
                    var removeBtn = existingDiscountPill.querySelector(
                      ".discount-pill-remove"
                    );
                    if (!removeBtn) {
                      var removeBtnHtml =
                        '<button type="button" class="discount-pill-remove" onclick="event.stopPropagation(); event.preventDefault(); window.removeDiscount && window.removeDiscount(\'' +
                        variantId +
                        '\'); return false;" aria-label="Remove discount" title="Remove discount">×</button>';
                      existingDiscountPill.insertAdjacentHTML(
                        "beforeend",
                        removeBtnHtml
                      );
                    }
                  }

                  priceSpan.dataset.discountApplied = "true";
                  var qtyEl = priceSpan
                    .closest(".mini-cart__line-item")
                    ?.querySelector(".quantity-selector__value");
                  var qtyText = (
                    qtyEl?.textContent ||
                    qtyEl?.value ||
                    "1"
                  ).replace(/[^0-9]/g, "");
                  var qty = parseInt(qtyText || "1");
                  var lineOrig = originalPrice * (isNaN(qty) ? 1 : qty);
                  var lineDisc = finalPrice * (isNaN(qty) ? 1 : qty);
                  drawerTotals.original += lineOrig;
                  drawerTotals.discounted += lineDisc;
                  try {
                    item.dataset.originalSubtotal = String(lineOrig);
                    item.dataset.discountedSubtotal = String(lineDisc);
                  } catch (e) {}
                } catch (e) {
                  console.error("[CART] Error applying discount:", e);
                }
              }
            } else {
              if (existingDiscountPill) {
                existingDiscountPill.remove();
              }
              if (priceSpan && priceSpan.dataset.discountApplied === "true") {
                delete priceSpan.dataset.discountApplied;
              }
              try {
                var amountElements = item.querySelectorAll(".price .amount");
                if (amountElements.length >= 2) {
                  var oTxt2 = amountElements[0].textContent.trim();
                  var dTxt2 = amountElements[1].textContent.trim();
                  var om2 = oTxt2.match(/[\d'.,]+/);
                  var dm2 = dTxt2.match(/[\d'.,]+/);
                  if (om2 && dm2) {
                    var oC2 = Math.round(
                      parseFloat(
                        om2[0].replace(/[']/g, "").replace(/,/g, ".")
                      ) * 100
                    );
                    var dC2 = Math.round(
                      parseFloat(
                        dm2[0].replace(/[']/g, "").replace(/,/g, ".")
                      ) * 100
                    );
                    var qtyEl2 = item.querySelector(
                      ".quantity-selector__value"
                    );
                    var qTxt2 = (
                      qtyEl2?.textContent ||
                      qtyEl2?.value ||
                      "1"
                    ).replace(/[^0-9]/g, "");
                    var q2 = parseInt(qTxt2 || "1");
                    drawerTotals.original += oC2 * (isNaN(q2) ? 1 : q2);
                    drawerTotals.discounted += dC2 * (isNaN(q2) ? 1 : q2);
                    return;
                  }
                }
              } catch (e) {}
              var centsNo = 0;
              var dsOrig = parseInt(item.dataset.originalPrice || "0");
              if (dsOrig && !isNaN(dsOrig)) {
                centsNo = dsOrig;
              } else {
                var amountSpanNo = item.querySelector(".price .amount");
                if (amountSpanNo) {
                  var txtNo = amountSpanNo.textContent.trim();
                  var mNo = txtNo.match(/[\d'.,]+/);
                  if (mNo) {
                    centsNo = Math.round(
                      parseFloat(
                        mNo[0].replace(/[']/g, "").replace(/,/g, ".")
                      ) * 100
                    );
                  }
                }
              }
              if (centsNo) {
                var qtyElNo = item.querySelector(".quantity-selector__value");
                var qtyTextNo = (
                  qtyElNo?.textContent ||
                  qtyElNo?.value ||
                  "1"
                ).replace(/[^0-9]/g, "");
                var qtyNo = parseInt(qtyTextNo || "1");
                var lineNo = centsNo * (isNaN(qtyNo) ? 1 : qtyNo);
                drawerTotals.original += lineNo;
                drawerTotals.discounted += lineNo;
              }
            }
          } catch (e) {
            console.error(
              "[DEBUG] Error processing cart item in applyCartDrawerDiscounts:",
              e
            );
          }
        });
      }, 100);
    }
  }

  document.addEventListener("cart:refresh", function () {
    if (cartRefreshTimeout) {
      clearTimeout(cartRefreshTimeout);
    }

    cartRefreshTimeout = setTimeout(function () {
      cartRefreshTimeout = null;

      setTimeout(function () {
        if (typeof window.applyCartDrawerDiscounts === "function") {
          window.applyCartDrawerDiscounts(
            "product-discount-price.js: cart:refresh line 4329"
          );
        } else {
          console.error(
            "product-discount-price.js: cart:refresh line 4329: applyCartDrawerDiscounts is not a function",
            window.applyCartDrawerDiscounts
          );
        }
        applyCartPageDiscounts(
          "product-discount-price.js: cart:refresh line 4335"
        );

        setTimeout(function () {
          recomputeDrawerSubtotalFromDOM(
            "product-discount-price.js: cart:refresh line 4382"
          );
          recomputeCartPageSubtotalFromDOM(
            "product-discount-price.js: cart:refresh line 4386"
          );
        }, 400);
      }, 500);
    }, 300);
  });

  document.addEventListener("cart:rerendered", function () {
    setTimeout(function () {
      if (typeof window.applyCartDrawerDiscounts === "function") {
        window.applyCartDrawerDiscounts(
          "product-discount-price.js: cart:rerendered line 4357"
        );
      }
      applyCartPageDiscounts(
        "product-discount-price.js: cart:rerendered line 4359"
      );

      setTimeout(function () {
        recomputeDrawerSubtotalFromDOM(
          "product-discount-price.js: cart:rerendered line 4409"
        );
        recomputeCartPageSubtotalFromDOM(
          "product-discount-price.js: cart:rerendered line 4410"
        );
      }, 400);
    }, 600);
  });
  document.addEventListener("line-item:change:end", function () {
    if (typeof window.applyCartDrawerDiscounts === "function") {
      window.applyCartDrawerDiscounts(
        "product-discount-price.js: line-item:change:end line 4377"
      );
    }
  });

  var applyCartPageDiscountsTimeout = null;
  var isApplyingCartPageDiscounts = false;
  var lastApplyTime = 0;
  var lastRetryScheduledTime = 0;

  function applyCartPageDiscounts(debugMessage) {
    if (!isCartPage) {
      return;
    }
    console.log(
      "product-discount-price.js: applyCartPageDiscounts: " + debugMessage
    );
    var now = Date.now();

    if (now - lastApplyTime < 500) {
      if (applyCartPageDiscountsTimeout) {
        clearTimeout(applyCartPageDiscountsTimeout);
      }
      applyCartPageDiscountsTimeout = setTimeout(function () {
        applyCartPageDiscounts(
          "product-discount-price.js: applyCartPageDiscounts line 4397"
        );
      }, 500 - (now - lastApplyTime));
      return;
    }

    if (applyCartPageDiscountsTimeout) {
      clearTimeout(applyCartPageDiscountsTimeout);
      applyCartPageDiscountsTimeout = null;
    }

    if (isApplyingCartPageDiscounts) {
      var timeSinceLastRetry = now - lastRetryScheduledTime;
      var timeSinceLastApply = now - lastApplyTime;

      if (timeSinceLastApply > 2000) {
        console.warn(
          "[DISCOUNT-DEBUG] applyCartPageDiscounts flag stuck for >2s, resetting",
          { timeSinceLastApply: timeSinceLastApply }
        );
        isApplyingCartPageDiscounts = false;
        applyCartPageDiscountsTimeout = null;
        lastRetryScheduledTime = 0;
      } else if (!applyCartPageDiscountsTimeout && timeSinceLastRetry > 300) {
        lastRetryScheduledTime = now;
        applyCartPageDiscountsTimeout = setTimeout(function () {
          applyCartPageDiscountsTimeout = null;
          applyCartPageDiscounts(
            "product-discount-price.js: applyCartPageDiscounts line 4423"
          );
        }, 300);
        return;
      } else {
        return;
      }
    }
    isApplyingCartPageDiscounts = true;
    lastApplyTime = now;

    var safetyTimeout = setTimeout(function () {
      if (isApplyingCartPageDiscounts) {
        isApplyingCartPageDiscounts = false;
        applyCartPageDiscountsTimeout = null;
        lastRetryScheduledTime = 0;
      }
    }, 5000);

    applyCartPageDiscountsTimeout = setTimeout(function () {
      try {
        if (isCartPage) {
          var rows = document.querySelectorAll('tr[id^="CartItem-"]');
        } else {
          var rows = document.querySelectorAll('[id^="CartDrawerItem-"]');
        }

        var userRemovedDiscountGlobal = hasUserRemovedDiscountGlobal();
        if (!userRemovedDiscountGlobal) {
          if (typeof window.hasNoDiscountPreference === "function") {
            userRemovedDiscountGlobal = window.hasNoDiscountPreference();
          } else {
            try {
              userRemovedDiscountGlobal =
                localStorage.getItem("activeDiscountTitle") ===
                "__no_discount__";
            } catch (e) {
              userRemovedDiscountGlobal = false;
            }
          }
        }

        if (userRemovedDiscountGlobal) {
          var allRows = isCartPage
            ? document.querySelectorAll('tr[id^="CartItem-"]')
            : document.querySelectorAll('[id^="CartDrawerItem-"]');
          allRows.forEach(function (row) {
            try {
              var shopifyPills = row.querySelectorAll(".discounts__discount");
              shopifyPills.forEach(function (pill) {
                pill.remove();
              });
              var customPill = row.querySelector(
                '#applied-discount-cart-page, .selected-applied-discount[id="applied-discount-cart-page"]'
              );
              if (customPill) customPill.remove();
              var unitPriceList = row.querySelector(".line-item__price-list");
              var priceSpan = unitPriceList
                ? unitPriceList.querySelector(".line-item__price")
                : null;
              if (priceSpan) {
                var originalCents = 0;
                var originalText = priceSpan.textContent.trim();
                originalCents = window.parseMoneyTextToCents(originalText);
                if (originalCents > 0) {
                  var cce =
                    window.currencyCodeEnabled !== undefined
                      ? window.currencyCodeEnabled
                      : true;
                  var formattedPrice = window.formatMoney(originalCents, cce);
                  priceSpan.innerHTML =
                    '<span class="amount">' + formattedPrice + "</span>";
                  var subtotalCell = row.querySelector(
                    ".line-item__line-price"
                  );
                  if (subtotalCell) {
                    var subtotalPriceSpan = subtotalCell.querySelector("span");
                    if (subtotalPriceSpan) {
                      var qtyInput =
                        row.querySelector('input[name="updates[]"]') ||
                        row.querySelector(".quantity-selector__value");
                      var quantity = 1;
                      if (qtyInput) {
                        quantity =
                          parseInt(
                            qtyInput.value ||
                              qtyInput.getAttribute("data-current-value") ||
                              "1",
                            10
                          ) || 1;
                      }
                      var lineTotal = originalCents * quantity;
                      var formattedLineTotal = window.formatMoney(
                        lineTotal,
                        cce
                      );
                      subtotalPriceSpan.innerHTML =
                        '<span class="amount">' +
                        formattedLineTotal +
                        "</span>";
                    }
                  }
                }
              }
            } catch (e) {
              console.error("[DEBUG] Error resetting row:", e);
            }
          });
          if (isCartPage) {
            recomputeCartPageSubtotalFromDOM(
              "product-discount-price.js: applyCartPageDiscounts line 4504"
            );
          } else {
            recomputeDrawerSubtotalFromDOM(
              "product-discount-price.js: applyCartPageDiscounts line 4581"
            );
          }
          return;
        }

        var pageTotals = { original: 0, discounted: 0 };

        rows.forEach(function (row) {
          try {
            var isMontageProduct = false;
            var productHandle = row.getAttribute("data-product-handle");
            if (productHandle) {
              isMontageProduct =
                productHandle === "montage" ||
                productHandle === "montage-zubehor";
            }

            if (isMontageProduct) {
              var existingPill = isCartPage
                ? row.querySelector(
                    "#applied-discount-cart-page, .selected-applied-discount[id='applied-discount-cart-page'], .discounts .selected-applied-discount"
                  )
                : row.querySelector(
                    '.selected-applied-discount[id="applied-discount-cart-drawer"]'
                  );
              if (existingPill) {
                existingPill.remove();
              }
              return;
            }
            var variantId = null;
            if (isCartPage) {
              var key = row.getAttribute("data-product-id") || "";
              var match = key.match(/^(\d+)/);
              if (!match) return;
              variantId = match[1];
            } else {
              variantId = row.getAttribute("data-variant-id");
              if (!variantId) {
                var idMatch = row.id.match(/CartDrawerItem-(\d+)/);
                if (idMatch) {
                  var cartData = window.cartData || null;
                  if (cartData && cartData.items) {
                    var itemIndex = parseInt(idMatch[1], 10) - 1;
                    if (itemIndex >= 0 && itemIndex < cartData.items.length) {
                      variantId = String(cartData.items[itemIndex].variant_id);
                    }
                  }
                }
              }
              if (!variantId) {
                return;
              }
              variantId = String(variantId).trim();
            }
            var discountData = window.getVariantDiscountData(variantId);

            var buttonMapping = window.getButtonDiscountMapping();
            var assemblyPreference = window.getAssemblyPreference();
            var buttonNumber = assemblyPreference || 1;
            var targetDiscountTitle = null;

            if (
              buttonMapping &&
              (buttonMapping.button1 || buttonMapping.button2)
            ) {
              if (buttonNumber === 1) {
                targetDiscountTitle = buttonMapping.button1;
              } else if (buttonNumber === 2) {
                targetDiscountTitle = buttonMapping.button2;
              }
            }

            var variantDiscountsAttr = row.getAttribute(
              "data-variant-discounts"
            );

            try {
              var noDiscountVariants = JSON.parse(
                localStorage.getItem("noDiscountVariants") || "[]"
              );
              if (noDiscountVariants.indexOf(variantId) !== -1) {
                return;
              }
            } catch (e) {
              console.error(
                "[CART-PAGE] Error checking no-discount variants:",
                e
              );
            }

            if (variantDiscountsAttr && targetDiscountTitle) {
              try {
                var variantDiscounts = JSON.parse(variantDiscountsAttr);
                if (
                  variantDiscounts &&
                  Array.isArray(variantDiscounts) &&
                  variantDiscounts.length > 0
                ) {
                  var needsUpdate = false;

                  if (
                    !discountData ||
                    !discountData.title ||
                    discountData.title !== targetDiscountTitle
                  ) {
                    needsUpdate = true;
                  }

                  if (needsUpdate || !discountData || !discountData.title) {
                    var foundDiscount = variantDiscounts.find(function (d) {
                      return d.title && d.title.trim() === targetDiscountTitle;
                    });

                    if (foundDiscount) {
                      var discountPercentage = 0;
                      var discountValue = foundDiscount.value;

                      if (discountValue) {
                        if (discountValue.value !== undefined) {
                          var value = parseFloat(discountValue.value);
                          if (discountValue.type === "percentage") {
                            discountPercentage =
                              value <= 1 ? value * 100 : value;
                          } else {
                            discountPercentage = value * 100;
                          }
                        } else if (typeof discountValue === "number") {
                          discountPercentage =
                            discountValue <= 1
                              ? discountValue * 100
                              : discountValue;
                        } else if (typeof discountValue === "string") {
                          var parsed = parseFloat(discountValue);
                          discountPercentage =
                            parsed <= 1 ? parsed * 100 : parsed;
                        }
                      }

                      discountData = {
                        title: targetDiscountTitle,
                        percentage: discountPercentage,
                      };

                      window.saveVariantDiscount(
                        variantId,
                        targetDiscountTitle,
                        discountPercentage
                      );
                    }
                  }
                }
              } catch (e) {
                console.error(
                  "[CART] Error parsing variant discounts from DOM:",
                  e
                );
              }
            }

            var unitPriceList = isCartPage
              ? row.querySelector(".line-item__price-list")
              : row.querySelector(".mini-cart__price-list");
            if (!unitPriceList && !isCartPage) {
              var productInfo = row.querySelector(".mini-cart__product-info");
              if (productInfo) {
                var allPriceLists = productInfo.querySelectorAll(
                  ".mini-cart__price-list"
                );
              }

              var altPriceList = row.querySelector(".mini-cart__price-list");
            }
            var unitPriceSpan = null;
            if (isCartPage) {
              unitPriceSpan = unitPriceList
                ? unitPriceList.querySelector(".line-item__price")
                : null;
            } else {
              if (unitPriceList) {
                unitPriceSpan =
                  unitPriceList.querySelector(".price.price--highlight") ||
                  unitPriceList.querySelector(".price:not(.price--compare)") ||
                  unitPriceList.querySelector(".price");
              }
            }
            var subtotalCell = isCartPage
              ? row.querySelector(".line-item__line-price")
              : null;
            var subtotalPriceSpan = subtotalCell
              ? subtotalCell.querySelector("span")
              : null;
            if (!unitPriceSpan) {
              return;
            }

            var existingPill = isCartPage
              ? row.querySelector(
                  '#applied-discount-cart-page, .selected-applied-discount[id="applied-discount-cart-page"], .line-item__discount-list #applied-discount-cart-page, .discounts #applied-discount-cart-page'
                )
              : row.querySelector(
                  '.selected-applied-discount[id="applied-discount-cart-drawer"]'
                );

            var allShopifyPills = isCartPage
              ? row.querySelectorAll(
                  ".discounts__discount:not(#applied-discount-cart-page)"
                )
              : row.querySelectorAll(".mini-cart__discount");

            var userRemovedDiscount = false;
            if (typeof window.hasNoDiscountPreference === "function") {
              userRemovedDiscount = window.hasNoDiscountPreference();
            } else {
              try {
                userRemovedDiscount =
                  localStorage.getItem("activeDiscountTitle") ===
                  "__no_discount__";
              } catch (e) {
                userRemovedDiscount = false;
              }
            }

            var shouldSkipPillRecreation = false;

            if (userRemovedDiscount) {
              allShopifyPills.forEach(function (pill) {
                pill.remove();
              });
              if (existingPill) {
                existingPill.remove();
              }
              var unitPriceList2 = isCartPage
                ? row.querySelector(".line-item__price-list")
                : row.querySelector(".mini-cart__price-list");
              var unitPriceSpan2 = null;
              if (isCartPage) {
                unitPriceSpan2 = unitPriceList2
                  ? unitPriceList2.querySelector(".line-item__price")
                  : null;
              } else {
                unitPriceSpan2 = unitPriceList2
                  ? unitPriceList2.querySelector(".price")
                  : null;
              }
              if (unitPriceSpan2) {
                if (unitPriceSpan2) {
                  var originalCents2 = 0;
                  var originalPriceText = unitPriceSpan2.textContent.trim();
                  originalCents2 =
                    window.parseMoneyTextToCents(originalPriceText);
                  if (originalCents2 > 0) {
                    var currencyCodeEnabled2 =
                      window.currencyCodeEnabled !== undefined
                        ? window.currencyCodeEnabled
                        : true;
                    var formattedPrice2 = window.formatMoney(
                      originalCents2,
                      currencyCodeEnabled2
                    );
                    var quantity2 = 1;
                    var qtyInput2 =
                      row.querySelector('input[name="updates[]"]') ||
                      row.querySelector(".quantity-selector__value");
                    if (qtyInput2) {
                      quantity2 =
                        parseInt(
                          qtyInput2.value ||
                            qtyInput2.getAttribute("data-current-value") ||
                            "1",
                          10
                        ) || 1;
                    }
                    var lineTotalCents2 = originalCents2 * quantity2;
                    var formattedLineTotal2 = window.formatMoney(
                      lineTotalCents2,
                      currencyCodeEnabled2
                    );
                    if (isCartPage) {
                      unitPriceSpan2.innerHTML =
                        '<span class="amount">' + formattedPrice2 + "</span>";
                    } else {
                      var qtyText2 = row.querySelector(
                        ".quantity-selector__value"
                      );
                      var quantityText2 = "";
                      if (qtyText2) {
                        var qtyValue2 =
                          qtyText2.value ||
                          qtyText2.getAttribute("data-current-value") ||
                          "1";
                        quantityText2 = qtyValue2 + " ×";
                      }
                      unitPriceSpan2.innerHTML =
                        (quantityText2
                          ? '<span class="mini-quantity">' +
                            quantityText2 +
                            "</span> "
                          : "") +
                        '<span class="amount">' +
                        formattedPrice2 +
                        "</span>";
                    }
                    var subtotalCell2 = isCartPage
                      ? row.querySelector(".line-item__line-price")
                      : null;
                    if (subtotalCell2) {
                      var subtotalPriceSpan2 =
                        subtotalCell2.querySelector("span");
                      if (subtotalPriceSpan2) {
                        var originalLinePrice = window.parseMoneyTextToCents(
                          subtotalPriceSpan2.textContent.trim()
                        );
                        if (originalLinePrice > 0) {
                          var formattedOriginalLineTotal = window.formatMoney(
                            originalLinePrice,
                            currencyCodeEnabled2
                          );
                          subtotalPriceSpan2.innerHTML =
                            '<span class="amount">' +
                            formattedOriginalLineTotal +
                            "</span>";
                        } else {
                          subtotalPriceSpan2.innerHTML =
                            '<span class="amount">' +
                            formattedLineTotal2 +
                            "</span>";
                        }
                      }
                    }
                  }
                }
              }
              return;
            }

            if (allShopifyPills.length > 0) {
              allShopifyPills.forEach(function (pill) {
                if (pill.id !== "applied-discount-cart-page") {
                  pill.remove();
                }
              });
            }

            if (existingPill) {
              if (
                discountData &&
                discountData.title &&
                discountData.title.trim() !== ""
              ) {
                var existingPillText = existingPill.textContent || "";
                var expectedDiscountText = discountData.title.trim();

                if (!existingPillText.includes(expectedDiscountText)) {
                  existingPill.remove();

                  existingPill = null;
                } else {
                  shouldSkipPillRecreation = true;
                }
              } else {
                if (!discountData || !discountData.title) {
                  return;
                }
              }
            }
            if (
              discountData &&
              discountData.title &&
              discountData.title.trim() !== ""
            ) {
              var qtyInput =
                row.querySelector('input[name="updates[]"]') ||
                row.querySelector(".quantity-selector__value");
              var quantity = 1;
              if (qtyInput) {
                quantity =
                  parseInt(
                    qtyInput.value ||
                      qtyInput.getAttribute("data-current-value") ||
                      "1",
                    10
                  ) || 1;
              }
              var discountPercentage = discountData.percentage || 0;
              var displayDiscountTitle = discountData.title;

              if (
                discountData.percentage === undefined ||
                discountData.percentage === 0
              ) {
                var ds =
                  document.querySelector("#main-cart-discounts-data") ||
                  document.querySelector(
                    '[data-product-discounts-wrapper] script[type="application/json"]'
                  );
                if (ds) {
                  try {
                    var discounts = JSON.parse(ds.textContent.trim());
                    if (discounts && Array.isArray(discounts)) {
                      var exactMatch = discounts.find(function (d) {
                        return d.title === discountData.title;
                      });
                      if (exactMatch) {
                        discountPercentage = exactMatch.percentage || 0;
                        displayDiscountTitle =
                          exactMatch.title || discountData.title;
                      }
                    }
                  } catch (e) {
                    console.error("[CART] Error resolving discount title:", e);
                  }
                }
              }

              var unitOriginal = 0;

              if (unitPriceSpan) {
                var originalPriceAttr = unitPriceSpan.getAttribute(
                  "data-original-price"
                );
                if (originalPriceAttr) {
                  var originalPriceCents = parseInt(originalPriceAttr, 10);
                  if (originalPriceCents > 0) {
                    unitOriginal = originalPriceCents;
                  }
                }

                if (!unitOriginal) {
                  var originalPriceText = unitPriceSpan.textContent.trim();
                  var parsedOriginal =
                    window.parseMoneyTextToCents(originalPriceText);
                  if (parsedOriginal > 0) {
                    unitOriginal = parsedOriginal;
                  }
                }
              }

              if (!unitOriginal && subtotalPriceSpan) {
                var subtotalOriginal = window.parseMoneyTextToCents(
                  subtotalPriceSpan.textContent.trim()
                );
                if (subtotalOriginal > 0) {
                  var qtyInputForPrice =
                    row.querySelector('input[name="updates[]"]') ||
                    row.querySelector(".quantity-selector__value");
                  var qtyForPrice = 1;
                  if (qtyInputForPrice) {
                    qtyForPrice =
                      parseInt(
                        qtyInputForPrice.value ||
                          qtyInputForPrice.getAttribute("data-current-value") ||
                          "1",
                        10
                      ) || 1;
                  }
                  if (qtyForPrice > 0) {
                    unitOriginal = Math.round(subtotalOriginal / qtyForPrice);
                  } else {
                    unitOriginal = subtotalOriginal;
                  }
                }
              }

              if (!unitOriginal && !isCartPage) {
                var originalPriceAttr = row.getAttribute("data-original-price");
                if (originalPriceAttr) {
                  var originalPriceCents = parseInt(originalPriceAttr, 10);
                  if (originalPriceCents > 0) {
                    unitOriginal = originalPriceCents;
                  }
                }
              }
              if (!unitOriginal) {
                var unitAmountEl = unitPriceSpan.querySelector(".amount");
                if (unitAmountEl) {
                  var txt = unitAmountEl.textContent.trim();
                  var parsedPrice = window.parseMoneyTextToCents(txt);
                  if (parsedPrice > 0) {
                    if (subtotalPriceSpan && quantity > 1) {
                      var subtotalText = subtotalPriceSpan.textContent.trim();
                      var subtotalCents =
                        window.parseMoneyTextToCents(subtotalText);

                      if (
                        subtotalCents > 0 &&
                        Math.abs(parsedPrice - subtotalCents) < 10
                      ) {
                        unitOriginal = Math.round(parsedPrice / quantity);
                      } else {
                        var estimatedUnitPrice = Math.round(
                          parsedPrice / quantity
                        );

                        if (
                          estimatedUnitPrice > 100 &&
                          (subtotalCents === 0 ||
                            Math.abs(
                              estimatedUnitPrice * quantity - subtotalCents
                            ) > 100)
                        ) {
                          unitOriginal = estimatedUnitPrice;
                        } else {
                          unitOriginal = parsedPrice;
                        }
                      }
                    } else {
                      unitOriginal = parsedPrice;
                    }
                  }
                }
              }
              if (!unitOriginal && unitPriceList) {
                var unitAttr = unitPriceList.getAttribute("data-price");
                if (unitAttr) {
                  var dataPriceValue = parseInt(unitAttr);
                  if (
                    dataPriceValue > 0 &&
                    discountPercentage > 0 &&
                    discountPercentage < 100
                  ) {
                    unitOriginal = Math.round(
                      dataPriceValue / (1 - discountPercentage / 100)
                    );
                  } else if (dataPriceValue > 0) {
                    unitOriginal = dataPriceValue;
                  }
                }
              }
              if (!unitOriginal) return;
              if (discountPercentage > 0) {
                var unitDiscount = Math.round(
                  unitOriginal * (discountPercentage / 100)
                );
                var unitFinal = unitOriginal - unitDiscount;
                var subtotalOriginal = unitOriginal * quantity;
                var subtotalDiscount = unitDiscount * quantity;
                var subtotalFinal = subtotalOriginal - subtotalDiscount;
                var cce =
                  window.currencyCodeEnabled !== undefined
                    ? window.currencyCodeEnabled
                    : true;
                var formattedUnitOriginal = window.formatMoney(
                  unitOriginal,
                  cce
                );
                var formattedUnitFinal = window.formatMoney(unitFinal, cce);
                if (unitPriceSpan && discountPercentage > 0) {
                  if (isCartPage) {
                    unitPriceSpan.innerHTML =
                      '<span class="amount price-original">' +
                      formattedUnitOriginal +
                      "</span> " +
                      '<span class="amount price-discounted">' +
                      formattedUnitFinal +
                      "</span>";
                  } else {
                    var qtyText = row.querySelector(
                      ".quantity-selector__value"
                    );
                    var quantityText = "";
                    if (qtyText) {
                      var qtyValue =
                        qtyText.value ||
                        qtyText.getAttribute("data-current-value") ||
                        "1";
                      quantityText = qtyValue + " ×";
                    }
                    unitPriceSpan.innerHTML =
                      (quantityText
                        ? '<span class="mini-quantity">' +
                          quantityText +
                          "</span> "
                        : "") +
                      '<span class="amount price-original">' +
                      formattedUnitOriginal +
                      "</span> " +
                      '<span class="amount price-discounted">' +
                      formattedUnitFinal +
                      "</span>";
                  }
                }
                var formattedSubtotalFinal = subtotalPriceSpan
                  ? window.formatMoney(subtotalFinal, cce)
                  : null;
                if (subtotalPriceSpan && formattedSubtotalFinal) {
                  var formattedSubtotalOriginal = window.formatMoney(
                    subtotalOriginal,
                    cce
                  );
                  subtotalPriceSpan.innerHTML =
                    '<span class="amount price-original">' +
                    formattedSubtotalOriginal +
                    "</span> " +
                    '<span class="amount price-discounted">' +
                    formattedSubtotalFinal +
                    "</span>";
                  try {
                    subtotalPriceSpan.style.display = "inline-flex";
                    subtotalPriceSpan.style.alignItems = "center";
                    subtotalPriceSpan.style.gap = "4px";
                    subtotalPriceSpan.style.flexWrap = "wrap";
                    subtotalPriceSpan.style.justifyContent = "flex-end";
                  } catch (e) {
                    console.error(
                      "[CART] Error setting subtotal price span styles:",
                      e
                    );
                  }
                }

                if (!shouldSkipPillRecreation) {
                  var currentExistingPill = isCartPage
                    ? row.querySelector(
                        '#applied-discount-cart-page, .selected-applied-discount[id="applied-discount-cart-page"], .line-item__discount-list #applied-discount-cart-page, .discounts #applied-discount-cart-page'
                      )
                    : row.querySelector(
                        '.selected-applied-discount[id="applied-discount-cart-drawer"]'
                      );
                  if (!currentExistingPill) {
                    if (isCartPage) {
                      var pillHtml =
                        '<li class="discounts__discount selected-applied-discount" id="applied-discount-cart-page">' +
                        '<span><svg width="12" height="12" aria-hidden="true" focusable="false" role="presentation" class="icon icon-discount" viewBox="0 0 12 12"><path fill-rule="evenodd" clip-rule="evenodd" d="M7 0h3a2 2 0 012 2v3a1 1 0 01-.3.7l-6 6a1 1 0 01-1.4 0l-4-4a1 1 0 010-1.4l6-6A1 1 0 017 0zm2 2a1 1 0 102 0 1 1 0 00-2 0z" fill="currentColor"></path></svg></span>' +
                        "<span>" +
                        displayDiscountTitle +
                        "</span>" +
                        '<button type="button" class="discount-pill-remove" onclick="event.stopPropagation(); event.preventDefault(); window.removeDiscount && window.removeDiscount(\'' +
                        variantId +
                        '\'); return false;" aria-label="Remove discount" title="Remove discount">×</button>' +
                        "</li>";

                      var shopifyDiscountList = row.querySelector(
                        ".line-item__discount-list"
                      );
                      if (shopifyDiscountList) {
                        shopifyDiscountList.insertAdjacentHTML(
                          "beforeend",
                          pillHtml
                        );
                      } else {
                        var discountsList = row.querySelector(".discounts");
                        if (discountsList) {
                          discountsList.insertAdjacentHTML(
                            "beforeend",
                            pillHtml
                          );
                        } else {
                          if (unitPriceList) {
                            var newList =
                              '<ul class="discounts" role="list">' +
                              pillHtml +
                              "</ul>";
                            unitPriceList.insertAdjacentHTML(
                              "afterend",
                              newList
                            );
                          } else {
                            var metaText =
                              row.querySelector(".cart__meta-text");
                            var insertAfter =
                              metaText || row.querySelector(".cart__meta h3");
                            if (insertAfter) {
                              var newList =
                                '<ul class="discounts" role="list">' +
                                pillHtml +
                                "</ul>";
                              insertAfter.insertAdjacentHTML(
                                "afterend",
                                newList
                              );
                            } else {
                              console.error(
                                "[DISCOUNT-DEBUG] Could not find insertion point for pill",
                                {
                                  variantId: variantId,
                                  hasShopifyDiscountList: !!shopifyDiscountList,
                                  hasDiscountsList: !!discountsList,
                                  hasUnitPriceList: !!unitPriceList,
                                  hasMetaText: !!metaText,
                                }
                              );
                            }
                          }
                        }
                      }
                    } else {
                      var pillHtml =
                        '<div class="selected-applied-discount" id="applied-discount-cart-drawer">' +
                        '<span><svg width="12" height="12" aria-hidden="true" focusable="false" role="presentation" class="icon icon-discount" viewBox="0 0 12 12"><path fill-rule="evenodd" clip-rule="evenodd" d="M7 0h3a2 2 0 012 2v3a1 1 0 01-.3.7l-6 6a1 1 0 01-1.4 0l-4-4a1 1 0 010-1.4l6-6A1 1 0 017 0zm2 2a1 1 0 102 0 1 1 0 00-2 0z" fill="currentColor"></path></svg></span>' +
                        "<span>" +
                        displayDiscountTitle +
                        "</span>" +
                        '<button type="button" class="discount-pill-remove" onclick="event.stopPropagation(); event.preventDefault(); window.removeDiscount && window.removeDiscount(\'' +
                        variantId +
                        '\'); return false;" aria-label="Remove discount" title="Remove discount">×</button>' +
                        "</div>";
                      var customPillContainer = row.querySelector(
                        ".mini-cart__product-info"
                      );
                      if (customPillContainer) {
                        if (unitPriceList && unitPriceList.parentNode) {
                          unitPriceList.insertAdjacentHTML(
                            "afterend",
                            pillHtml
                          );
                        } else {
                          customPillContainer.insertAdjacentHTML(
                            "beforeend",
                            pillHtml
                          );
                        }
                      } else {
                        console.error(
                          "[DISCOUNT-DEBUG] Could not find insertion point for cart drawer pill",
                          {
                            variantId: variantId,
                            hasProductInfo: !!customPillContainer,
                          }
                        );
                      }
                    }
                  }
                }

                if (shouldSkipPillRecreation && existingPill) {
                  var textSpan = existingPill.querySelector("span:last-child");
                  if (
                    textSpan &&
                    textSpan.textContent !== displayDiscountTitle
                  ) {
                    textSpan.textContent = displayDiscountTitle;
                  }
                  var removeBtn = existingPill.querySelector(
                    ".discount-pill-remove"
                  );
                  if (!removeBtn) {
                    var removeBtnHtml =
                      '<button type="button" class="discount-pill-remove" onclick="event.stopPropagation(); event.preventDefault(); window.removeDiscount && window.removeDiscount(\'' +
                      variantId +
                      '\'); return false;" aria-label="Remove discount" title="Remove discount">×</button>';
                    existingPill.insertAdjacentHTML("beforeend", removeBtnHtml);
                  }
                } else if (!shouldSkipPillRecreation) {
                  var finalExistingPill = isCartPage
                    ? row.querySelector(
                        '#applied-discount-cart-page, .selected-applied-discount[id="applied-discount-cart-page"], .line-item__discount-list #applied-discount-cart-page, .discounts #applied-discount-cart-page'
                      )
                    : row.querySelector(
                        '.selected-applied-discount[id="applied-discount-cart-drawer"]'
                      );
                  if (finalExistingPill) {
                    var textSpan =
                      finalExistingPill.querySelector("span:last-child");
                    if (textSpan) {
                      textSpan.textContent = displayDiscountTitle;
                    }
                    var removeBtn = finalExistingPill.querySelector(
                      ".discount-pill-remove"
                    );
                    if (!removeBtn) {
                      var removeBtnHtml =
                        '<button type="button" class="discount-pill-remove" onclick="event.stopPropagation(); event.preventDefault(); window.removeDiscount && window.removeDiscount(\'' +
                        variantId +
                        '\'); return false;" aria-label="Remove discount" title="Remove discount">×</button>';
                      finalExistingPill.insertAdjacentHTML(
                        "beforeend",
                        removeBtnHtml
                      );
                    }
                  }
                }
                pageTotals.original += subtotalOriginal;
                pageTotals.discounted += subtotalFinal;
              }
            } else {
              if (existingPill && !shouldSkipPillRecreation) {
                existingPill.remove();
              }
              var baseSubtotalAttr = row
                .querySelector(".product-subtotal")
                ?.getAttribute("data-subtotal");
              var baseSubtotal = baseSubtotalAttr
                ? parseInt(baseSubtotalAttr)
                : 0;
              if (baseSubtotal) {
                pageTotals.original += baseSubtotal;
                pageTotals.discounted += baseSubtotal;
              }
            }
          } catch (e) {
            console.error("[DISCOUNT-DEBUG] Error processing row:", row.id, e);
          }
        });
      } catch (e) {
        console.error(
          "[DISCOUNT-DEBUG] Error in applyCartPageDiscounts execution:",
          e
        );
      } finally {
        isApplyingCartPageDiscounts = false;
        applyCartPageDiscountsTimeout = null;
        lastRetryScheduledTime = 0;
        clearTimeout(safetyTimeout);
      }
    }, 150);
  }

  var cartUpdateTimeout = null;
  function handleCartPageUpdate() {
    console.log("product-discount-price.js: handleCartPageUpdate");

    if (!isCartPage) {
      return;
    }

    if (cartUpdateTimeout) {
      clearTimeout(cartUpdateTimeout);
    }

    cartUpdateTimeout = setTimeout(function () {
      cartUpdateTimeout = null;
      setTimeout(function () {
        applyCartPageDiscounts(
          "product-discount-price.js: handleCartPageUpdate line 5397"
        );
        setTimeout(recomputeCartPageSubtotalFromDOM, 200);
        try {
          setupCheckoutDiscountRedirects(
            "product-discount-price.js: handleCartPageUpdate line 5464"
          );
        } catch (e) {
          console.error("[CHK] update error", e);
        }
      }, 500);
    }, 300);
  }

  if (isCartPage) {
    document.addEventListener("cart:refresh", handleCartPageUpdate);
    document.addEventListener("line-item:change:end", handleCartPageUpdate);

    if (document.readyState === "loading") {
      document.addEventListener("DOMContentLoaded", function () {
        setTimeout(function () {
          try {
            setupCheckoutDiscountRedirects(
              "product-discount-price.js: handleCartPageUpdate line 5479"
            );
          } catch (e) {
            console.error(
              "[CHK] Error setting up redirects on cart page load:",
              e
            );
          }
        }, 700);
      });
    } else {
      setTimeout(function () {
        try {
          setupCheckoutDiscountRedirects(
            "product-discount-price.js: handleCartPageUpdate line 5492"
          );
        } catch (e) {
          console.error(
            "[CHK] Error setting up redirects on cart page load:",
            e
          );
        }
      }, 700);
    }
  }

  function handleMontageProductRemoval(debugMessage) {
    console.log(
      "product-discount-price.js: handleMontageProductRemoval: " + debugMessage
    );
    if (isRemovingProduct) {
      return;
    }
    isRemovingProduct = true;
    window.disableCartInteractions(
      "product-discount-price.js: handleMontageProductRemoval: "
    );
    var domItemsByVariantId = {};

    var drawerItems = document.querySelectorAll(
      ".mini-cart__line-item[data-variant-id][data-product-handle]"
    );
    drawerItems.forEach(function (item) {
      var variantId = item.getAttribute("data-variant-id");
      var handle = item.getAttribute("data-product-handle") || "";
      if (variantId && !domItemsByVariantId[variantId]) {
        domItemsByVariantId[variantId] = handle;
      }
    });

    var mainCartItems = document.querySelectorAll(
      "tr[id^='CartItem-'][data-variant-id][data-product-handle]"
    );
    mainCartItems.forEach(function (item) {
      var variantId = item.getAttribute("data-variant-id");
      var handle = item.getAttribute("data-product-handle") || "";
      if (variantId && !domItemsByVariantId[variantId]) {
        domItemsByVariantId[variantId] = handle;
      }
    });

    fetch("/cart.js")
      .then(function (response) {
        if (!response.ok) {
          throw new Error("Failed to fetch cart: " + response.status);
        }
        return response.json();
      })
      .then(function (cartData) {
        if (!cartData || !cartData.items || cartData.items.length === 0) {
          window.enableCartInteractions(
            "product-discount-price.js: handleMontageProductRemoval empty cart"
          );
          isRemovingProduct = false;
          return;
        }

        var montageKeysToRemove = [];
        var mainProductVariantIds = [];

        cartData.items.forEach(function (item) {
          var productHandle =
            domItemsByVariantId[String(item.variant_id)] || "";
          var isMontage =
            productHandle === "montage" || productHandle === "montage-zubehor";

          if (isMontage && item.key) {
            montageKeysToRemove.push(item.key);
          } else if (item.variant_id) {
            mainProductVariantIds.push(String(item.variant_id));
          }
        });

        var lockedDiscountTitle = null;
        var lockedDiscountPercentage = 0;

        var lockedButtonNumber = 1;
        try {
          var lockedPref = localStorage.getItem("cartLockedDiscountPreference");
          if (lockedPref) {
            lockedButtonNumber = parseInt(lockedPref, 10) || 1;
          }
        } catch (e) {
          console.error(
            "[MONTAGE] Error getting cartLockedDiscountPreference:",
            e
          );
        }

        try {
          var buttonMapping = localStorage.getItem("buttonDiscountMapping");
          if (buttonMapping) {
            var mapping = JSON.parse(buttonMapping);
            lockedDiscountTitle =
              lockedButtonNumber === 2 ? mapping.button2 : mapping.button1;
          }
        } catch (e) {
          console.error("[MONTAGE] Error getting buttonDiscountMapping:", e);
        }

        if (!lockedDiscountTitle) {
          var buttonSelector =
            lockedButtonNumber === 2
              ? "#discount-button-2"
              : "#discount-button-1, .discount-button[data-discount-title]";
          var discountButton = document.querySelector(buttonSelector);
          if (discountButton) {
            lockedDiscountTitle = discountButton.getAttribute(
              "data-discount-title"
            );
          }
        }

        if (lockedDiscountTitle) {
          try {
            var discountsScript = document.querySelector(
              'script[id^="discounts-data-"]'
            );
            if (discountsScript) {
              var discountsData = JSON.parse(discountsScript.textContent);
              if (discountsData && Array.isArray(discountsData)) {
                var foundDiscount = discountsData.find(function (discount) {
                  return (
                    discount.title &&
                    discount.title.trim() === lockedDiscountTitle
                  );
                });
                if (foundDiscount && foundDiscount.percentage !== undefined) {
                  lockedDiscountPercentage =
                    parseFloat(foundDiscount.percentage) || 0;
                }
              }
            }
          } catch (e) {
            console.error(
              "[MONTAGE] Error getting discounts from script tag:",
              e
            );
          }

          if (
            lockedDiscountPercentage === 0 &&
            mainProductVariantIds.length > 0
          ) {
            try {
              var variantDiscounts = JSON.parse(
                localStorage.getItem("variantDiscounts") || "{}"
              );

              for (var i = 0; i < mainProductVariantIds.length; i++) {
                var variantId = mainProductVariantIds[i];
                var existingDiscount = variantDiscounts[variantId];
                if (
                  existingDiscount &&
                  existingDiscount.title === lockedDiscountTitle &&
                  existingDiscount.percentage > 0
                ) {
                  lockedDiscountPercentage = existingDiscount.percentage;
                  break;
                }
              }
            } catch (e) {}
          }
        }

        var button1DiscountTitle = lockedDiscountTitle;
        var button1DiscountPercentage = lockedDiscountPercentage;

        if (button1DiscountTitle) {
          try {
            var variantDiscounts = JSON.parse(
              localStorage.getItem("variantDiscounts") || "{}"
            );
            mainProductVariantIds.forEach(function (variantId) {
              variantDiscounts[variantId] = {
                title: button1DiscountTitle,
                percentage: button1DiscountPercentage,
              };
            });
            localStorage.setItem(
              "variantDiscounts",
              JSON.stringify(variantDiscounts)
            );
          } catch (e) {
            console.error("[MONTAGE] Error updating discounts:", e);
          }

          try {
            localStorage.setItem("cartLockedDiscountPreference", "1");
            localStorage.setItem("assemblyPreference", "1");
          } catch (e) {
            console.error("[MONTAGE] Error locking discount preference:", e);
          }
        }

        if (montageKeysToRemove.length > 0) {
          var updates = {};
          montageKeysToRemove.forEach(function (key) {
            updates[key] = 0;
          });

          var sections = ["mini-cart"];
          if (isCartPage) {
            sections.push("main-cart");
          }

          fetch("/cart/update.js", {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              Accept: "application/json",
            },
            body: JSON.stringify({
              updates: updates,
              sections: sections,
              sections_url: window.location.pathname,
            }),
          })
            .then(function (response) {
              if (!response.ok) {
                throw new Error("Failed to update cart: " + response.status);
              }
              return response.json();
            })
            .then(function (cartResponse) {
              try {
                localStorage.removeItem("variantRelationships");
              } catch (e) {
                console.error(
                  "[MONTAGE] Error clearing variantRelationships:",
                  e
                );
              }

              if (!cartResponse.items || cartResponse.items.length === 0) {
                try {
                  localStorage.removeItem("cartLockedDiscountPreference");
                  clearUserRemovedDiscountGlobal();
                } catch (e) {
                  console.error(
                    "[MONTAGE] Error clearing locked discount preference:",
                    e
                  );
                }
              }

              if (
                cartResponse.item_count !== undefined &&
                typeof window.updateBubbleCount === "function"
              ) {
                window.updateBubbleCount(cartResponse.item_count);
              }

              if (cartResponse.sections) {
                if (isCartPage && cartResponse.sections["main-cart"]) {
                  var tempDiv = document.createElement("div");
                  tempDiv.innerHTML = cartResponse.sections["main-cart"];
                  var newSection = tempDiv.querySelector(
                    '[data-section-type="cart"]'
                  );
                  if (newSection) {
                    var existingSection = document.querySelector(
                      '[data-section-type="cart"]'
                    );
                    if (existingSection) {
                      var newTableWrapper =
                        newSection.querySelector(".table-wrapper");
                      var existingTableWrapper = document.querySelector(
                        ".cart-wrapper .table-wrapper"
                      );
                      if (newTableWrapper && existingTableWrapper) {
                        existingTableWrapper.innerHTML =
                          newTableWrapper.innerHTML;
                      } else {
                        existingSection.innerHTML = newSection.innerHTML;
                      }
                    }
                  }
                }

                if (cartResponse.sections["mini-cart"]) {
                  var drawerEl = document.getElementById("mini-cart");
                  if (drawerEl) {
                    var inner =
                      drawerEl.querySelector(".mini-cart__inner") || drawerEl;
                    inner.innerHTML = cartResponse.sections["mini-cart"];
                    var newCount = drawerEl.getAttribute("data-item-count");
                    if (
                      newCount &&
                      typeof window.updateBubbleCount === "function"
                    ) {
                      window.updateBubbleCount(newCount);
                    }
                  }
                }
              }

              if (isCartPage) {
                document.dispatchEvent(new CustomEvent("cart:refresh"));
              }

              document.dispatchEvent(new Event("theme:cart:refresh"));
              document.dispatchEvent(new Event("thb:cart:update"));

              if (!isCartPage) {
                document.dispatchEvent(new Event("cart-drawer:refresh"));
              }

              setTimeout(function () {
                window.enableCartInteractions(
                  "product-discount-price.js: handleMontageProductRemoval complete"
                );
                isRemovingProduct = false;
              }, 400);
            })
            .catch(function (error) {
              console.error("[MONTAGE] Error removing montage items:", error);
              window.enableCartInteractions(
                "product-discount-price.js: handleMontageProductRemoval error"
              );
              isRemovingProduct = false;
            });
        } else {
          if (isCartPage) {
            fetch("/?sections=main-cart,mini-cart")
              .then(function (response) {
                return response.json();
              })
              .then(function (sectionsData) {
                if (sectionsData && sectionsData.sections) {
                  var mainCartSection = sectionsData.sections["main-cart"];
                  var cartDrawerSection = sectionsData.sections["mini-cart"];
                  if (mainCartSection) {
                    var tempDiv = document.createElement("div");
                    tempDiv.innerHTML = mainCartSection;
                    var newSection = tempDiv.querySelector(
                      '[data-section-type="cart"]'
                    );
                    if (newSection) {
                      var existingSection = document.querySelector(
                        '[data-section-type="cart"]'
                      );
                      if (existingSection) {
                        var newTableWrapper =
                          newSection.querySelector(".table-wrapper");
                        var existingTableWrapper = document.querySelector(
                          ".cart-wrapper .table-wrapper"
                        );
                        if (newTableWrapper && existingTableWrapper) {
                          existingTableWrapper.innerHTML =
                            newTableWrapper.innerHTML;
                        } else {
                          existingSection.innerHTML = newSection.innerHTML;
                        }
                      }
                    }
                  }
                  if (cartDrawerSection) {
                    var drawerEl = document.getElementById("mini-cart");
                    if (drawerEl) {
                      var inner =
                        drawerEl.querySelector(".mini-cart__inner") || drawerEl;
                      inner.innerHTML = cartDrawerSection;
                    }
                  }
                }

                document.dispatchEvent(new CustomEvent("cart:refresh"));
                document.dispatchEvent(new Event("theme:cart:refresh"));
                document.dispatchEvent(new Event("thb:cart:update"));
                if (!isCartPage) {
                  document.dispatchEvent(new Event("cart-drawer:refresh"));
                }

                setTimeout(function () {
                  if (typeof window.applyCartDrawerDiscounts === "function") {
                    window.applyCartDrawerDiscounts(
                      "product-discount-price.js: handleMontageProductRemoval no montage"
                    );
                  }
                  if (
                    typeof window.recomputeDrawerSubtotalFromDOM ===
                      "function" &&
                    !isCartPage
                  ) {
                    window.recomputeDrawerSubtotalFromDOM(
                      "product-discount-price.js:6269 removeSequentially - update minicart DOM line 6270"
                    );
                  }
                }, 300);

                setTimeout(function () {
                  window.enableCartInteractions(
                    "product-discount-price.js:6269"
                  );
                  isRemovingProduct = false;
                  try {
                    setTimeout(
                      setupCheckoutDiscountRedirects,
                      500,
                      "product-discount-price.js:6261"
                    );
                  } catch (e) {
                    console.error(
                      "[CHK] Error setting up redirects after montage removal:",
                      e
                    );
                  }
                }, 400);
              })
              .catch(function (error) {
                console.error("[MONTAGE] Error fetching sections:", error);
                window.enableCartInteractions(
                  "product-discount-price.js:6290 error"
                );
                isRemovingProduct = false;
              });
          } else {
            setTimeout(function () {
              document.dispatchEvent(new CustomEvent("cart:refresh"));
              window.enableCartInteractions(
                "product-discount-price.js:6291 no cart page"
              );
              isRemovingProduct = false;
            }, 300);
          }
        }
      })
      .catch(function (error) {
        console.error(
          "[REMOVE-MONTAGE] Error in handleMontageProductRemoval:",
          error
        );
        window.enableCartInteractions(
          "product-discount-price.js: handleMontageProductRemoval error"
        );
        isRemovingProduct = false;
      });
  }

  var quantityChangeTimeout = null;
  var lastQuantityChange = {
    line: null,
    quantity: null,
    variantId: null,
    timestamp: 0,
  };
  var isSyncingMontage = false;
  var isRemovingProduct = false;

  var removeProductDebounceTimeout = null;
  var syncQueue = [];

  function updateDiscountsAfterQuantityChange() {
    console.log(
      "product-discount-price.js: updateDiscountsAfterQuantityChange"
    );
    setTimeout(function () {
      if (isCartPage) {
        setTimeout(function () {
          applyCartPageDiscounts(
            "product-discount-price.js: updateDiscountsAfterQuantityChange line 7633"
          );
        }, 300);
      } else {
        if (typeof window.applyCartDrawerDiscounts === "function") {
          window.applyCartDrawerDiscounts(
            "product-discount-price.js: updateDiscountsAfterQuantityChange line 7631"
          );
        }
      }

      setTimeout(function () {
        recomputeDrawerSubtotalFromDOM(
          "product-discount-price.js: updateDiscountsAfterQuantityChange line 7739"
        );
        recomputeCartPageSubtotalFromDOM(
          "product-discount-price.js: updateDiscountsAfterQuantityChange line 5853"
        );
      }, 300);
    }, 500);
  }

  function processSyncQueue() {
    console.log("product-discount-price.js: processSyncQueue");
    if (syncQueue.length === 0) {
      return;
    }

    if (isSyncingMontage) {
      setTimeout(processSyncQueue, 200);
      return;
    }

    var nextSync = syncQueue.shift();
    handleQuantityChangeSync(
      nextSync.line,
      nextSync.variantId,
      nextSync.quantity,
      function () {
        if (typeof nextSync.onComplete === "function") {
          nextSync.onComplete();
        }

        setTimeout(function () {
          processSyncQueue();
        }, 200);
      }
    );
  }

  function handleQuantityChangeSync(line, variantId, quantity, onComplete) {
    console.log(
      "product-discount-price.js: handleQuantityChangeSync",
      line,
      variantId,
      quantity
    );
    clearTimeout(quantityChangeTimeout);

    if (!line || !variantId || quantity === null) {
      onComplete?.();
      return;
    }

    if (isSyncingMontage) {
      if (quantity > 0) {
        syncQueue.push({ line, variantId, quantity, onComplete });
      }
      return;
    }

    const isRemoval = quantity === 0;
    const pathname = window.location.pathname;
    const sectionsToFetch = ["mini-cart"];
    if (isCartPage) sectionsToFetch.push("main-cart");

    let variantRelationships = {};
    try {
      variantRelationships = JSON.parse(
        localStorage.getItem("variantRelationships") || "{}"
      );
    } catch (e) {}

    const linked = variantRelationships[String(variantId)] || [];
    const ids = isRemoval ? [variantId, ...linked] : [variantId, ...linked];

    const updates = {};
    ids.forEach((id) => (updates[id] = quantity));

    isSyncingMontage = true;
    window.disableCartInteractions(
      "product-discount-price.js: handleQuantityChangeSync"
    );

    if (!isRemoval) {
      lastQuantityChange = { line, quantity, variantId, timestamp: Date.now() };
    }

    fetch("/cart/update.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
      body: JSON.stringify({
        updates,
        sections: sectionsToFetch,
        sections_url: pathname,
      }),
    })
      .then((r) => (r.json && typeof r.json === "function" ? r.json() : r))
      .then((data) => {
        if (!isRemoval && (!data || !data.items || data.items.length === 0)) {
          try {
            localStorage.removeItem("cartLockedDiscountPreference");
            clearUserRemovedDiscountGlobal();
          } catch (e) {}
        }

        if (data && data.sections) {
          if (typeof window.updateMiniCartFromSections === "function") {
            window.updateMiniCartFromSections(data, {
              openDrawer: false,
              updateBubbleCount: true,
            });
          }
          if (
            typeof window.updateBubbleCount === "function" &&
            data.item_count !== undefined
          ) {
            window.updateBubbleCount(data.item_count);
          }

          if (isCartPage && data.sections["main-cart"]) {
            const mainCart = document.querySelector(
              '[data-section-type="cart"]'
            );
            if (mainCart) {
              const temp = document.createElement("div");
              temp.innerHTML = data.sections["main-cart"];

              const newTable = temp.querySelector(".table-wrapper");
              const oldTable = mainCart.querySelector(".table-wrapper");
              if (newTable && oldTable) oldTable.innerHTML = newTable.innerHTML;

              const newRecap = temp.querySelector(".cart-recap");
              const oldRecap = mainCart.querySelector(".cart-recap");
              if (newRecap && oldRecap) oldRecap.innerHTML = newRecap.innerHTML;

              if (!newTable && !newRecap)
                mainCart.innerHTML = data.sections["main-cart"];

              const newCartSection = temp.querySelector(
                '[data-section-type="cart"]'
              );
              const existing = mainCart.querySelector(
                '[data-section-type="cart"]'
              );
              if (newCartSection && existing) {
                const isEmpty =
                  newCartSection.classList.contains("cart--empty") ||
                  newCartSection.querySelector(".cart--empty") ||
                  !temp.querySelector(".line-item");
                if (isEmpty) existing.innerHTML = newCartSection.innerHTML;
              }
            }
          }
        } else {
          fetch("/?sections=" + sectionsToFetch.join(","))
            .then((r) => r.json())
            .then((sec) => {
              if (typeof window.updateMiniCartFromSections === "function") {
                window.updateMiniCartFromSections(
                  { sections: sec },
                  {
                    openDrawer: false,
                    updateBubbleCount: true,
                  }
                );
              }
            })
            .catch((e) =>
              console.error("[QUANTITY-SYNC] Error fetching sections:", e)
            );
        }

        document.dispatchEvent(new CustomEvent("cart:refresh"));
        document.dispatchEvent(new CustomEvent("cart-drawer:refresh"));

        setTimeout(() => {
          if (typeof window.applyCartDrawerDiscounts === "function") {
            window.applyCartDrawerDiscounts(
              "product-discount-price.js: handleQuantityChangeSync line 7825"
            );
          }
          applyCartPageDiscounts(
            "product-discount-price.js: handleQuantityChangeSync line 7827"
          );
          setTimeout(() => {
            if (typeof window.recomputeDrawerSubtotalFromDOM === "function")
              window.recomputeDrawerSubtotalFromDOM(
                "product-discount-price.js: handleQuantityChangeSync line 6036"
              );
            recomputeCartPageSubtotalFromDOM(
              "product-discount-price.js: handleQuantityChangeSync line 6039"
            );
          }, 200);
        }, 300);

        setTimeout(() => {
          isSyncingMontage = false;
          window.enableCartInteractions(
            "product-discount-price.js: handleQuantityChangeSync"
          );
          onComplete?.();
          setTimeout(processSyncQueue, 100);
        }, 100);
      })
      .catch((err) => {
        console.error("[QUANTITY-SYNC] Error:", err);
        isSyncingMontage = false;
        window.enableCartInteractions(
          "product-discount-price.js: handleQuantityChangeSync error"
        );
        onComplete?.();
      });
  }

  document.addEventListener(
    "change",
    function (e) {
      console.log("product-discount-price.js: change event");
      var target = e.target;
      var line = null;
      var quantity = 0;

      if (window._cartInteractionsDisabled) {
        e.preventDefault();
        return;
      }

      if (
        target &&
        target.classList.contains("qty") &&
        target.hasAttribute("data-index")
      ) {
        line = parseInt(target.getAttribute("data-index")) || null;
        quantity = parseInt(target.value) || 0;
      } else if (
        target &&
        target.classList.contains("quantity-selector__value") &&
        target.hasAttribute("data-line")
      ) {
        line = parseInt(target.getAttribute("data-line")) || null;
        quantity = parseInt(target.value) || 0;
      }

      if (!line || quantity < 0) {
        return;
      }

      var row =
        target.closest('tr[id^="CartItem-"]') ||
        target.closest('[id^="CartDrawerItem-"]') ||
        target.closest('[id^="CartItem-"]') ||
        target.closest(".line-item") ||
        target.closest(".mini-cart__line-item");
      if (!row) {
        return;
      }

      var variantId = null;
      var variantIdEl = row.querySelector("[data-variant-id]");
      if (variantIdEl) {
        variantId = variantIdEl.getAttribute("data-variant-id");
      } else if (row.hasAttribute("data-variant-id")) {
        variantId = row.getAttribute("data-variant-id");
      } else {
        var productIdAttr = row.getAttribute("data-product-id");
        if (productIdAttr) {
          var m = productIdAttr.match(/^(\d+)/);
          if (m) {
            variantId = m[1];
          }
        }
      }

      if (!variantId) {
        return;
      }

      var productLink = row.querySelector(
        ".cart-product-link, .mini-cart__product-title, .line-item__title, a[href*='/products/']"
      );
      var isMontage = false;

      if (productLink) {
        var productTitle = productLink.textContent.trim().toLowerCase();
        isMontage = productTitle.includes("montage");
      }

      if (!isMontage && variantId) {
        e.preventDefault();
        e.stopPropagation();
        e.stopImmediatePropagation();

        lastQuantityChange = {
          line: line,
          quantity: quantity,
          variantId: variantId,
          timestamp: Date.now(),
        };
        handleQuantityChangeSync(line, variantId, quantity, function () {
          updateDiscountsAfterQuantityChange();
        });
      }
    },
    true
  );

  document.addEventListener(
    "click",
    function (e) {
      var target = e.target;
      var button = target.closest(
        '[data-action="decrease-quantity"], [data-action="increase-quantity"]'
      );

      if (button && button.hasAttribute("data-line")) {
        if (
          button.classList.contains("disabled") ||
          window._cartInteractionsDisabled
        ) {
          e.preventDefault();
          e.stopPropagation();
          return;
        }

        var line = parseInt(button.getAttribute("data-line")) || null;
        var action = button.getAttribute("data-action");

        var row =
          button.closest('tr[id^="CartItem-"]') ||
          button.closest('[id^="CartDrawerItem-"]') ||
          button.closest('[id^="CartItem-"]') ||
          button.closest(".line-item") ||
          button.closest(".mini-cart__line-item");
        if (!row) {
          return;
        }

        var quantity = parseInt(button.getAttribute("data-quantity")) || 0;

        var qtyInput = row.querySelector(".quantity-selector__value");
        if (qtyInput && quantity > 0) {
          var currentValue =
            parseInt(
              qtyInput.value ||
                qtyInput.getAttribute("data-current-value") ||
                "0",
              10
            ) || 0;
        }

        if (!line || quantity < 0) {
          return;
        }

        var variantId = null;
        var variantIdEl = row.querySelector("[data-variant-id]");
        if (variantIdEl) {
          variantId = variantIdEl.getAttribute("data-variant-id");
        } else if (row.hasAttribute("data-variant-id")) {
          variantId = row.getAttribute("data-variant-id");
        } else {
          var productIdAttr = row.getAttribute("data-product-id");
          if (productIdAttr) {
            var m = productIdAttr.match(/^(\d+)/);
            if (m) {
              variantId = m[1];
            }
          }
        }

        if (!variantId) {
          return;
        }

        var productLink = row.querySelector(
          ".cart-product-link, .mini-cart__product-title, .line-item__title, a[href*='/products/']"
        );
        var isMontage = false;

        var productHandle = row.getAttribute("data-product-handle");
        if (productHandle) {
          isMontage =
            productHandle === "montage" || productHandle === "montage-zubehor";
        }

        if (!isMontage && productLink) {
          var productTitle = productLink.textContent.trim().toLowerCase();
          isMontage = productTitle.includes("montage");
        }

        var isCartPageMode =
          window.theme &&
          window.theme.cartType === "page" &&
          button.hasAttribute("data-href");

        if (!isMontage && variantId) {
          if (isCartPageMode) {
            e.preventDefault();
            e.stopPropagation();
            e.stopImmediatePropagation();

            window.disableCartInteractions(
              "product-discount-price.js: cartPageMode quantity"
            );

            var variantRelationships = {};
            try {
              variantRelationships = JSON.parse(
                localStorage.getItem("variantRelationships") || "{}"
              );
            } catch (e) {}

            var linkedVariantIds =
              variantRelationships[String(variantId)] || [];

            var updates = {};
            updates[variantId] = quantity;
            linkedVariantIds.forEach(function (linkedId) {
              updates[linkedId] = quantity;
            });

            fetch("/cart/update.js", {
              method: "POST",
              headers: {
                "Content-Type": "application/json",
                Accept: "application/json",
              },
              body: JSON.stringify({ updates: updates }),
            })
              .then(function (response) {
                if (!response.ok) {
                  throw new Error("Failed to update cart");
                }
                return response.json();
              })
              .then(function () {
                window.enableCartInteractions(
                  "product-discount-price.js: cartPageMode quantity"
                );
                window.location.href = button.getAttribute("data-href");
              })
              .catch(function (error) {
                console.error(
                  "[QTY] Error updating quantity on cart page:",
                  error
                );
                window.enableCartInteractions(
                  "product-discount-price.js: cartPageMode quantity error"
                );
                window.location.href = button.getAttribute("data-href");
              });
          } else {
            e.preventDefault();
            e.stopPropagation();
            e.stopImmediatePropagation();

            var actualQuantity = quantity;

            handleQuantityChangeSync(
              line,
              variantId,
              actualQuantity,
              function () {
                updateDiscountsAfterQuantityChange();
              }
            );
          }
        }
      }
    },
    true
  );

  var previousCartItemCount = null;

  document.addEventListener("line-item:change:end", function (event) {
    console.log("product-discount-price.js: line-item:change:end event");
    try {
      if (isSyncingMontage) {
        return;
      }

      var timeSinceLastChange =
        Date.now() - (lastQuantityChange.timestamp || 0);
      if (timeSinceLastChange < 2000) {
        console.error(
          "[LINE-CHANGE] Skipping - handled",
          timeSinceLastChange,
          "ms ago"
        );
        return;
      }

      var shouldCleanup = false;
      if (event.detail) {
        if (event.detail.quantity === 0 || event.detail.quantity === "0") {
          shouldCleanup = true;
        }
        if (event.detail.cart && event.detail.cart.items) {
          var currentItemCount = event.detail.cart.items.length;
          if (
            previousCartItemCount !== null &&
            currentItemCount < previousCartItemCount
          ) {
            shouldCleanup = true;
          }
          previousCartItemCount = currentItemCount;
        }
      }

      if (shouldCleanup) {
        setTimeout(window.cleanuplocalStorageForRemovedItems, 1000);
      }

      if (
        event.detail &&
        event.detail.cart &&
        event.detail.cart.items &&
        event.detail.cart.items.length === 0
      ) {
        try {
          localStorage.removeItem("cartLockedDiscountPreference");
          clearUserRemovedDiscountGlobal();
        } catch (e) {
          console.error(
            "[CLEANUP] Error clearing locked discount preference:",
            e
          );
        }
      }

      if (event.detail && event.detail.cart && event.detail.cart.items) {
        var changedLine = null;
        var changedItem = null;

        for (var i = 0; i < event.detail.cart.items.length; i++) {
          var item = event.detail.cart.items[i];
          if (item && item.product_handle !== "montage") {
            var currentLine = i + 1;

            var qtyInput =
              document.querySelector(
                'input.qty[data-index="' + currentLine + '"]'
              ) ||
              document.querySelector(
                '.quantity-selector__value[data-line="' + currentLine + '"]'
              );
            if (qtyInput) {
              var currentQty =
                parseInt(
                  qtyInput.value ||
                    qtyInput.getAttribute("data-current-value") ||
                    "0",
                  10
                ) || 0;

              var wasHandled =
                lastQuantityChange.line === currentLine &&
                lastQuantityChange.quantity === item.quantity &&
                lastQuantityChange.variantId === item.variant_id;

              if (currentQty === item.quantity && !wasHandled) {
                changedLine = currentLine;
                changedItem = item;
                break;
              }
            }
          }
        }

        if (changedLine && changedItem) {
          lastQuantityChange = {
            line: changedLine,
            quantity: changedItem.quantity,
            variantId: changedItem.variant_id,
            timestamp: Date.now(),
          };

          var variantRelationships = {};
          try {
            variantRelationships = JSON.parse(
              localStorage.getItem("variantRelationships") || "{}"
            );
          } catch (e) {}

          var linkedVariantIds =
            variantRelationships[String(changedItem.variant_id)] || [];

          if (linkedVariantIds.length > 0) {
            window.disableCartInteractions(
              "product-discount-price.js: line-item:change:end sync"
            );

            var updates = {};
            linkedVariantIds.forEach(function (linkedId) {
              updates[linkedId] = changedItem.quantity;
            });

            var sectionsToFetch = ["mini-cart"];
            if (isCartPage) {
              sectionsToFetch.push("main-cart");
            }

            fetch("/cart/update.js", {
              method: "POST",
              headers: {
                "Content-Type": "application/json",
                Accept: "application/json",
              },
              body: JSON.stringify({
                updates: updates,
                sections: sectionsToFetch,
                sections_url: window.location.pathname,
              }),
            })
              .then(function (response) {
                return response.json();
              })
              .then(function (cartData) {
                if (cartData && cartData.sections) {
                  if (typeof window.updateMiniCartFromSections === "function") {
                    window.updateMiniCartFromSections(cartData, {
                      openDrawer: false,
                      updateBubbleCount: true,
                    });
                  }
                }

                setTimeout(function () {
                  window.enableCartInteractions(
                    "product-discount-price.js: line-item:change:end sync"
                  );
                  updateDiscountsAfterQuantityChange();
                }, 100);
              })
              .catch(function (error) {
                console.error("[LINE-CHANGE-SYNC] Error:", error);
                window.enableCartInteractions(
                  "product-discount-price.js: line-item:change:end sync error"
                );
                updateDiscountsAfterQuantityChange();
              });
          } else {
            updateDiscountsAfterQuantityChange();
          }
        } else {
          updateDiscountsAfterQuantityChange();
        }
      }
    } catch (e) {
      console.error("[QTY] Error in line-item:change:end handler:", e);
    }
  });

  document.addEventListener(
    "click",
    function (e) {
      var target = e.target;
      if (!target) return;
      var drawerRemove =
        target.closest &&
        target.closest(".mini-cart__line-item .remove[data-id]");
      if (drawerRemove) {
        if (
          drawerRemove.classList.contains("disabled") ||
          window._cartInteractionsDisabled
        ) {
          e.preventDefault();
          e.stopPropagation();
          return;
        }

        e.preventDefault();
        e.stopPropagation();
        e.stopImmediatePropagation();

        var cartItem = drawerRemove.closest('[id^="CartDrawerItem-"]');
        if (cartItem) {
          var variantId = null;

          if (cartItem.hasAttribute("data-variant-id")) {
            variantId = cartItem.getAttribute("data-variant-id");
          } else if (drawerRemove.hasAttribute("data-id")) {
            variantId = drawerRemove.getAttribute("data-id");
          }

          if (variantId) {
            try {
              var st = localStorage.getItem("variantDiscounts");
              if (st) {
                var mp = JSON.parse(st);
                if (mp && mp[variantId]) {
                  delete mp[variantId];
                  localStorage.setItem("variantDiscounts", JSON.stringify(mp));
                }
              }
            } catch (e) {}

            var isMontage = false;
            var productHandle = cartItem.getAttribute("data-product-handle");

            if (productHandle) {
              isMontage =
                productHandle === "montage" ||
                productHandle === "montage-zubehor";
            } else {
              var productLink = cartItem.querySelector(
                ".mini-cart__product-title"
              );
              if (productLink) {
                var productTitle = productLink.textContent.trim().toLowerCase();
                isMontage = productTitle.includes("montage");
              }
            }

            if (isMontage) {
              handleMontageProductRemoval(
                "handleMontageProductRemoval drawer remove 6691"
              );
              setTimeout(window.cleanuplocalStorageForRemovedItems, 1000);
              setTimeout(recomputeDrawerSubtotalFromDOM, 120);
              return;
            }

            if (!isMontage && variantId) {
              isRemovingProduct = true;
              window.disableCartInteractions(
                "product-discount-price.js:8329 click - drawer remove with linked products"
              );

              var updates = {};
              updates[variantId] = 0;

              try {
                var variantRelationships = JSON.parse(
                  localStorage.getItem("variantRelationships") || "{}"
                );
                var linkedVariantIds = variantRelationships[String(variantId)];
                if (linkedVariantIds && Array.isArray(linkedVariantIds)) {
                  linkedVariantIds.forEach(function (linkedId) {
                    updates[linkedId] = 0;
                  });
                }
                delete variantRelationships[String(variantId)];
                localStorage.setItem(
                  "variantRelationships",
                  JSON.stringify(variantRelationships)
                );
              } catch (e) {
                console.error(
                  "[REMOVE] Error reading variantRelationships:",
                  e
                );
              }

              console.log(
                "[REMOVE] Drawer: Removing variants in single call:",
                updates
              );

              var sectionsToFetch = ["mini-cart"];
              if (isCartPage) {
                sectionsToFetch.push("main-cart");
              }

              fetch("/cart/update.js", {
                method: "POST",
                headers: {
                  "Content-Type": "application/json",
                  Accept: "application/json",
                },
                body: JSON.stringify({
                  updates: updates,
                  sections: sectionsToFetch,
                  sections_url: window.location.pathname,
                }),
              })
                .then(function (response) {
                  if (!response.ok) {
                    throw new Error("Failed to remove items from cart");
                  }
                  return response.json();
                })
                .then(function (cartData) {
                  if (!isRemovingProduct) {
                    return;
                  }

                  if (
                    !cartData ||
                    !cartData.items ||
                    cartData.items.length === 0
                  ) {
                    try {
                      localStorage.removeItem("cartLockedDiscountPreference");
                      clearUserRemovedDiscountGlobal();
                    } catch (e) {
                      console.error(
                        "[REMOVE] Error clearing locked preference:",
                        e
                      );
                    }
                  }

                  if (cartData && cartData.sections) {
                    if (
                      typeof window.updateMiniCartFromSections === "function"
                    ) {
                      window.updateMiniCartFromSections(cartData, {
                        updateBubbleCount: true,
                        openDrawer: false,
                      });
                    }

                    if (isCartPage && cartData.sections["main-cart"]) {
                      var mainCartSection = document.querySelector(
                        '[data-section-type="cart"]'
                      );
                      if (mainCartSection) {
                        var temp = document.createElement("div");
                        temp.innerHTML = cartData.sections["main-cart"];

                        var newTableWrapper =
                          temp.querySelector(".table-wrapper");
                        var oldTableWrapper =
                          mainCartSection.querySelector(".table-wrapper");

                        if (newTableWrapper && oldTableWrapper) {
                          oldTableWrapper.innerHTML = newTableWrapper.innerHTML;
                        }

                        var newContent = temp.querySelector(".cart-recap");
                        var oldContent =
                          mainCartSection.querySelector(".cart-recap");
                        if (newContent && oldContent) {
                          oldContent.innerHTML = newContent.innerHTML;
                        }

                        var newCartSection = temp.querySelector(
                          '[data-section-type="cart"]'
                        );
                        if (newCartSection) {
                          var isNowEmpty =
                            newCartSection.classList.contains("cart--empty") ||
                            newCartSection.querySelector(".cart--empty") ||
                            !temp.querySelector(".line-item");

                          if (isNowEmpty) {
                            mainCartSection.innerHTML =
                              newCartSection.innerHTML;
                          }
                        }
                      }
                    }

                    if (
                      typeof window.updateBubbleCount === "function" &&
                      cartData.item_count !== undefined
                    ) {
                      window.updateBubbleCount(cartData.item_count);
                    }
                  }

                  document.dispatchEvent(new CustomEvent("cart:refresh"));
                  document.dispatchEvent(
                    new CustomEvent("cart-drawer:refresh")
                  );

                  setTimeout(function () {
                    window.enableCartInteractions(
                      "product-discount-price.js:8420 drawer remove complete"
                    );
                    isRemovingProduct = false;

                    applyCartDrawerDiscounts(
                      "product-discount-price.js:8511 cart page remove complete line 8510"
                    );

                    applyCartPageDiscounts(
                      "product-discount-price.js:8511 cart page remove complete line 8512"
                    );

                    setTimeout(function () {
                      recomputeDrawerSubtotalFromDOM(
                        "product-discount-price.js:8420 drawer remove complete line 8421"
                      );
                      recomputeCartPageSubtotalFromDOM(
                        "product-discount-price.js:8511 cart page remove complete line 6725"
                      );
                    }, 200);

                    try {
                      setTimeout(
                        setupCheckoutDiscountRedirects,
                        400,
                        "product-discount-price.js:8678"
                      );
                    } catch (e) {
                      console.error(
                        "[CHK] Error setting up redirects after item removal:",
                        e
                      );
                    }
                  }, 100);
                })
                .catch(function (error) {
                  console.error("[REMOVE] Error removing items:", error);
                  window.enableCartInteractions(
                    "product-discount-price.js:8421 drawer remove error"
                  );
                  isRemovingProduct = false;
                });
            }

            setTimeout(window.cleanuplocalStorageForRemovedItems, 1000);
          }
        }
        setTimeout(recomputeDrawerSubtotalFromDOM, 120);
        return;
      }
      var cartRemove =
        target.closest && target.closest("a.remove.line-item__quantity-remove");

      console.log("clickListener line 6899: cartRemove", cartRemove);
      if (cartRemove) {
        e.preventDefault();
        e.stopPropagation();
        e.stopImmediatePropagation();

        if (isRemovingProduct) {
          console.log(
            "clickListener line 6904: isRemovingProduct true, return early",
            isRemovingProduct
          );
        } else {
          console.log(
            "clickListener line 6908: isRemovingProduct false, continue",
            isRemovingProduct
          );
        }

        if (isRemovingProduct) {
          return;
        }

        clearTimeout(removeProductDebounceTimeout);
        removeProductDebounceTimeout = setTimeout(function () {
          if (isRemovingProduct) {
            return;
          }

          var row = cartRemove.closest('tr[id^="CartItem-"]');
          if (row) {
            var key = row.getAttribute("data-product-id") || "";
            var m = key.match(/^(\d+)/);
            var v = m ? m[1] : null;
            var productHandle = row.getAttribute("data-product-handle");
            var isMontage = false;

            if (productHandle) {
              isMontage =
                productHandle === "montage" ||
                productHandle === "montage-zubehor";
            }

            console.log("clickListener line 6942: isMontage", isMontage);

            if (isMontage) {
              handleMontageProductRemoval(
                "handleMontageProductRemoval cart page remove 6924"
              );
              setTimeout(window.cleanuplocalStorageForRemovedItems, 1000);
              return;
            }

            if (v) {
              isRemovingProduct = true;
              window.disableCartInteractions(
                "product-discount-price.js:8488 cart page remove with linked products"
              );

              var updates = {};
              updates[v] = 0;

              try {
                var variantRelationships = JSON.parse(
                  localStorage.getItem("variantRelationships") || "{}"
                );

                console.log(
                  "clickListener line 6966: variantRelationships",
                  variantRelationships
                );

                var linkedVariantIds = variantRelationships[String(v)];
                if (linkedVariantIds && Array.isArray(linkedVariantIds)) {
                  linkedVariantIds.forEach(function (linkedId) {
                    updates[linkedId] = 0;
                  });
                }
                delete variantRelationships[String(v)];
                localStorage.setItem(
                  "variantRelationships",
                  JSON.stringify(variantRelationships)
                );
              } catch (e) {
                console.error(
                  "[REMOVE] Error reading variantRelationships:",
                  e
                );
              }

              console.log(
                "[REMOVE] Cart page: Removing variants in single call:",
                updates
              );

              fetch("/cart/update.js", {
                method: "POST",
                headers: {
                  "Content-Type": "application/json",
                  Accept: "application/json",
                },
                body: JSON.stringify({
                  updates: updates,
                  sections: ["main-cart", "mini-cart"],
                  sections_url: window.location.pathname,
                }),
              })
                .then(function (response) {
                  if (!response.ok) {
                    throw new Error("Failed to remove items from cart");
                  }
                  return response.json();
                })
                .then(function (cartData) {
                  if (
                    !cartData ||
                    !cartData.items ||
                    cartData.items.length === 0
                  ) {
                    try {
                      localStorage.removeItem("cartLockedDiscountPreference");
                      clearUserRemovedDiscountGlobal();
                    } catch (e) {
                      console.error(
                        "[REMOVE] Error clearing locked preference:",
                        e
                      );
                    }
                  }

                  try {
                    var st2 = localStorage.getItem("variantDiscounts");
                    if (st2) {
                      var mp2 = JSON.parse(st2);
                      Object.keys(updates).forEach(function (varId) {
                        if (mp2 && mp2[varId]) {
                          delete mp2[varId];
                        }
                      });
                      localStorage.setItem(
                        "variantDiscounts",
                        JSON.stringify(mp2)
                      );
                    }
                  } catch (e) {}

                  if (cartData && cartData.sections) {
                    var mainCartSection = cartData.sections["main-cart"];
                    var cartDrawerSection = cartData.sections["mini-cart"];

                    if (mainCartSection) {
                      var tempDiv = document.createElement("div");
                      tempDiv.innerHTML = mainCartSection;

                      var newSection = tempDiv.querySelector(
                        '[data-section-type="cart"]'
                      );
                      if (newSection) {
                        var existingSection = document.querySelector(
                          '[data-section-type="cart"]'
                        );
                        if (existingSection) {
                          var newTableWrapper =
                            newSection.querySelector(".table-wrapper");
                          var existingTableWrapper = document.querySelector(
                            ".cart-wrapper .table-wrapper"
                          );

                          if (newTableWrapper && existingTableWrapper) {
                            existingTableWrapper.innerHTML =
                              newTableWrapper.innerHTML;
                          }

                          var newContent =
                            newSection.querySelector(".cart-recap");
                          var oldContent =
                            existingSection.querySelector(".cart-recap");
                          if (newContent && oldContent) {
                            oldContent.innerHTML = newContent.innerHTML;
                          }

                          var isNowEmpty =
                            newSection.classList.contains("cart--empty") ||
                            newSection.querySelector(".cart--empty") ||
                            !tempDiv.querySelector(".line-item");

                          if (isNowEmpty) {
                            existingSection.innerHTML = newSection.innerHTML;
                          }
                        }
                      }
                    }

                    if (cartDrawerSection) {
                      if (
                        typeof window.updateMiniCartFromSections === "function"
                      ) {
                        window.updateMiniCartFromSections(cartData, {
                          updateBubbleCount: true,
                          openDrawer: false,
                        });
                      } else {
                        var drawerEl = document.getElementById("mini-cart");
                        if (drawerEl) {
                          var selector = ".mini-cart__inner";
                          var inner =
                            drawerEl.querySelector(selector) || drawerEl;
                          inner.innerHTML = cartDrawerSection;
                        }
                      }
                    }

                    if (
                      typeof window.updateBubbleCount === "function" &&
                      cartData.item_count !== undefined
                    ) {
                      window.updateBubbleCount(cartData.item_count);
                    }
                  }

                  document.dispatchEvent(new CustomEvent("cart:refresh"));
                  document.dispatchEvent(new Event("theme:cart:refresh"));
                  document.dispatchEvent(new Event("thb:cart:update"));
                  if (!isCartPage) {
                    document.dispatchEvent(new Event("cart-drawer:refresh"));
                  }

                  setTimeout(function () {
                    window.enableCartInteractions(
                      "product-discount-price.js:9254 cart page remove complete"
                    );
                    isRemovingProduct = false;

                    applyCartDrawerDiscounts(
                      "product-discount-price.js:9254 cart page remove complete line 8779"
                    );
                    applyCartPageDiscounts(
                      "product-discount-price.js:9254 cart page remove complete line 8781"
                    );

                    setTimeout(function () {
                      recomputeDrawerSubtotalFromDOM(
                        "product-discount-price.js:9254 cart page remove complete line 9255"
                      );
                      recomputeCartPageSubtotalFromDOM(
                        "product-discount-price.js:9254 cart page remove complete line 6979"
                      );
                    }, 200);
                  }, 100);
                })
                .catch(function (error) {
                  console.error("[REMOVE] Error removing items:", error);
                  window.enableCartInteractions(
                    "product-discount-price.js:9255 cart page remove error"
                  );
                  isRemovingProduct = false;
                });

              setTimeout(window.cleanuplocalStorageForRemovedItems, 1000);
            }
          }
          setTimeout(function () {
            recomputeCartPageSubtotalFromDOM(
              "product-discount-price.js:8488 cart page remove with linked products line 6994"
            );
          }, 120);
        }, 100);
      }
    },
    true
  );

  function setupEssentialUpsellListener() {
    var upsellContainer = document.querySelector(
      ".essential-upsell-side-cart-top"
    );
    if (upsellContainer) {
      upsellContainer.addEventListener(
        "click",
        function (e) {
          var addToCartButton = e.target.closest(
            '[data-essential-upsell-element="add-to-cart-button"]'
          );
          if (addToCartButton) {
            setTimeout(function () {
              document.dispatchEvent(new CustomEvent("cart:refresh"));
              setTimeout(function () {
                applyCartDrawerDiscounts(
                  "product-discount-price.js:9372 setupEssentialUpsellListener line 8839"
                );
                recomputeDrawerSubtotalFromDOM(
                  "product-discount-price.js:9372 setupEssentialUpsellListener line 9373"
                );
              }, 300);
            }, 500);
          } else {
          }
        },
        true
      );
    } else {
      setTimeout(setupEssentialUpsellListener, 500);
    }
  }

  document.addEventListener(
    "click",
    function (e) {
      var addToCartButton = e.target.closest(
        '[data-essential-upsell-element="add-to-cart-button"]'
      );
      if (addToCartButton) {
        var container = addToCartButton.closest(
          ".essential-upsell-side-cart-top, .essential-upsell-cross-sell-block.essential-cart-upsell"
        );
        if (container) {
          e.preventDefault();
          e.stopPropagation();
          e.stopImmediatePropagation();

          var productCard = addToCartButton.closest(
            '[data-essential-upsell-element="product"]'
          );
          var productInfo = {};

          if (productCard) {
            var variantSelect = productCard.querySelector(
              'select[data-essential-upsell-element="variant-select"], select[aria-label*="Select variant"]'
            );
            if (variantSelect) {
              productInfo.variantId = variantSelect.value;
            }

            var titleLink = productCard.querySelector(
              '[data-essential-upsell-element="title"]'
            );
            if (titleLink) {
              var href = titleLink.getAttribute("href");
              if (href) {
                var handleMatch = href.match(/\/products\/([^\/\?]+)/);
                if (handleMatch) {
                  productInfo.productHandle = handleMatch[1];
                }
              }
              productInfo.productTitle = titleLink.textContent.trim();
            }

            var discountedPriceEl = productCard.querySelector(
              '[data-essential-upsell-element="discounted-price"]'
            );
            var regularPriceEl = productCard.querySelector(
              '[data-essential-upsell-element="regular-price"]'
            );

            if (productInfo.variantId && productInfo.productHandle) {
              window.disableCartInteractions("product-discount-price.js:8729");
              fetch("/cart/add.js", {
                method: "POST",
                headers: {
                  "Content-Type": "application/json",
                  "X-Requested-With": "XMLHttpRequest",
                  Accept: "application/json",
                },
                body: JSON.stringify({
                  id: productInfo.variantId,
                  quantity: 1,
                  sections: isCartPage
                    ? ["mini-cart", "main-cart"]
                    : ["mini-cart"],
                  sections_url: window.location.pathname,
                }),
              })
                .then(function (response) {
                  if (response.ok) {
                    return response.json();
                  }
                  throw new Error("Failed to add item to cart");
                })
                .then(function (cartData) {
                  if (cartData && cartData.items && cartData.items.length > 0) {
                    var productItem = cartData.items[cartData.items.length - 1];
                    var upsellVariantId = String(productItem.variant_id);

                    var buttonMapping = window.getButtonDiscountMapping();
                    var assemblyPreference = window.getAssemblyPreference();
                    var buttonNumber = assemblyPreference || 1;
                    var targetDiscountTitle = null;

                    if (
                      buttonMapping &&
                      (buttonMapping.button1 || buttonMapping.button2)
                    ) {
                      if (buttonNumber === 1) {
                        targetDiscountTitle = buttonMapping.button1;
                      } else if (buttonNumber === 2) {
                        targetDiscountTitle = buttonMapping.button2;
                      }
                    }

                    if (targetDiscountTitle) {
                      fetch("/products/" + productInfo.productHandle + ".js")
                        .then(function (response) {
                          return response.json();
                        })
                        .then(function (productData) {
                          var discountsMetafield = null;

                          if (productData && productData.variants) {
                            var variant = productData.variants.find(function (
                              v
                            ) {
                              return String(v.id) === upsellVariantId;
                            });
                            if (variant && variant.metafields) {
                              discountsMetafield =
                                variant.metafields.custom?.discounts?.value;
                            }
                          }

                          if (
                            !discountsMetafield &&
                            productData &&
                            productData.metafields
                          ) {
                            discountsMetafield =
                              productData.metafields.custom?.discounts?.value;
                          }

                          if (
                            discountsMetafield &&
                            Array.isArray(discountsMetafield) &&
                            discountsMetafield.length > 0
                          ) {
                            var foundDiscount = discountsMetafield.find(
                              function (d) {
                                return (
                                  d.title &&
                                  d.title.trim() === targetDiscountTitle
                                );
                              }
                            );

                            if (foundDiscount) {
                              var discountPercentage = 0;
                              var discountValue = foundDiscount.value;

                              if (discountValue) {
                                if (discountValue.value !== undefined) {
                                  var value = parseFloat(discountValue.value);
                                  if (discountValue.type === "percentage") {
                                    discountPercentage =
                                      value <= 1 ? value * 100 : value;
                                  } else {
                                    discountPercentage = value * 100;
                                  }
                                } else if (typeof discountValue === "number") {
                                  discountPercentage =
                                    discountValue <= 1
                                      ? discountValue * 100
                                      : discountValue;
                                } else if (typeof discountValue === "string") {
                                  var parsed = parseFloat(discountValue);
                                  discountPercentage =
                                    parsed <= 1 ? parsed * 100 : parsed;
                                }
                              }

                              window.saveVariantDiscount(
                                upsellVariantId,
                                targetDiscountTitle,
                                discountPercentage
                              );
                            }
                          }
                        })
                        .catch(function (error) {
                          console.error(
                            "[UPSELL] Error fetching product data:",
                            error
                          );
                        });
                    }

                    document.dispatchEvent(
                      new CustomEvent("cart:item-added", {
                        detail: { product: productItem },
                      })
                    );
                  }

                  document.dispatchEvent(new CustomEvent("cart:refresh"));

                  if (cartData && cartData.sections) {
                    if (cartData.sections["mini-cart"]) {
                      if (
                        typeof window.updateMiniCartFromSections === "function"
                      ) {
                        window.updateMiniCartFromSections(cartData, {
                          openDrawer: false,
                          updateBubbleCount: true,
                        });
                      } else {
                        var miniCartSection = cartData.sections["mini-cart"];
                        var drawerEl = document.getElementById("mini-cart");
                        if (drawerEl && miniCartSection) {
                          var selector = ".mini-cart__inner";
                          var inner =
                            drawerEl.querySelector(selector) || drawerEl;
                          inner.innerHTML = miniCartSection;
                        }
                      }
                    }

                    if (isCartPage && cartData.sections["main-cart"]) {
                      var cartSection = document.querySelector(
                        '[data-section-type="cart"]'
                      );
                      if (cartSection) {
                        var tempElement = document.createElement("div");
                        tempElement.innerHTML = cartData.sections["main-cart"];
                        var newCartSection = tempElement.querySelector(
                          '[data-section-type="cart"]'
                        );
                        if (newCartSection) {
                          cartSection.innerHTML = newCartSection.innerHTML;
                        }
                      }
                    }

                    document.dispatchEvent(
                      new CustomEvent("cart-drawer:refresh")
                    );
                  }

                  setTimeout(function () {
                    applyCartDrawerDiscounts(
                      "product-discount-price.js:9486 click event line 9085"
                    );
                  }, 500);

                  setTimeout(function () {
                    var addedVariantId = String(productInfo.variantId);

                    setTimeout(
                      function () {
                        var cartItem = null;
                        if (isCartPage) {
                          cartItem = document.querySelector(
                            'tr[id^="CartItem-"][data-main-variant-id="' +
                              addedVariantId +
                              '"], tr[id^="CartItem-"][data-variant-id="' +
                              addedVariantId +
                              '"]'
                          );
                        } else {
                          cartItem = document.querySelector(
                            '.mini-cart__line-item[data-main-variant-id="' +
                              addedVariantId +
                              '"], .mini-cart__line-item[data-variant-id="' +
                              addedVariantId +
                              '"]'
                          );
                        }

                        if (cartItem) {
                          var linkedVariantIdsStr = cartItem.getAttribute(
                            "data-linked-variant-ids"
                          );

                          if (
                            linkedVariantIdsStr &&
                            linkedVariantIdsStr.trim() !== "" &&
                            linkedVariantIdsStr !== "null"
                          ) {
                            var linkedVariantIds = linkedVariantIdsStr
                              .split(",")
                              .map(function (id) {
                                return String(id.trim());
                              })
                              .filter(function (id) {
                                return id !== "";
                              });

                            if (linkedVariantIds.length > 0) {
                              var lockedPreference = null;
                              try {
                                lockedPreference = localStorage.getItem(
                                  "cartLockedDiscountPreference"
                                );
                              } catch (e) {
                                console.error(
                                  "[UPSELL] Error checking locked preference:",
                                  e
                                );
                              }

                              var shouldAddMontageProducts = false;
                              if (lockedPreference === "2") {
                                shouldAddMontageProducts = true;
                              } else if (lockedPreference === "1") {
                                return;
                              } else {
                                shouldAddMontageProducts =
                                  window.isAssemblyBySkyPergola();
                              }

                              if (!shouldAddMontageProducts) {
                                return;
                              }

                              var isAssemblyBySkyPergola =
                                window.isAssemblyBySkyPergola();

                              if (!isAssemblyBySkyPergola) {
                                return;
                              }

                              fetch("/cart.js")
                                .then(function (response) {
                                  return response.json();
                                })
                                .then(function (currentCartData) {
                                  if (
                                    !currentCartData ||
                                    !currentCartData.items
                                  ) {
                                    return;
                                  }

                                  var variantsAlreadyInCart = [];
                                  currentCartData.items.forEach(function (
                                    cartItem
                                  ) {
                                    variantsAlreadyInCart.push(
                                      String(cartItem.variant_id)
                                    );
                                  });

                                  var mainItem = currentCartData.items.find(
                                    function (item) {
                                      return (
                                        String(item.variant_id) ===
                                        addedVariantId
                                      );
                                    }
                                  );

                                  if (!mainItem) {
                                    return;
                                  }

                                  var linkedVariantsToAdd =
                                    linkedVariantIds.filter(function (id) {
                                      return (
                                        variantsAlreadyInCart.indexOf(id) === -1
                                      );
                                    });

                                  if (linkedVariantsToAdd.length > 0) {
                                    var variantRelationships = JSON.parse(
                                      localStorage.getItem(
                                        "variantRelationships"
                                      ) || "{}"
                                    );
                                    variantRelationships[addedVariantId] =
                                      linkedVariantIds;
                                    localStorage.setItem(
                                      "variantRelationships",
                                      JSON.stringify(variantRelationships)
                                    );

                                    var propertyLabel = {
                                      en: "For",
                                      de: "Für",
                                      fr: "Pour",
                                      it: "Per",
                                    };
                                    var currentLocale =
                                      document.documentElement.lang || "en";
                                    var langCode = currentLocale
                                      .split("-")[0]
                                      .toLowerCase();
                                    if (!propertyLabel[langCode]) {
                                      langCode = "en";
                                    }
                                    var propertyKey = propertyLabel[langCode];

                                    var combinedTitle =
                                      mainItem.product_title ||
                                      mainItem.title ||
                                      "";
                                    if (
                                      mainItem.variant_title &&
                                      mainItem.variant_title !== "Default Title"
                                    ) {
                                      combinedTitle =
                                        combinedTitle +
                                        " " +
                                        mainItem.variant_title;
                                    }

                                    var itemsToAdd = [];
                                    // Remove "Default Title" (case-insensitive) from combinedTitle
                                    var cleanedCombinedTitle = combinedTitle
                                      ? combinedTitle
                                          .replace(
                                            /(\s*-?\s*default title\s*)$/i,
                                            ""
                                          )
                                          .trim()
                                      : "";

                                    linkedVariantsToAdd.forEach(function (
                                      variantIdToAdd
                                    ) {
                                      var properties = {};
                                      if (cleanedCombinedTitle) {
                                        properties[propertyKey] =
                                          cleanedCombinedTitle;
                                      }
                                      itemsToAdd.push({
                                        id: variantIdToAdd,
                                        quantity: mainItem.quantity || 1,
                                        properties: properties,
                                      });
                                    });

                                    fetch("/cart/add.js", {
                                      method: "POST",
                                      headers: {
                                        "Content-Type": "application/json",
                                        "X-Requested-With": "XMLHttpRequest",
                                        Accept: "application/json",
                                      },
                                      body: JSON.stringify({
                                        items: itemsToAdd,
                                        sections: isCartPage
                                          ? ["mini-cart", "main-cart"]
                                          : ["mini-cart"],
                                        sections_url: window.location.pathname,
                                      }),
                                    })
                                      .then(function (response) {
                                        if (response.ok) {
                                          return response.json();
                                        }
                                        throw new Error(
                                          "Failed to add linked variants"
                                        );
                                      })
                                      .then(function (addResponse) {
                                        document.dispatchEvent(
                                          new CustomEvent("cart:refresh")
                                        );

                                        if (
                                          addResponse &&
                                          addResponse.sections
                                        ) {
                                          if (
                                            addResponse.sections["mini-cart"]
                                          ) {
                                            if (
                                              typeof window.updateMiniCartFromSections ===
                                              "function"
                                            ) {
                                              window.updateMiniCartFromSections(
                                                addResponse,
                                                {
                                                  openDrawer: false,
                                                  updateBubbleCount: true,
                                                }
                                              );
                                            } else {
                                              var miniCartSection =
                                                addResponse.sections[
                                                  "mini-cart"
                                                ];
                                              var drawerEl =
                                                document.getElementById(
                                                  "mini-cart"
                                                );
                                              if (drawerEl && miniCartSection) {
                                                var selector =
                                                  ".mini-cart__inner";
                                                var inner =
                                                  drawerEl.querySelector(
                                                    selector
                                                  ) || drawerEl;
                                                inner.innerHTML =
                                                  miniCartSection;
                                              }
                                            }
                                          }

                                          if (
                                            isCartPage &&
                                            addResponse.sections["main-cart"]
                                          ) {
                                            var cartSection =
                                              document.querySelector(
                                                '[data-section-type="cart"]'
                                              );
                                            if (cartSection) {
                                              var tempElement =
                                                document.createElement("div");
                                              tempElement.innerHTML =
                                                addResponse.sections[
                                                  "main-cart"
                                                ];
                                              var newCartSection =
                                                tempElement.querySelector(
                                                  '[data-section-type="cart"]'
                                                );
                                              if (newCartSection) {
                                                cartSection.innerHTML =
                                                  newCartSection.innerHTML;
                                              }
                                            }
                                          }

                                          document.dispatchEvent(
                                            new CustomEvent(
                                              "cart-drawer:refresh"
                                            )
                                          );
                                        }

                                        setTimeout(function () {
                                          applyCartDrawerDiscounts(
                                            "product-discount-price.js:9404 click event line 7550"
                                          );
                                          applyCartPageDiscounts(
                                            "product-discount-price.js:9404 click event line 7553"
                                          );
                                          recomputeCartPageSubtotalFromDOM(
                                            "product-discount-price.js:9404 click event line 7555"
                                          );
                                          recomputeDrawerSubtotalFromDOM(
                                            "product-discount-price.js:9404 click event line 7557"
                                          );
                                        }, 300);
                                      })
                                      .catch(function (error) {
                                        console.error(
                                          "[UPSELL] Error adding linked variants:",
                                          error
                                        );
                                      });
                                  }
                                })
                                .catch(function (error) {
                                  console.error(
                                    "[UPSELL] Error fetching cart:",
                                    error
                                  );
                                });
                            }
                          }
                        }
                      },
                      isCartPage ? 800 : 600
                    );

                    applyCartDrawerDiscounts(
                      "product-discount-price.js:9252 click event line 7583"
                    );
                    applyCartPageDiscounts(
                      "product-discount-price.js:9252 click event line 7586"
                    );
                    recomputeCartPageSubtotalFromDOM(
                      "product-discount-price.js:9252 click event line 7589"
                    );
                    recomputeDrawerSubtotalFromDOM(
                      "product-discount-price.js:9253"
                    );
                    window.enableCartInteractions(
                      "product-discount-price.js:9253"
                    );
                  }, 300);
                })
                .catch(function (error) {
                  console.error(
                    "[UPSELL] " + context + ": Error adding item:",
                    error
                  );
                  window.enableCartInteractions(
                    "product-discount-price.js:9277"
                  );
                  document.dispatchEvent(new CustomEvent("cart:refresh"));
                });
            }
          }
        }
      }
    },
    true
  );

  function applyDiscountsOnPageLoad() {
    if (isCartPage) {
      var checkCartReady = function (attempts) {
        attempts = attempts || 0;
        var maxAttempts = 15;
        var lineItemTable = document.querySelector(".line-item-table");
        var hasCartItems =
          lineItemTable &&
          lineItemTable.querySelectorAll(".line-item").length > 0;

        if (hasCartItems || attempts >= maxAttempts) {
          setTimeout(function () {
            applyCartPageDiscounts(
              "product-discount-price.js: applyDiscountsOnPageLoad line 9692"
            );

            setTimeout(function () {
              recomputeCartPageSubtotalFromDOM(
                "product-discount-price.js: applyDiscountsOnPageLoad line 9627"
              );

              try {
                setupCheckoutDiscountRedirects(
                  "product-discount-price.js: applyDiscountsOnPageLoad run setupCheckoutDiscountRedirects"
                );
              } catch (e) {
                console.error(
                  "[CHK] Error running setupCheckoutDiscountRedirects on cart page:",
                  e
                );
              }
            }, 400);
          }, 500);
        } else {
          setTimeout(function () {
            checkCartReady(attempts + 1);
          }, 200);
        }
      };

      setTimeout(function () {
        checkCartReady(0);
      }, 600);
    }
  }

  document.addEventListener("cart:refresh", function () {
    console.log("product-discount-price.js: cart:refresh event");
    setTimeout(setupEssentialUpsellListener, 200);

    setTimeout(function () {
      try {
        setupCheckoutDiscountRedirects(
          "product-discount-price.js: setupCheckoutDiscountRedirects line 9639"
        );
      } catch (e) {
        console.error("[CHK] Error re-setting up checkout redirects:", e);
      }
    }, 300);

    setTimeout(function () {
      try {
        fetch("/cart.js")
          .then(function (response) {
            return response.json();
          })
          .then(function (cartData) {
            if (!cartData || !cartData.items || cartData.items.length === 0) {
              try {
                localStorage.removeItem("cartLockedDiscountPreference");
                clearUserRemovedDiscountGlobal();
              } catch (e) {
                console.error("[CLEANUP] Error clearing locked preference:", e);
              }
            }
          })
          .catch(function (error) {
            console.error("[CLEANUP] Error checking cart:", error);
          });
      } catch (e) {
        console.error("[CLEANUP] Error in cart empty check:", e);
      }
    }, 500);
  });

  document.addEventListener("cart-drawer:refresh", function () {
    console.log("product-discount-price.js: cart-drawer:refresh event");
    setTimeout(function () {
      try {
        setupCheckoutDiscountRedirects(
          "product-discount-price.js: handleCartPageUpdate line 9705"
        );
      } catch (e) {
        console.error(
          "[CHK] Error setting up checkout redirects on drawer refresh:",
          e
        );
      }
    }, 300);

    setTimeout(function () {
      if (typeof window.applyCartDrawerDiscounts === "function") {
        window.applyCartDrawerDiscounts(
          "product-discount-price.js:9253 cart-drawer:refresh line 8775"
        );
      }

      recomputeDrawerSubtotalFromDOM(
        "product-discount-price.js:9253 cart-drawer:refresh line 9254"
      );
    }, 400);
  });

  document.addEventListener("cart-drawer:open", function () {
    console.log("product-discount-price.js: cart-drawer:open event");
    setTimeout(function () {
      try {
        setupCheckoutDiscountRedirects(
          "product-discount-price.js: handleCartPageUpdate line 9672"
        );
      } catch (e) {
        console.error(
          "[CHK] Error setting up checkout redirects on drawer open:",
          e
        );
      }
    }, 200);

    setTimeout(function () {
      if (typeof window.applyCartDrawerDiscounts === "function") {
        window.applyCartDrawerDiscounts(
          "product-discount-price.js:9250 cart-drawer:open line 8776"
        );
      }
      if (
        typeof window.recomputeDrawerSubtotalFromDOM === "function" &&
        !isCartPage
      ) {
        window.recomputeDrawerSubtotalFromDOM(
          "product-discount-price.js:9253 cart-drawer:refresh line 9254"
        );
      }
    }, 500);
  });

  if (typeof window.handleDiscountButtonClick !== "function") {
    console.error(
      "[BUTTON] handleDiscountButtonClick is NOT available on window!"
    );
  }

  function getActiveDiscountCodeFromDOM() {
    console.log("product-discount-price.js: getActiveDiscountCodeFromDOM");

    if (hasUserRemovedDiscountGlobal()) {
      return "";
    }

    try {
      var variantDiscounts = {};
      try {
        variantDiscounts = JSON.parse(
          localStorage.getItem("variantDiscounts") || "{}"
        );
      } catch (e) {
        console.error("[CHK] Error parsing variantDiscounts:", e);
        return "";
      }

      if (Object.keys(variantDiscounts).length === 0) {
        return "";
      }

      var cartItems = [];
      try {
        var cartRows = document.querySelectorAll('tr[id^="CartItem-"]');
        if (cartRows.length > 0) {
          cartRows.forEach(function (row) {
            var key = row.getAttribute("data-product-id") || "";
            var match = key.match(/^(\d+)/);
            if (match) {
              var variantId = match[1];
              var discountData = variantDiscounts[variantId];
              if (discountData && discountData.title) {
                var title = discountData.title.trim();
                if (title && /^[A-Za-z0-9-_]+$/.test(title)) {
                  cartItems.push({ variantId: variantId, discount: title });
                }
              }
            }
          });
        }
      } catch (e) {
        console.error("[CHK] Error getting cart items:", e);
      }

      if (cartItems.length === 0) {
        try {
          var drawerItems = document.querySelectorAll(".mini-cart__line-item");
          if (drawerItems.length > 0) {
            drawerItems.forEach(function (item) {
              var variantId = item.getAttribute("data-variant-id");
              if (!variantId) {
                var button = item.querySelector(".remove[data-id]");
                if (button) {
                  variantId = button.getAttribute("data-id");
                }
              }
              if (variantId) {
                var discountData = variantDiscounts[variantId];
                if (discountData && discountData.title) {
                  var title = discountData.title.trim();
                  if (title && /^[A-Za-z0-9-_]+$/.test(title)) {
                    cartItems.push({ variantId: variantId, discount: title });
                  }
                }
              }
            });
          }
        } catch (e) {
          console.error("[CHK] Error getting drawer items:", e);
        }
      }

      if (cartItems.length > 0) {
        var discountCounts = {};
        cartItems.forEach(function (item) {
          var discount = item.discount;
          if (!discountCounts[discount]) {
            discountCounts[discount] = 0;
          }
          discountCounts[discount]++;
        });

        var mostCommonDiscount = null;
        var maxCount = 0;
        for (var discount in discountCounts) {
          if (discountCounts[discount] > maxCount) {
            maxCount = discountCounts[discount];
            mostCommonDiscount = discount;
          }
        }

        if (mostCommonDiscount) {
          return mostCommonDiscount;
        }

        return cartItems[0].discount;
      }

      var sel = [
        "#applied-discount-cart-page span:last-child",
        "#applied-discount-cart-drawer span:last-child",
        ".custom-discount-pill span:last-child",
        ".discounts__discount",
      ];
      for (var i = 0; i < sel.length; i++) {
        var el = document.querySelector(sel[i]);
        if (el && el.textContent) {
          var text = el.textContent.trim();
          var codeMatch = text.match(/^([A-Za-z0-9-_]+)/);
          if (codeMatch) {
            var code = codeMatch[1];
            if (code && /^[A-Za-z0-9-_]+$/.test(code)) {
              return code;
            }
          }
        }
      }
    } catch (e) {
      console.error("[CHK] code parse error", e);
    }
    return "";
  }

  function getCheckoutURL(code) {
    console.log("product-discount-price.js: getCheckoutURL");
    try {
      var url = "/checkout";
      var discountCode = code || "";

      try {
        var lockedPreference = localStorage.getItem(
          "cartLockedDiscountPreference"
        );

        if (lockedPreference) {
          var lockedButtonNumber = parseInt(lockedPreference, 10);
          var buttonMapping = window.getButtonDiscountMapping();

          if (buttonMapping) {
            var discountTitle = null;
            if (lockedButtonNumber === 1 && buttonMapping.button1) {
              discountTitle = buttonMapping.button1;
            } else if (lockedButtonNumber === 2 && buttonMapping.button2) {
              discountTitle = buttonMapping.button2;
            }

            if (discountTitle && discountTitle.trim() !== "") {
              discountCode = discountTitle.trim();
            }
          }
        }
      } catch (e) {
        console.error("[CHK] Error checking locked preference:", e);
      }

      if (!discountCode || discountCode.trim() === "") {
        return url;
      }

      url = "/checkout?discount=" + encodeURIComponent(discountCode.trim());

      return url;
    } catch (e) {
      console.error("[CHK] URL generation error", e);
      return "/checkout";
    }
  }

  function performCheckoutRedirect(code) {
    console.log("product-discount-price.js: performCheckoutRedirect");
    try {
      var url = getCheckoutURL(code);
      window.location.href = url;
      return true;
    } catch (e) {
      console.error("[CHK] Redirect error", e);
      return false;
    }
  }

  function setupCheckoutDiscountRedirects(debugMessage) {
    console.log(
      "product-discount-price.js: setupCheckoutDiscountRedirects: " +
        debugMessage
    );

    try {
      if (!document.documentElement.dataset.chkDelegationBound) {
        document.documentElement.dataset.chkDelegationBound = "true";
        document.addEventListener(
          "click",
          function (e) {
            try {
              var target = e.target;
              var checkoutBtn = target.closest(
                'button[name="checkout"], a[href*="/checkout"]'
              );

              if (checkoutBtn) {
                var isDrawerBtn = checkoutBtn.closest("form#mini-cart");
                var isCartBtn = checkoutBtn.closest("form.cart-recap");

                if (
                  !isCartBtn &&
                  checkoutBtn.getAttribute("form") === "cart-recap"
                ) {
                  isCartBtn = true;
                }

                if (isDrawerBtn || isCartBtn) {
                  e.preventDefault();
                  e.stopPropagation();
                  e.stopImmediatePropagation();

                  var code = getActiveDiscountCodeFromDOM();
                  if (code && code.trim() !== "") {
                    performCheckoutRedirect(code);
                  } else {
                    performCheckoutRedirect("");
                  }
                  return false;
                }
              }
            } catch (err) {
              console.error("[CHK] delegation click handler error", err);
            }
          },
          true
        );
      }

      if (!document.documentElement.dataset.chkFormDelegationBound) {
        document.documentElement.dataset.chkFormDelegationBound = "true";
        document.addEventListener(
          "submit",
          function (e) {
            try {
              var form = e.target;
              if (form && form.tagName === "FORM") {
                var isDrawerForm = form.closest("form#mini-cart");
                var isCartForm = form.classList.contains("cart-recap");

                var hasCheckoutBtn = form.querySelector(
                  'button[name="checkout"]'
                );

                if ((isDrawerForm || isCartForm) && hasCheckoutBtn) {
                  var code = getActiveDiscountCodeFromDOM();
                  if (performCheckoutRedirect(code || "")) {
                    e.preventDefault();
                    e.stopPropagation();
                    e.stopImmediatePropagation();
                    return false;
                  }
                }
              }
            } catch (err) {
              console.error("[CHK] delegation form submit handler error", err);
            }
          },
          true
        );
      }

      var cartCheckoutBtn = document.querySelector(
        "form.cart-recap button.cart-recap__checkout"
      );
      if (cartCheckoutBtn && !cartCheckoutBtn.dataset.chkBound) {
        cartCheckoutBtn.dataset.chkBound = "true";
        cartCheckoutBtn.type = "button";
        cartCheckoutBtn.addEventListener("click", function (e) {
          try {
            e.preventDefault();
            e.stopPropagation();
            e.stopImmediatePropagation();

            var code = getActiveDiscountCodeFromDOM();
            performCheckoutRedirect(code || "");
            return false;
          } catch (err) {
            console.error("[CHK] Cart checkout button handler error", err);
          }
        });
      }

      var drawerCheckoutBtn = document.querySelector(
        "form#mini-cart .mini-cart__button-container .button-group button.button.button--primary"
      );
      if (drawerCheckoutBtn && !drawerCheckoutBtn.dataset.chkBound) {
        drawerCheckoutBtn.dataset.chkBound = "true";
        if (drawerCheckoutBtn.tagName === "BUTTON") {
          drawerCheckoutBtn.type = "button";
        }
        drawerCheckoutBtn.addEventListener("click", function (e) {
          try {
            e.preventDefault();
            e.stopPropagation();
            e.stopImmediatePropagation();

            var code = getActiveDiscountCodeFromDOM();
            performCheckoutRedirect(code || "");
            return false;
          } catch (err) {
            console.error("[CHK] Drawer checkout button handler error", err);
          }
        });
      }
    } catch (e) {
      console.error("[CHK] setup error", e);
    }
  }

  function recomputeCartPageSubtotalFromDOM(debugMessage) {
    if (!isCartPage) {
      return;
    }

    console.log(
      "product-discount-price.js: recomputeCartPageSubtotalFromDOM: " +
        debugMessage
    );
    try {
      var row = document.querySelector(".cart-recap__scroller");
      if (!row) {
        return;
      }
      var totalPriceLine = document.querySelector(
        ".cart-recap__price-line:not(.cart-recap__price-line--highlight) .cart-recap__price-line-price"
      );

      var amountWrap =
        totalPriceLine ||
        document.querySelector(".cart-recap__price-line-price");
      if (!amountWrap) {
        return;
      }

      var userRemovedDiscount = hasUserRemovedDiscountGlobal();
      if (!userRemovedDiscount) {
        try {
          if (typeof window.hasNoDiscountPreference === "function") {
            userRemovedDiscount = window.hasNoDiscountPreference();
          } else {
            userRemovedDiscount =
              localStorage.getItem("activeDiscountTitle") === "__no_discount__";
          }
        } catch (e) {
          try {
            userRemovedDiscount =
              localStorage.getItem("activeDiscountTitle") === "__no_discount__";
          } catch (e2) {
            userRemovedDiscount = false;
          }
        }
      }

      var dataOriginalTotal = row.getAttribute("data-original-total");

      if (userRemovedDiscount) {
        var originalSubtotalCents = 0;
        if (dataOriginalTotal) {
          originalSubtotalCents = parseInt(dataOriginalTotal);
        } else {
          var cartRows = document.querySelectorAll('tr[id^="CartItem-"]');
          cartRows.forEach(function (cartRow) {
            try {
              var unitPriceList = cartRow.querySelector(
                ".line-item__price-list"
              );
              var priceSpan = unitPriceList
                ? unitPriceList.querySelector(".line-item__price")
                : null;
              if (priceSpan) {
                if (priceSpan) {
                  var originalText = priceSpan.textContent.trim();
                  var priceCents = window.parseMoneyTextToCents(originalText);
                  if (priceCents > 0) {
                    var qtyInput =
                      cartRow.querySelector('input[name="updates[]"]') ||
                      cartRow.querySelector(".quantity-selector__value");
                    var quantity = 1;
                    if (qtyInput) {
                      quantity =
                        parseInt(
                          qtyInput.value ||
                            qtyInput.getAttribute("data-current-value") ||
                            "1",
                          10
                        ) || 1;
                    }
                    originalSubtotalCents += priceCents * quantity;
                  }
                }
              }
            } catch (e) {}
          });
        }

        if (originalSubtotalCents > 0) {
          var fBase = window.formatMoneyDrawer(originalSubtotalCents);
          var totalPriceLine = document.querySelector(
            ".cart-recap__price-line:not(.cart-recap__price-line--highlight) .cart-recap__price-line-price"
          );
          var totalPriceElement =
            totalPriceLine ||
            document.querySelector(".cart-recap__price-line-price");
          if (totalPriceElement) {
            totalPriceElement.textContent = fBase;
          } else if (amountWrap) {
            while (amountWrap.firstChild) {
              amountWrap.removeChild(amountWrap.firstChild);
            }
            var amountSpan = document.createElement("span");
            amountSpan.className = "amount";
            amountSpan.textContent = fBase;
            amountWrap.appendChild(amountSpan);
          }
          row.setAttribute(
            "data-original-total",
            String(originalSubtotalCents)
          );
          row.setAttribute("data-final-total", String(originalSubtotalCents));
          setTimeout(function () {
            var hasNoDiscount = false;
            if (typeof window.hasNoDiscountPreference === "function") {
              hasNoDiscount = window.hasNoDiscountPreference();
            } else {
              try {
                hasNoDiscount =
                  localStorage.getItem("activeDiscountTitle") ===
                  "__no_discount__";
              } catch (e) {
                hasNoDiscount = false;
              }
            }
            if (hasNoDiscount) {
              var recheckRow = document.querySelector(
                "tr.line-item__line-price"
              );
              if (recheckRow) {
                var recheckWrap = recheckRow.querySelector("span");
                if (recheckWrap) {
                  var recheckOriginalCents = 0;
                  if (dataOriginalTotal) {
                    recheckOriginalCents = parseInt(dataOriginalTotal);
                  } else {
                    var recheckText = recheckWrap.textContent.trim();
                    recheckOriginalCents =
                      window.parseMoneyTextToCents(recheckText);
                    if (recheckOriginalCents > 0) {
                      var recheckFBase =
                        window.formatMoneyDrawer(recheckOriginalCents);
                      recheckWrap.textContent = recheckFBase;
                    }
                  }
                }
              }
            }
          }, 200);
          return;
        } else {
          return;
        }
      }
      var userRemovedDiscountCheck = false;
      if (typeof window.hasNoDiscountPreference === "function") {
        userRemovedDiscountCheck = window.hasNoDiscountPreference();
      } else {
        try {
          userRemovedDiscountCheck =
            localStorage.getItem("activeDiscountTitle") === "__no_discount__";
        } catch (e) {
          userRemovedDiscountCheck = false;
        }
      }
      if (userRemovedDiscountCheck) {
        return;
      }
      var cartRows = document.querySelectorAll('tr[id^="CartItem-"]');
      var base = 0;
      var totalDiscount = 0;
      cartRows.forEach(function (cartRow) {
        try {
          var qtyInput = cartRow.querySelector(".quantity-selector__value");
          var quantity = 1;
          if (qtyInput) {
            var qtyValue =
              qtyInput.value ||
              qtyInput.getAttribute("data-current-value") ||
              "1";
            quantity = parseInt(qtyValue, 10) || 1;
          }

          var subtotalCell = cartRow.querySelector(".line-item__line-price");
          if (!subtotalCell) return;
          var subtotalPriceSpan = subtotalCell.querySelector("span");
          var dataSubtotal = subtotalCell.getAttribute("data-subtotal");
          var originalLinePrice = 0;
          var finalLinePrice = 0;
          if (dataSubtotal) {
            finalLinePrice = window.parseMoneyTextToCents(dataSubtotal);
          }
          if (subtotalPriceSpan) {
            var originalPriceEl =
              subtotalPriceSpan.querySelector(".price-original");
            var discountedPriceEl =
              subtotalPriceSpan.querySelector(".price-discounted");

            if (originalPriceEl && discountedPriceEl) {
              var originalPriceText = originalPriceEl.textContent.trim();
              originalLinePrice =
                window.parseMoneyTextToCents(originalPriceText);

              var discountedPriceText = discountedPriceEl.textContent.trim();
              finalLinePrice =
                window.parseMoneyTextToCents(discountedPriceText);

              if (originalLinePrice > 0) {
                base += originalLinePrice;
              }
              if (finalLinePrice > 0 && originalLinePrice > finalLinePrice) {
                var rowDiscount = originalLinePrice - finalLinePrice;
                if (rowDiscount > 0) {
                  totalDiscount += rowDiscount;
                }
              }
            } else {
              var priceText = subtotalPriceSpan.textContent.trim();
              originalLinePrice = window.parseMoneyTextToCents(priceText);
              if (originalLinePrice > 0) {
                base += originalLinePrice;
                finalLinePrice = originalLinePrice;
              }
            }
          } else if (dataSubtotal) {
            var key = cartRow.getAttribute("data-product-id") || "";
            var match = key.match(/^(\d+)/);
            if (match) {
              var variantId = match[1];
              var discountData =
                typeof window.getVariantDiscountData === "function"
                  ? window.getVariantDiscountData(variantId)
                  : null;
              if (discountData && discountData.percentage) {
                if (!qtyInput) {
                  qtyInput =
                    cartRow.querySelector('input[name="updates[]"]') ||
                    cartRow.querySelector(".quantity-selector__value");
                  quantity = 1;
                  if (qtyInput) {
                    quantity =
                      parseInt(
                        qtyInput.value ||
                          qtyInput.getAttribute("data-current-value") ||
                          "1",
                        10
                      ) || 1;
                  }
                }
                var unitPriceList = cartRow.querySelector(
                  ".line-item__price-list"
                );
                var unitPriceSpan = unitPriceList
                  ? unitPriceList.querySelector(".line-item__price")
                  : null;
                if (unitPriceSpan) {
                  var unitOriginalEl =
                    unitPriceSpan.querySelector(".price-original");
                  var unitDiscountedEl =
                    unitPriceSpan.querySelector(".price-discounted");

                  if (unitOriginalEl && unitDiscountedEl) {
                    var unitOriginalCents = window.parseMoneyTextToCents(
                      unitOriginalEl.textContent.trim()
                    );
                    var unitDiscountedCents = window.parseMoneyTextToCents(
                      unitDiscountedEl.textContent.trim()
                    );
                    if (unitOriginalCents > 0) {
                      var lineOriginal = unitOriginalCents * quantity;
                      base += lineOriginal;
                      if (unitDiscountedCents > 0) {
                        var lineFinal = unitDiscountedCents * quantity;
                        var lineDiscount = lineOriginal - lineFinal;
                        if (lineDiscount > 0) {
                          totalDiscount += lineDiscount;
                        }
                      } else {
                        var lineDiscount = Math.round(
                          lineOriginal * (discountData.percentage / 100)
                        );
                        totalDiscount += lineDiscount;
                      }
                    }
                  } else {
                    var unitPriceCents = window.parseMoneyTextToCents(
                      unitPriceSpan.textContent.trim()
                    );
                    if (unitPriceCents > 0) {
                      var lineOriginal = unitPriceCents * quantity;
                      base += lineOriginal;
                      var lineDiscount = Math.round(
                        lineOriginal * (discountData.percentage / 100)
                      );
                      totalDiscount += lineDiscount;
                    }
                  }
                }
              } else {
                base += finalLinePrice;
              }
            } else {
              base += finalLinePrice;
            }
          }
        } catch (e) {
          console.error("[CART] Error processing cart row:", e);
        }
      });
      if (base === 0) {
        var origAttr = parseInt(row.getAttribute("data-original-total") || "0");
        if (origAttr && origAttr > 0) {
          base = origAttr;
        } else {
          var totalPriceLine = document.querySelector(
            ".cart-recap__price-line:not(.cart-recap__price-line--highlight) .cart-recap__price-line-price"
          );
          var totalPriceElement =
            totalPriceLine ||
            document.querySelector(".cart-recap__price-line-price");
          if (totalPriceElement) {
            var txt = totalPriceElement.textContent.trim();
            base = window.parseMoneyTextToCents(txt);
          } else {
            var amountWrap = row.querySelector(".price .amount, .price");
            if (amountWrap) {
              var txt = amountWrap.textContent.trim();
              base = window.parseMoneyTextToCents(txt);
            }
          }
        }
      }
      if (!base) return;

      if (totalDiscount === 0) {
        var shopifyPillElements = document.querySelectorAll(
          ".discounts__discount:not(#applied-discount-cart-page)"
        );
        var useShopifyPills = shopifyPillElements.length > 0;
        var jsPills = document.querySelectorAll("#applied-discount-cart-page");
        if (useShopifyPills && jsPills.length > 0) {
          jsPills.forEach(function (jsPill) {
            jsPill.style.display = "none";
          });
        }
        var nodes = useShopifyPills
          ? Array.from(shopifyPillElements)
          : document.querySelectorAll(
              "#applied-discount-cart-page span:last-child"
            );
        nodes.forEach(function (node) {
          try {
            var t = node.textContent || "";

            var currencyCode = (window.shop_currency || "CHF").replace(
              /[.*+?^${}()|[\]\\]/g,
              "\\$&"
            );
            var m = t.match(
              new RegExp(
                "[\\-\\u2013]\\s*" + currencyCode + "\\s*([\\d'.,]+)",
                "i"
              )
            );
            if (m) {
              var cents = Math.round(
                parseFloat(m[1].replace(/[']/g, "").replace(/,/g, "")) * 100
              );
              if (cents > 0) {
                totalDiscount += cents;
              }
            }
          } catch (e) {}
        });
      }

      var finalCents = Math.max(0, base - totalDiscount);
      try {
        row.setAttribute("data-original-total", String(base));
        row.setAttribute("data-final-total", String(finalCents));
      } catch (e) {}
      var fBase = window.formatMoneyDrawer(base);
      var fFinal = window.formatMoneyDrawer(finalCents);

      var totalPriceLine = document.querySelector(
        ".cart-recap__price-line:not(.cart-recap__price-line--highlight) .cart-recap__price-line-price"
      );

      var amountWrap =
        totalPriceLine ||
        document.querySelector(".cart-recap__price-line-price");
      if (!amountWrap) {
        return;
      }

      if (amountWrap) {
        var newHtml =
          totalDiscount > 0
            ? '<span class="price-original">' +
              fBase +
              '</span> <span class="price-discounted">' +
              fFinal +
              "</span>"
            : fBase;
        if (totalDiscount > 0) {
          amountWrap.innerHTML = newHtml;
        } else {
          amountWrap.textContent = newHtml;
        }
      }
    } catch (e) {
      console.error("Error getting active discount code:", e);
    }
  }

  function recomputeDrawerSubtotalFromDOM(debugMessage) {
    if (isCartPage) {
      return;
    }
    console.log(
      "product-discount-price.js: recomputeDrawerSubtotalFromDOM: " +
        debugMessage
    );
    try {
      var totalPriceLine = document.querySelector(
        ".mini-cart__recap-price-line:not(.mini-cart__recap-price-line--highlight)"
      );
      if (!totalPriceLine) {
        return;
      }
      var amountWrap = totalPriceLine.querySelector("span:last-child");
      var drawerTotals = { original: 0, discounted: 0 };
      var cartItems = document.querySelectorAll(".mini-cart__line-item");
      cartItems.forEach(function (item, index) {
        try {
          var originalLinePrice = item.getAttribute("data-original-line-price");
          var finalLinePrice = item.getAttribute("data-final-line-price");
          var discountedSubtotal = item.getAttribute(
            "data-discounted-subtotal"
          );

          if (originalLinePrice) {
            var oCents = parseInt(originalLinePrice) || 0;
            var fCents = discountedSubtotal
              ? parseInt(discountedSubtotal) || 0
              : parseInt(finalLinePrice) || oCents;

            if (oCents > 0) {
              drawerTotals.original += oCents;
              drawerTotals.discounted += fCents > 0 ? fCents : oCents;
            }
          }
        } catch (e) {
          console.error("[DRAWER] Error calculating item total:", e);
        }
      });
      var baseSubtotal = drawerTotals.original;
      var finalSubtotal = drawerTotals.discounted;
      var totalDiscount = baseSubtotal - finalSubtotal;

      try {
        var fBase = window.formatMoneyDrawer(baseSubtotal);
        var fFinal = window.formatMoneyDrawer(finalSubtotal);
        try {
          if (!amountWrap) {
            return;
          }
          var currentContent =
            amountWrap.innerHTML || amountWrap.textContent || "";
          var newContent =
            totalDiscount > 0
              ? '<span class="price-original">' +
                fBase +
                '</span> <span class="price-discounted">' +
                fFinal +
                "</span>"
              : fBase;
          if (currentContent !== newContent) {
            totalPriceLine.setAttribute(
              "data-final-total",
              String(finalSubtotal)
            );
            totalPriceLine.setAttribute(
              "data-original-total",
              String(baseSubtotal)
            );
            if (totalDiscount > 0) {
              amountWrap.innerHTML = newContent;
            } else {
              amountWrap.textContent = newContent;
            }
          }
        } catch (e) {
          console.error("[DRAWER] Error updating total:", e);
        }
      } catch (err) {}
    } catch (e) {}
  }
})();
